import * as STD                            from '@emersya/mpa-std-lib';
import CM                                  from '@emersya/mpa-components-manager-lib';
import ViewerComponent, { NS as ViewerNS } from '../../../viewer/Viewer/Viewer';
import { NS as StandingPartitionsHeadsNS } from '../StandingPartitionsHeads/StandingPartitionsHeads';
import { NS as StandingStorageNS }         from '../StandingStorage/StandingStorage';

export interface IStandingPlinthComponentConfiguration extends CM.Component.IConfiguration {
	// To not duplicate many property of the app configuration, and because this component is unique, retrieve conf directly from app and lets this interface be empty.
};

export class StandingPlinthComponent extends CM.Component<
	StandingPlinthComponent,
	IStandingPlinthComponentConfiguration
>
{
	static override initialize() {
		super.initialize();
	};

	readonly plannerCategory! : ViewerComponent.ProductCategory;
	viewerNode : ViewerComponent.ProductInstance | null = null;

	getWDH() {
		const p = app.currentProduct;
		if (!p) {
			this.component_throwUserError('');
		}
		const dpart = p.getPart([ 'dimensions' ]);
		return {
			width :  Number.parseFloat(dpart.getPart([ 'width' ])?.reference?.value || <string> <any> 1),
			depth :  Number.parseFloat(dpart.getPart([ 'depth' ])?.reference?.value || <string> <any> 1),
			height : Number.parseFloat(dpart.getPart([ 'height' ])?.reference?.value || <string> <any> 1)
		};
	};

	getWallThickness() {
		// TODO : DEHARDCODE
		return 0.05;
	}

	private computeMatrix(side : string) {
		const wdh = this.getWDH();
		const x = wdh.width;
		const y = wdh.height;
		const z = wdh.depth;
		void x;
		void y;
		void z;
		const product = app.currentProduct;
		if (!product) {
			throw STD.errors.user('No current product available!');
		}
		const leftPlinth = product.id === 'confort' || product.id === 'prestige' ?
			app.component_configuration.productsComponents.find(x => x.type === 'plinth' && x.SKU === 'plinth_LEDLeft') :
			app.component_configuration.productsComponents.find(x => x.type === 'plinth' && x.SKU === 'plinth_Left');
		const middlePlinth = product.id === 'confort' || product.id === 'prestige' ?
			app.component_configuration.productsComponents.find(x => x.type === 'plinth' && x.SKU === 'plinth_LEDMiddle') :
			app.component_configuration.productsComponents.find(x => x.type === 'plinth' && x.SKU === 'plinth_Middle');
		const rightPlinth = product.id === 'confort' || product.id === 'prestige' ?
			app.component_configuration.productsComponents.find(x => x.type === 'plinth' && x.SKU === 'plinth_LEDRight') :
			app.component_configuration.productsComponents.find(x => x.type === 'plinth' && x.SKU === 'plinth_Right');
		const cornerPlinth = product.id === 'confort' || product.id === 'prestige' ?
			app.component_configuration.productsComponents.find(x => x.type === 'plinth' && x.SKU === 'plinth_LEDCorner') :
			app.component_configuration.productsComponents.find(x => x.type === 'plinth' && x.SKU === 'plinth_Corner');
		if (!leftPlinth || !middlePlinth || !rightPlinth || !cornerPlinth) {
			throw STD.errors.user('One of the plinth not found');
		}

		const boundingBoxLeft = leftPlinth.boundingBox;
		const boundingBoxMiddle = middlePlinth.boundingBox;
		const boundingBoxRight = rightPlinth.boundingBox;
		const boundingBoxCorner = cornerPlinth.boundingBox;
		const partitionsHeads = app.modules.used.find(x => x.id === 'standing-partitionsHeads');
		if (!partitionsHeads) {
			throw STD.errors.user('Partitions Heads not instanciate before plinth');
		}
		const partitionHeadsComponent = <StandingPartitionsHeadsNS.Component> partitionsHeads.component;
		if (!partitionHeadsComponent) {
			throw STD.errors.user('Partitions Heads doesnt have component');
		}
		let boundingBoxPartitions = partitionHeadsComponent.partitionsWidth;
		if (!boundingBoxPartitions) {
			if (!partitionHeadsComponent.isPartitionsHeads) {
				boundingBoxPartitions = 0;
			} else {
				throw STD.errors.user('Missing bounding box for partitionsHeads');
			}
		}
		const partitionHeadsPosition = partitionHeadsComponent.partitionsPosition;
		// const partitionsHeadsSpace = partitionHeadsComponent.partitionsSpace;
		if (!boundingBoxLeft || !boundingBoxMiddle || !boundingBoxRight || !boundingBoxCorner) {
			throw STD.errors.user('Missing bounding box for plinth');
		}
		if (!partitionHeadsComponent.isPartitionsHeads) {
			boundingBoxPartitions = 0;
		}
		const layoutPart = product.getPart([ 'layout' ]);
		if (!layoutPart) {
			throw STD.errors.user('No part layout available');
		}
		const layoutCurrentOption = layoutPart.currentOption;
		if (!layoutCurrentOption) {
			throw STD.errors.user('No current option in layout part');
		}
		const layoutId = layoutCurrentOption.id;
		const storage = app.modules.used.find(x => x.id === 'standing-storage');
		if (storage) {
			const storageComponent = <StandingStorageNS.Component> storage.component;
			if (!storageComponent) {
				throw STD.errors.user('Storage doesnt have component');
			}
			if (storageComponent.hasStorage()) {
				const surface = x * z;
				if (product.id === 'prestige') {
					if (surface > 24) {
						const storage3x1Classic = app.component_configuration.productsComponents.find(x => x.type ===
							'storage' &&
							x.SKU ===
							'storage3x1Classic');
						if (!storage3x1Classic) {
							throw STD.errors.user('No storage 3x1 Classic found in plinth');
						}
						const boundingBox3x1Classic = storage3x1Classic.boundingBox;
						if (!boundingBox3x1Classic) {
							throw STD.errors.user('Missing bounding box for storage in plinth');
						}
						const storage3x1CornerLeft = app.component_configuration.productsComponents.find(x => x.type ===
							'storage' &&
							x.SKU ===
							'storage3x1CornerLeft');
						if (!storage3x1CornerLeft) {
							throw STD.errors.user('No storage 3x1 Classic found in plinth');
						}
						const boundingBox3x1CornerLeft = storage3x1CornerLeft.boundingBox;
						if (!boundingBox3x1CornerLeft) {
							throw STD.errors.user('Missing bounding box for storage in plinth');
						}
						const storage3x1CornerRight = app.component_configuration.productsComponents.find(x => x.type ===
							'storage' &&
							x.SKU ===
							'storage3x1CornerRight');
						if (!storage3x1CornerRight) {
							throw STD.errors.user('No storage 3x1 Classic found in plinth');
						}
						const boundingBox3x1CornerRight = storage3x1CornerRight.boundingBox;
						if (!boundingBox3x1CornerRight) {
							throw STD.errors.user('Missing bounding box for storage in plinth');
						}
						if (layoutId === 'shape-no-wall') {
							return (ViewerNS.Component.mtx([ 1, 1, 1 ], [ 0, 0, 0 ], 0));
						} else if (layoutId === 'shape-back-left') {
							if (side === 'left') {
								return (ViewerNS.Component.mtx([ -(x / 2), 0, z / 2 ], [ 1, 1, 1 ], 90));
							} else if (side === 'back') {
								return (ViewerNS.Component.mtx([ -(x / 2), 0, -z / 2 ], [ 1, 1, 1 ], 0));
							} else if (side === 'left-leftPlinth') {
								if (z >= 4.5) {
									return (ViewerNS.Component.mtx([ 0, 0, 0 ], [ z / 3, 1, 1 ], 0));
								} else if (z > 3) {
									return (ViewerNS.Component.mtx([ 0, 0, 0 ], [ z - 3, 1, 1 ], 0));
								} else {
									return (ViewerNS.Component.mtx([ 1, 1, 1 ], [ 0, 0, 0 ], 0));
								}
							} else if (side === 'left-middlePlinth') {
								if (z > 4.5) {
									return (ViewerNS.Component.mtx([ z / 3, 0, 0 ], [ (2 * z / 3) - 3, 1, 1 ], 0));
								} else {
									return (ViewerNS.Component.mtx([ 1, 1, 1 ], [ 0, 0, 0 ], 0));
								}
							} else if (side === 'back-middlePlinth') {
								return (ViewerNS.Component.mtx(
									[ boundingBox3x1CornerRight.width, 0, 0 ],
									[ 2 * x / 3 - boundingBox3x1CornerRight.width, 1, 1 ],
									0
								));
							} else if (side === 'back-rightPlinthClosed') {
								return (ViewerNS.Component.mtx([ 2 * x / 3, 0, 0 ], [ x / 3, 1, 1 ], 0));
							} else {
								return (ViewerNS.Component.mtx([ 1, 1, 1 ], [ 0, 0, 0 ], 0));
							}
						} else if (layoutId === 'shape-back') {
							if (side === 'back') {
								return (ViewerNS.Component.mtx([ -(x / 2), 0, -z / 2 ], [ 1, 1, 1 ], 0));
							} else if (side === 'back-middlePlinth') {
								return (ViewerNS.Component.mtx(
									[ boundingBox3x1Classic.width, 0, 0 ],
									[ 2 * x / 3 - boundingBox3x1Classic.width, 1, 1 ],
									0
								));
							} else if (side === 'back-rightPlinthClosed') {
								return (ViewerNS.Component.mtx([ 2 * x / 3, 0, 0 ], [ x / 3, 1, 1 ], 0));
							} else {
								return (ViewerNS.Component.mtx([ 1, 1, 1 ], [ 0, 0, 0 ], 0));
							}
						} else if (layoutId === 'shape-back-right') {
							if (side === 'right') {
								return (ViewerNS.Component.mtx([ (x / 2), 0, -z / 2 ], [ 1, 1, 1 ], 270));
							} else if (side === 'back') {
								return (ViewerNS.Component.mtx([ -(x / 2), 0, -z / 2 ], [ 1, 1, 1 ], 0));
							} else if (side === 'right-middlePlinth') {
								if (z > 4.5) {
									return (ViewerNS.Component.mtx([ 3, 0, 0 ], [ 2 * z / 3 - 3, 1, 1 ], 0));
								} else {
									return (ViewerNS.Component.mtx([ 1, 1, 1 ], [ 0, 0, 0 ], 0));
								}
							} else if (side === 'right-rightPlinth') {
								if (z >= 4.5) {
									return (ViewerNS.Component.mtx([ 2 * z / 3, 0, 0 ], [ z / 3, 1, 1 ], 0));
								} else if (z > 3) {
									return (ViewerNS.Component.mtx([ 3, 0, 0 ], [ z - 3, 1, 1 ], 0));
								} else {
									return (ViewerNS.Component.mtx([ 1, 1, 1 ], [ 0, 0, 0 ], 0));
								}
							} else if (side === 'back-leftPlinthClosed') {
								return (ViewerNS.Component.mtx([ 0, 0, 0 ], [ x / 3, 1, 1 ], 0));
							} else if (side === 'back-middlePlinth') {
								return (ViewerNS.Component.mtx([ x / 3, 0, 0 ], [ 2 * x / 3 - boundingBox3x1CornerRight.width, 1, 1 ], 0));
							} else {
								return (ViewerNS.Component.mtx([ 1, 1, 1 ], [ 0, 0, 0 ], 0));
							}
						} else if (layoutId === 'shape-left-back-right') {
							const archPrestigeSpecial = app.component_configuration.productsComponents.find(x => x.type ===
								'arch' &&
								x.SKU ===
								'arch-prestige-special');
							if (!archPrestigeSpecial) {
								throw STD.errors.user('No arch prestige special found in plinth');
							}
							const boundingBoxArchPrestigeSpecial = archPrestigeSpecial.boundingBox;
							if (!boundingBoxArchPrestigeSpecial) {
								throw STD.errors.user('Missing bounding box for special arch prestige in plinth');
							}
							if (side === 'left') {
								return (ViewerNS.Component.mtx([ -(x / 2), 0, z / 2 ], [ 1, 1, 1 ], 90));
							} else if (side === 'back') {
								return (ViewerNS.Component.mtx([ -(x / 2), 0, -z / 2 ], [ 1, 1, 1 ], 0));
							} else if (side === 'right') {
								return (ViewerNS.Component.mtx([ (x / 2), 0, -z / 2 ], [ 1, 1, 1 ], 270));
							} else if (side === 'left-leftPlinth') {
								return (ViewerNS.Component.mtx([ 0, 0, 0 ], [ z / 3, 1, 1 ], 0));
							} else if (side === 'left-middlePlinth') {
								return (ViewerNS.Component.mtx([ z / 3, 0, 0 ], [ z / 3, 1, 1 ], 0));
							} else if (side === 'left-rightPlinth') {
								return (ViewerNS.Component.mtx([ 2 * z / 3, 0, 0 ], [ z / 3 - boundingBoxCorner.depth, 1, 1 ], 0));
							} else if (side === 'back-cornerLeftPlinth') {
								return (ViewerNS.Component.mtx([ 0, 0, 0 ], [ 1, 1, 1 ], 0));
							} else if (side === 'back-leftPlinthOpened') {
								return (ViewerNS.Component.mtx(
									[ boundingBoxCorner.width, 0, 0 ],
									[ boundingBoxArchPrestigeSpecial.width - boundingBoxCorner.width, 1, 1 ],
									0
								));
							} else if (side === 'back-rightPlinthOpened') {
								return (ViewerNS.Component.mtx(
									[ boundingBox3x1Classic.width + boundingBoxArchPrestigeSpecial.width, 0, 0 ],
									[
										x - boundingBox3x1Classic.width - boundingBoxArchPrestigeSpecial.width - boundingBoxCorner.depth,
										1,
										1
									],
									0
								));
							} else if (side === 'back-cornerRightPlinth') {
								return (ViewerNS.Component.mtx([ x, 0, 0 ], [ 1, 1, 1 ], 270));
							} else if (side === 'right-leftPlinth') {
								return (ViewerNS.Component.mtx(
									[ boundingBoxCorner.width, 0, 0 ],
									[ z / 3 - boundingBoxCorner.width, 1, 1 ],
									0
								));
							} else if (side === 'right-middlePlinth') {
								return (ViewerNS.Component.mtx([ z / 3, 0, 0 ], [ z / 3, 1, 1 ], 0));
							} else if (side === 'right-rightPlinth') {
								return (ViewerNS.Component.mtx([ 2 * z / 3, 0, 0 ], [ z / 3, 1, 1 ], 0));
							} else {
								return (ViewerNS.Component.mtx([ 1, 1, 1 ], [ 0, 0, 0 ], 0));
							}
						} else {
							throw STD.errors.user('Unknown layoutId in plinth');
						}
					} else if (surface > 17) {
						const storage2x1Classic = app.component_configuration.productsComponents.find(x => x.type ===
							'storage' &&
							x.SKU ===
							'storage2x1Classic');
						if (!storage2x1Classic) {
							throw STD.errors.user('No storage 2x1 Classic found in plinth');
						}
						const boundingBox2x1Classic = storage2x1Classic.boundingBox;
						if (!boundingBox2x1Classic) {
							throw STD.errors.user('Missing bounding box for storage in plinth');
						}
						const storage2x1CornerLeft = app.component_configuration.productsComponents.find(x => x.type ===
							'storage' &&
							x.SKU ===
							'storage2x1CornerLeft');
						if (!storage2x1CornerLeft) {
							throw STD.errors.user('No storage 2x1 Classic found in plinth');
						}
						const boundingBox2x1CornerLeft = storage2x1CornerLeft.boundingBox;
						if (!boundingBox2x1CornerLeft) {
							throw STD.errors.user('Missing bounding box for storage in plinth');
						}
						const storage2x1CornerRight = app.component_configuration.productsComponents.find(x => x.type ===
							'storage' &&
							x.SKU ===
							'storage2x1CornerRight');
						if (!storage2x1CornerRight) {
							throw STD.errors.user('No storage 2x1 Classic found in plinth');
						}
						const boundingBox2x1CornerRight = storage2x1CornerRight.boundingBox;
						if (!boundingBox2x1CornerRight) {
							throw STD.errors.user('Missing bounding box for storage in plinth');
						}
						if (layoutId === 'shape-no-wall') {
							return (ViewerNS.Component.mtx([ 1, 1, 1 ], [ 0, 0, 0 ], 0));
						} else if (layoutId === 'shape-back-left') {
							if (side === 'left') {
								return (ViewerNS.Component.mtx([ -(x / 2), 0, z / 2 ], [ 1, 1, 1 ], 90));
							} else if (side === 'back') {
								return (ViewerNS.Component.mtx([ -(x / 2), 0, -z / 2 ], [ 1, 1, 1 ], 0));
							} else if (side === 'left-leftPlinth') {
								if (z >= 3) {
									return (ViewerNS.Component.mtx([ 0, 0, 0 ], [ z / 3, 1, 1 ], 0));
								} else if (z > 2) {
									return (ViewerNS.Component.mtx([ 0, 0, 0 ], [ z - 2, 1, 1 ], 0));
								} else {
									return (ViewerNS.Component.mtx([ 1, 1, 1 ], [ 0, 0, 0 ], 0));
								}
							} else if (side === 'left-middlePlinth') {
								if (z > 3) {
									return (ViewerNS.Component.mtx([ z / 3, 0, 0 ], [ (2 * z / 3) - 2, 1, 1 ], 0));
								} else {
									return (ViewerNS.Component.mtx([ 1, 1, 1 ], [ 0, 0, 0 ], 0));
								}
							} else if (side === 'back-middlePlinth') {
								return (ViewerNS.Component.mtx(
									[ boundingBox2x1CornerRight.width, 0, 0 ],
									[ 2 * x / 3 - boundingBox2x1CornerRight.width, 1, 1 ],
									0
								));
							} else if (side === 'back-rightPlinthClosed') {
								return (ViewerNS.Component.mtx([ 2 * x / 3, 0, 0 ], [ x / 3, 1, 1 ], 0));
							} else {
								return (ViewerNS.Component.mtx([ 1, 1, 1 ], [ 0, 0, 0 ], 0));
							}
						} else if (layoutId === 'shape-back') {
							if (side === 'back') {
								return (ViewerNS.Component.mtx([ -(x / 2), 0, -z / 2 ], [ 1, 1, 1 ], 0));
							} else if (side === 'back-middlePlinth') {
								return (ViewerNS.Component.mtx(
									[ boundingBox2x1Classic.width, 0, 0 ],
									[ 2 * x / 3 - boundingBox2x1Classic.width, 1, 1 ],
									0
								));
							} else if (side === 'back-rightPlinthClosed') {
								return (ViewerNS.Component.mtx([ 2 * x / 3, 0, 0 ], [ x / 3, 1, 1 ], 0));
							} else {
								return (ViewerNS.Component.mtx([ 1, 1, 1 ], [ 0, 0, 0 ], 0));
							}
						} else if (layoutId === 'shape-back-right') {
							if (side === 'right') {
								return (ViewerNS.Component.mtx([ (x / 2), 0, -z / 2 ], [ 1, 1, 1 ], 270));
							} else if (side === 'back') {
								return (ViewerNS.Component.mtx([ -(x / 2), 0, -z / 2 ], [ 1, 1, 1 ], 0));
							} else if (side === 'right-middlePlinth') {
								if (z > 2) {
									return (ViewerNS.Component.mtx([ 2, 0, 0 ], [ 2 * z / 3 - 2, 1, 1 ], 0));
								} else {
									return (ViewerNS.Component.mtx([ 1, 1, 1 ], [ 0, 0, 0 ], 0));
								}
							} else if (side === 'right-rightPlinth') {
								return (ViewerNS.Component.mtx([ 2 * z / 3, 0, 0 ], [ z / 3, 1, 1 ], 0));
							} else if (side === 'back-leftPlinthClosed') {
								return (ViewerNS.Component.mtx([ 0, 0, 0 ], [ x / 3, 1, 1 ], 0));
							} else if (side === 'back-middlePlinth') {
								return (ViewerNS.Component.mtx([ x / 3, 0, 0 ], [ 2 * x / 3 - boundingBox2x1CornerLeft.width, 1, 1 ], 0));
							} else {
								return (ViewerNS.Component.mtx([ 1, 1, 1 ], [ 0, 0, 0 ], 0));
							}
						} else if (layoutId === 'shape-left-back-right') {
							const archPrestigeSpecial = app.component_configuration.productsComponents.find(x => x.type ===
								'arch' &&
								x.SKU ===
								'arch-prestige-special');
							if (!archPrestigeSpecial) {
								throw STD.errors.user('No arch prestige special found in plinth');
							}
							const boundingBoxArchPrestigeSpecial = archPrestigeSpecial.boundingBox;
							if (!boundingBoxArchPrestigeSpecial) {
								throw STD.errors.user('Missing bounding box for special arch prestige in plinth');
							}
							if (side === 'left') {
								return (ViewerNS.Component.mtx([ -(x / 2), 0, z / 2 ], [ 1, 1, 1 ], 90));
							} else if (side === 'back') {
								return (ViewerNS.Component.mtx([ -(x / 2), 0, -z / 2 ], [ 1, 1, 1 ], 0));
							} else if (side === 'right') {
								return (ViewerNS.Component.mtx([ (x / 2), 0, -z / 2 ], [ 1, 1, 1 ], 270));
							} else if (side === 'left-leftPlinth') {
								return (ViewerNS.Component.mtx([ 0, 0, 0 ], [ z / 3, 1, 1 ], 0));
							} else if (side === 'left-middlePlinth') {
								return (ViewerNS.Component.mtx([ z / 3, 0, 0 ], [ z / 3, 1, 1 ], 0));
							} else if (side === 'left-rightPlinth') {
								return (ViewerNS.Component.mtx([ 2 * z / 3, 0, 0 ], [ z / 3 - boundingBoxCorner.depth, 1, 1 ], 0));
							} else if (side === 'back-cornerLeftPlinth') {
								return (ViewerNS.Component.mtx([ 0, 0, 0 ], [ 1, 1, 1 ], 0));
							} else if (side === 'back-leftPlinthOpened') {
								return (ViewerNS.Component.mtx(
									[ boundingBoxCorner.width, 0, 0 ],
									[ boundingBoxArchPrestigeSpecial.width - boundingBoxCorner.width, 1, 1 ],
									0
								));
							} else if (side === 'back-rightPlinthOpened') {
								return (ViewerNS.Component.mtx(
									[ boundingBox2x1Classic.width + boundingBoxArchPrestigeSpecial.width, 0, 0 ],
									[
										x - boundingBox2x1Classic.width - boundingBoxArchPrestigeSpecial.width - boundingBoxCorner.depth,
										1,
										1
									],
									0
								));
							} else if (side === 'back-cornerRightPlinth') {
								return (ViewerNS.Component.mtx([ x, 0, 0 ], [ 1, 1, 1 ], 270));
							} else if (side === 'right-leftPlinth') {
								return (ViewerNS.Component.mtx(
									[ boundingBoxCorner.width, 0, 0 ],
									[ z / 3 - boundingBoxCorner.width, 1, 1 ],
									0
								));
							} else if (side === 'right-middlePlinth') {
								return (ViewerNS.Component.mtx([ z / 3, 0, 0 ], [ z / 3, 1, 1 ], 0));
							} else if (side === 'right-rightPlinth') {
								return (ViewerNS.Component.mtx([ 2 * z / 3, 0, 0 ], [ z / 3, 1, 1 ], 0));
							} else {
								return (ViewerNS.Component.mtx([ 1, 1, 1 ], [ 0, 0, 0 ], 0));
							}
						} else {
							throw STD.errors.user('Unknown layoutId in plinth');
						}
					} else {
						return (ViewerNS.Component.mtx([ 1, 1, 1 ], [ 0, 0, 0 ], 0));
					}
				} else if (product.id === 'confort') {
					if (surface > 24) {
						const storage3x1Classic = app.component_configuration.productsComponents.find(x => x.type ===
							'storage' &&
							x.SKU ===
							'storage3x1Classic');
						if (!storage3x1Classic) {
							throw STD.errors.user('No storage 3x1 Classic found in plinth');
						}
						const boundingBox3x1Classic = storage3x1Classic.boundingBox;
						if (!boundingBox3x1Classic) {
							throw STD.errors.user('Missing bounding box for storage in plinth');
						}
						const storage3x1CornerLeft = app.component_configuration.productsComponents.find(x => x.type ===
							'storage' &&
							x.SKU ===
							'storage3x1CornerLeft');
						if (!storage3x1CornerLeft) {
							throw STD.errors.user('No storage 3x1 Classic found in plinth');
						}
						const boundingBox3x1CornerLeft = storage3x1CornerLeft.boundingBox;
						if (!boundingBox3x1CornerLeft) {
							throw STD.errors.user('Missing bounding box for storage in plinth');
						}
						const storage3x1Side = app.component_configuration.productsComponents.find(x => x.type ===
							'storage' &&
							x.SKU ===
							'storage3x1Side');
						if (!storage3x1Side) {
							throw STD.errors.user('No storage 3x1 Classic found in plinth');
						}
						const boundingBox3x1Side = storage3x1Side.boundingBox;
						if (!boundingBox3x1Side) {
							throw STD.errors.user('Missing bounding box for storage in plinth');
						}
						if (layoutId === 'shape-no-wall') {
							return (ViewerNS.Component.mtx([ 1, 1, 1 ], [ 0, 0, 0 ], 0));
						} else if (layoutId === 'shape-back-left') {
							if (side === 'left') {
								return (ViewerNS.Component.mtx([ -(x / 2), 0, z / 2 ], [ 1, 1, 1 ], 90));
							} else if (side === 'back') {
								return (ViewerNS.Component.mtx([ -(x / 2), 0, -z / 2 ], [ 1, 1, 1 ], 0));
							} else if (side === 'left-leftPlinth') {
								return (ViewerNS.Component.mtx([ 0, 0, 0 ], [ z / 3, 1, 1 ], 0));
							} else if (side === 'left-middlePlinth') {
								return (ViewerNS.Component.mtx([ z / 3, 0, 0 ], [ 2 * z / 3 - boundingBox3x1CornerLeft.width, 1, 1 ], 0));
							} else if (side === 'back-middlePlinth') {
								return (ViewerNS.Component.mtx([ 3, 0, 0 ], [ 2 * x / 3 - 3, 1, 1 ], 0));
							} else if (side === 'back-rightPlinthClosed') {
								return (ViewerNS.Component.mtx([ 2 * x / 3, 0, 0 ], [ x / 3, 1, 1 ], 0));
							} else {
								return (ViewerNS.Component.mtx([ 1, 1, 1 ], [ 0, 0, 0 ], 0));
							}
						} else if (layoutId === 'shape-back') {
							if (side === 'back') {
								return (ViewerNS.Component.mtx([ -(x / 2), 0, -z / 2 ], [ 1, 1, 1 ], 0));
							} else if (side === 'back-middlePlinth') {
								return (ViewerNS.Component.mtx([ 3, 0, 0 ], [ 2 * x / 3 - 3, 1, 1 ], 0));
							} else if (side === 'back-rightPlinthClosed') {
								return (ViewerNS.Component.mtx([ 2 * x / 3, 0, 0 ], [ x / 3, 1, 1 ], 0));
							} else {
								return (ViewerNS.Component.mtx([ 1, 1, 1 ], [ 0, 0, 0 ], 0));
							}
						} else if (layoutId === 'shape-back-right') {
							if (side === 'right') {
								return (ViewerNS.Component.mtx([ (x / 2), 0, -z / 2 ], [ 1, 1, 1 ], 270));
							} else if (side === 'back') {
								return (ViewerNS.Component.mtx([ -(x / 2), 0, -z / 2 ], [ 1, 1, 1 ], 0));
							} else if (side === 'right-middlePlinth') {
								if (z > 4.5) {
									return (ViewerNS.Component.mtx([ 3, 0, 0 ], [ 2 * z / 3 - 3, 1, 1 ], 0));
								} else {
									return (ViewerNS.Component.mtx([ 1, 1, 1 ], [ 0, 0, 0 ], 0));
								}
							} else if (side === 'right-rightPlinth') {
								if (z > 4.5) {
									return (ViewerNS.Component.mtx([ 2 * z / 3, 0, 0 ], [ z / 3, 1, 1 ], 0));
								} else if (z > 3) {
									return (ViewerNS.Component.mtx([ 3, 0, 0 ], [ z - 3, 1, 1 ], 0));
								} else {
									return (ViewerNS.Component.mtx([ 1, 1, 1 ], [ 0, 0, 0 ], 0));
								}
							} else if (side === 'back-leftPlinthClosed') {
								return (ViewerNS.Component.mtx([ 0, 0, 0 ], [ x / 3, 1, 1 ], 0));
							} else if (side === 'back-middlePlinth') {
								return (ViewerNS.Component.mtx([ x / 3, 0, 0 ], [ 2 * x / 3 - boundingBox3x1CornerLeft.width, 1, 1 ], 0));
							} else {
								return (ViewerNS.Component.mtx([ 1, 1, 1 ], [ 0, 0, 0 ], 0));
							}
						} else if (layoutId === 'shape-left-back-right') {
							if (side === 'left') {
								return (ViewerNS.Component.mtx([ -(x / 2), 0, z / 2 ], [ 1, 1, 1 ], 90));
							} else if (side === 'back') {
								return (ViewerNS.Component.mtx([ -(x / 2), 0, -z / 2 ], [ 1, 1, 1 ], 0));
							} else if (side === 'right') {
								return (ViewerNS.Component.mtx([ (x / 2), 0, -z / 2 ], [ 1, 1, 1 ], 270));
							} else if (side === 'left-leftPlinth') {
								return (ViewerNS.Component.mtx([ 0, 0, 0 ], [ z / 3, 1, 1 ], 0));
							} else if (side === 'left-middlePlinth') {
								return (ViewerNS.Component.mtx([ z / 3, 0, 0 ], [ 2 * z / 3 - boundingBox3x1CornerLeft.width, 1, 1 ], 0));
							} else if (side === 'back-middlePlinth') {
								if (x > 4.5) {
									return (ViewerNS.Component.mtx([ 3, 0, 0 ], [ 2 * x / 3 - 3, 1, 1 ], 0));
								} else {
									return (ViewerNS.Component.mtx([ 1, 1, 1 ], [ 0, 0, 0 ], 0));
								}
							} else if (side === 'back-rightPlinthOpened') {
								if (x > 4.5) {
									return (ViewerNS.Component.mtx([ 2 * x / 3, 0, 0 ], [ x / 3 - boundingBoxCorner.depth, 1, 1 ], 0));
								} else if (x > 3) {
									return (ViewerNS.Component.mtx([ 3, 0, 0 ], [ x - 3, 1, 1 ], 0));
								} else {
									return (ViewerNS.Component.mtx([ 1, 1, 1 ], [ 0, 0, 0 ], 0));
								}
							} else if (side === 'back-cornerRightPlinth') {
								return (ViewerNS.Component.mtx([ x, 0, 0 ], [ 1, 1, 1 ], 270));
							} else if (side === 'right-leftPlinth') {
								return (ViewerNS.Component.mtx(
									[ boundingBoxCorner.width, 0, 0 ],
									[ z / 3 - boundingBoxCorner.width, 1, 1 ],
									0
								));
							} else if (side === 'right-middlePlinth') {
								return (ViewerNS.Component.mtx([ z / 3, 0, 0 ], [ z / 3, 1, 1 ], 0));
							} else if (side === 'right-rightPlinth') {
								return (ViewerNS.Component.mtx([ 2 * z / 3, 0, 0 ], [ z / 3, 1, 1 ], 0));
							} else {
								return (ViewerNS.Component.mtx([ 1, 1, 1 ], [ 0, 0, 0 ], 0));
							}
						} else {
							throw STD.errors.user('Unknown layoutId in plinth');
						}
					} else if (surface > 17) {
						const storage2x1Classic = app.component_configuration.productsComponents.find(x => x.type ===
							'storage' &&
							x.SKU ===
							'storage2x1Classic');
						if (!storage2x1Classic) {
							throw STD.errors.user('No storage 2x1 Classic found in plinth');
						}
						const boundingBox2x1Classic = storage2x1Classic.boundingBox;
						if (!boundingBox2x1Classic) {
							throw STD.errors.user('Missing bounding box for storage in plinth');
						}
						const storage2x1CornerLeft = app.component_configuration.productsComponents.find(x => x.type ===
							'storage' &&
							x.SKU ===
							'storage2x1CornerLeft');
						if (!storage2x1CornerLeft) {
							throw STD.errors.user('No storage 2x1 Classic found in plinth');
						}
						const boundingBox2x1CornerLeft = storage2x1CornerLeft.boundingBox;
						if (!boundingBox2x1CornerLeft) {
							throw STD.errors.user('Missing bounding box for storage in plinth');
						}
						const storage2x1Side = app.component_configuration.productsComponents.find(x => x.type ===
							'storage' &&
							x.SKU ===
							'storage2x1Side');
						if (!storage2x1Side) {
							throw STD.errors.user('No storage 2x1 Classic found in plinth');
						}
						const boundingBox2x1Side = storage2x1Side.boundingBox;
						if (!boundingBox2x1Side) {
							throw STD.errors.user('Missing bounding box for storage in plinth');
						}
						if (layoutId === 'shape-no-wall') {
							return (ViewerNS.Component.mtx([ 1, 1, 1 ], [ 0, 0, 0 ], 0));
						} else if (layoutId === 'shape-back-left') {
							if (side === 'left') {
								return (ViewerNS.Component.mtx([ -(x / 2), 0, z / 2 ], [ 1, 1, 1 ], 90));
							} else if (side === 'back') {
								return (ViewerNS.Component.mtx([ -(x / 2), 0, -z / 2 ], [ 1, 1, 1 ], 0));
							} else if (side === 'left-leftPlinth') {
								return (ViewerNS.Component.mtx([ 0, 0, 0 ], [ z / 3, 1, 1 ], 0));
							} else if (side === 'left-middlePlinth') {
								return (ViewerNS.Component.mtx([ z / 3, 0, 0 ], [ 2 * z / 3 - boundingBox2x1CornerLeft.width, 1, 1 ], 0));
							} else if (side === 'back-middlePlinth') {
								return (ViewerNS.Component.mtx([ 2, 0, 0 ], [ 2 * x / 3 - 2, 1, 1 ], 0));
							} else if (side === 'back-rightPlinthClosed') {
								return (ViewerNS.Component.mtx([ 2 * x / 3, 0, 0 ], [ x / 3, 1, 1 ], 0));
							} else {
								return (ViewerNS.Component.mtx([ 1, 1, 1 ], [ 0, 0, 0 ], 0));
							}
						} else if (layoutId === 'shape-back') {
							if (side === 'back') {
								return (ViewerNS.Component.mtx([ -(x / 2), 0, -z / 2 ], [ 1, 1, 1 ], 0));
							} else if (side === 'back-middlePlinth') {
								return (ViewerNS.Component.mtx([ 2, 0, 0 ], [ 2 * x / 3 - 2, 1, 1 ], 0));
							} else if (side === 'back-rightPlinthClosed') {
								return (ViewerNS.Component.mtx([ 2 * x / 3, 0, 0 ], [ x / 3, 1, 1 ], 0));
							} else {
								return (ViewerNS.Component.mtx([ 1, 1, 1 ], [ 0, 0, 0 ], 0));
							}
						} else if (layoutId === 'shape-back-right') {
							if (side === 'right') {
								return (ViewerNS.Component.mtx([ (x / 2), 0, -z / 2 ], [ 1, 1, 1 ], 270));
							} else if (side === 'back') {
								return (ViewerNS.Component.mtx([ -(x / 2), 0, -z / 2 ], [ 1, 1, 1 ], 0));
							} else if (side === 'right-middlePlinth') {
								return (ViewerNS.Component.mtx([ 2, 0, 0 ], [ 2 * z / 3 - 2, 1, 1 ], 0));
							} else if (side === 'right-rightPlinth') {
								return (ViewerNS.Component.mtx([ 2 * z / 3, 0, 0 ], [ z / 3, 1, 1 ], 0));
							} else if (side === 'back-leftPlinthClosed') {
								return (ViewerNS.Component.mtx([ 0, 0, 0 ], [ x / 3, 1, 1 ], 0));
							} else if (side === 'back-middlePlinth') {
								return (ViewerNS.Component.mtx([ x / 3, 0, 0 ], [ 2 * x / 3 - boundingBox2x1CornerLeft.width, 1, 1 ], 0));
							} else {
								return (ViewerNS.Component.mtx([ 1, 1, 1 ], [ 0, 0, 0 ], 0));
							}
						} else if (layoutId === 'shape-left-back-right') {
							if (side === 'left') {
								return (ViewerNS.Component.mtx([ -(x / 2), 0, z / 2 ], [ 1, 1, 1 ], 90));
							} else if (side === 'back') {
								return (ViewerNS.Component.mtx([ -(x / 2), 0, -z / 2 ], [ 1, 1, 1 ], 0));
							} else if (side === 'right') {
								return (ViewerNS.Component.mtx([ (x / 2), 0, -z / 2 ], [ 1, 1, 1 ], 270));
							} else if (side === 'left-leftPlinth') {
								return (ViewerNS.Component.mtx([ 0, 0, 0 ], [ z / 3, 1, 1 ], 0));
							} else if (side === 'left-middlePlinth') {
								return (ViewerNS.Component.mtx([ z / 3, 0, 0 ], [ 2 * z / 3 - boundingBox2x1CornerLeft.width, 1, 1 ], 0));
							} else if (side === 'back-middlePlinth') {
								return (ViewerNS.Component.mtx([ 2, 0, 0 ], [ 2 * x / 3 - 2, 1, 1 ], 0));
							} else if (side === 'back-rightPlinthOpened') {
								return (ViewerNS.Component.mtx([ 2 * x / 3, 0, 0 ], [ x / 3 - boundingBoxCorner.depth, 1, 1 ], 0));
							} else if (side === 'back-cornerRightPlinth') {
								return (ViewerNS.Component.mtx([ x, 0, 0 ], [ 1, 1, 1 ], 270));
							} else if (side === 'right-leftPlinth') {
								return (ViewerNS.Component.mtx(
									[ boundingBoxCorner.width, 0, 0 ],
									[ z / 3 - boundingBoxCorner.width, 1, 1 ],
									0
								));
							} else if (side === 'right-middlePlinth') {
								return (ViewerNS.Component.mtx([ z / 3, 0, 0 ], [ z / 3, 1, 1 ], 0));
							} else if (side === 'right-rightPlinth') {
								return (ViewerNS.Component.mtx([ 2 * z / 3, 0, 0 ], [ z / 3, 1, 1 ], 0));
							} else {
								return (ViewerNS.Component.mtx([ 1, 1, 1 ], [ 0, 0, 0 ], 0));
							}
						} else {
							throw STD.errors.user('Unknown layoutId in plinth');
						}
					} else {
						return (ViewerNS.Component.mtx([ 1, 1, 1 ], [ 0, 0, 0 ], 0));
					}
				} else if (product.id === 'business') {
					if (surface > 35) {
						if (layoutId === 'shape-no-wall') {
							return (ViewerNS.Component.mtx([ 1, 1, 1 ], [ 0, 0, 0 ], 0));
						} else if (layoutId === 'shape-back-left') {
							if (partitionHeadsPosition === 'left') {
								if (side === 'left') {
									return (ViewerNS.Component.mtx([ -(x / 2), 0, z / 2 ], [ 1, 1, 1 ], 90));
								} else if (side === 'back') {
									return (ViewerNS.Component.mtx([ -(x / 2), 0, -z / 2 ], [ 1, 1, 1 ], 0));
								} else if (side === 'left-leftPlinth') {
									return (ViewerNS.Component.mtx(
										[ boundingBoxPartitions, 0, 0 ],
										[ z / 3 - boundingBoxPartitions, 1, 1 ],
										0
									));
								} else if (side === 'left-middlePlinth') {
									return (ViewerNS.Component.mtx([ z / 3, 0, 0 ], [ z / 3, 1, 1 ], 0));
								} else if (side === 'left-rightPlinth') {
									return (ViewerNS.Component.mtx([ 2 * z / 3, 0, 0 ], [ z / 3 - boundingBoxCorner.depth, 1, 1 ], 0));
								} else if (side === 'back-leftPlinthOpened') {
									return (ViewerNS.Component.mtx(
										[ boundingBoxCorner.width, 0, 0 ],
										[ x / 3 - boundingBoxCorner.width, 1, 1 ],
										0
									));
								} else if (side === 'back-middlePlinth') {
									return (ViewerNS.Component.mtx([ x / 3, 0, 0 ], [ x / 3, 1, 1 ], 0));
								} else if (side === 'back-rightPlinthClosed') {
									return (ViewerNS.Component.mtx([ 2 * x / 3, 0, 0 ], [ x / 3, 1, 1 ], 0));
								} else if (side === 'back-cornerLeftPlinth') {
									return (ViewerNS.Component.mtx([ 0, 0, 0 ], [ 1, 1, 1 ], 0));
								} else {
									return (ViewerNS.Component.mtx([ 1, 1, 1 ], [ 0, 0, 0 ], 0));
								}
							} else if (partitionHeadsPosition === 'back') {
								if (side === 'left') {
									return (ViewerNS.Component.mtx([ -(x / 2), 0, z / 2 ], [ 1, 1, 1 ], 90));
								} else if (side === 'back') {
									return (ViewerNS.Component.mtx([ -(x / 2), 0, -z / 2 ], [ 1, 1, 1 ], 0));
								} else if (side === 'left-leftPlinth') {
									return (ViewerNS.Component.mtx([ 0, 0, 0 ], [ z / 3, 1, 1 ], 0));
								} else if (side === 'left-middlePlinth') {
									return (ViewerNS.Component.mtx([ z / 3, 0, 0 ], [ z / 3, 1, 1 ], 0));
								} else if (side === 'left-rightPlinth') {
									return (ViewerNS.Component.mtx([ 2 * z / 3, 0, 0 ], [ z / 3 - boundingBoxCorner.depth, 1, 1 ], 0));
								} else if (side === 'back-leftPlinthOpened') {
									return (ViewerNS.Component.mtx(
										[ boundingBoxCorner.width, 0, 0 ],
										[ x / 3 - boundingBoxCorner.width, 1, 1 ],
										0
									));
								} else if (side === 'back-middlePlinth') {
									return (ViewerNS.Component.mtx([ x / 3, 0, 0 ], [ x / 3, 1, 1 ], 0));
								} else if (side === 'back-rightPlinthClosed') {
									return (ViewerNS.Component.mtx([ 2 * x / 3, 0, 0 ], [ x / 3 - boundingBoxPartitions, 1, 1 ], 0));
								} else if (side === 'back-cornerLeftPlinth') {
									return (ViewerNS.Component.mtx([ 0, 0, 0 ], [ 1, 1, 1 ], 0));
								} else {
									return (ViewerNS.Component.mtx([ 1, 1, 1 ], [ 0, 0, 0 ], 0));
								}
							} else if (partitionHeadsPosition === 'back-left') {
								if (side === 'left') {
									return (ViewerNS.Component.mtx([ -(x / 2), 0, z / 2 ], [ 1, 1, 1 ], 90));
								} else if (side === 'back') {
									return (ViewerNS.Component.mtx([ -(x / 2), 0, -z / 2 ], [ 1, 1, 1 ], 0));
								} else if (side === 'left-leftPlinth') {
									return (ViewerNS.Component.mtx(
										[ boundingBoxPartitions, 0, 0 ],
										[ z / 3 - boundingBoxPartitions, 1, 1 ],
										0
									));
								} else if (side === 'left-middlePlinth') {
									return (ViewerNS.Component.mtx([ z / 3, 0, 0 ], [ z / 3, 1, 1 ], 0));
								} else if (side === 'left-rightPlinth') {
									return (ViewerNS.Component.mtx([ 2 * z / 3, 0, 0 ], [ z / 3 - boundingBoxCorner.depth, 1, 1 ], 0));
								} else if (side === 'back-leftPlinthOpened') {
									return (ViewerNS.Component.mtx(
										[ boundingBoxCorner.width, 0, 0 ],
										[ x / 3 - boundingBoxCorner.width, 1, 1 ],
										0
									));
								} else if (side === 'back-middlePlinth') {
									return (ViewerNS.Component.mtx([ x / 3, 0, 0 ], [ x / 3, 1, 1 ], 0));
								} else if (side === 'back-rightPlinthClosed') {
									return (ViewerNS.Component.mtx([ 2 * x / 3, 0, 0 ], [ x / 3 - boundingBoxPartitions, 1, 1 ], 0));
								} else if (side === 'back-cornerLeftPlinth') {
									return (ViewerNS.Component.mtx([ 0, 0, 0 ], [ 1, 1, 1 ], 0));
								} else {
									return (ViewerNS.Component.mtx([ 1, 1, 1 ], [ 0, 0, 0 ], 0));
								}
							} else {
								if (side === 'left') {
									return (ViewerNS.Component.mtx([ -(x / 2), 0, z / 2 ], [ 1, 1, 1 ], 90));
								} else if (side === 'back') {
									return (ViewerNS.Component.mtx([ -(x / 2), 0, -z / 2 ], [ 1, 1, 1 ], 0));
								} else if (side === 'left-leftPlinth') {
									return (ViewerNS.Component.mtx([ 0, 0, 0 ], [ z / 3, 1, 1 ], 0));
								} else if (side === 'left-middlePlinth') {
									return (ViewerNS.Component.mtx([ z / 3, 0, 0 ], [ z / 3, 1, 1 ], 0));
								} else if (side === 'left-rightPlinth') {
									return (ViewerNS.Component.mtx([ 2 * z / 3, 0, 0 ], [ z / 3 - boundingBoxCorner.depth, 1, 1 ], 0));
								} else if (side === 'back-leftPlinthOpened') {
									return (ViewerNS.Component.mtx(
										[ boundingBoxCorner.width, 0, 0 ],
										[ x / 3 - boundingBoxCorner.width, 1, 1 ],
										0
									));
								} else if (side === 'back-middlePlinth') {
									return (ViewerNS.Component.mtx([ x / 3, 0, 0 ], [ x / 3, 1, 1 ], 0));
								} else if (side === 'back-rightPlinthClosed') {
									return (ViewerNS.Component.mtx([ 2 * x / 3, 0, 0 ], [ x / 3, 1, 1 ], 0));
								} else if (side === 'back-cornerLeftPlinth') {
									return (ViewerNS.Component.mtx([ 0, 0, 0 ], [ 1, 1, 1 ], 0));
								} else {
									return (ViewerNS.Component.mtx([ 1, 1, 1 ], [ 0, 0, 0 ], 0));
								}
							}
						} else if (layoutId === 'shape-back') {
							if (partitionHeadsPosition === 'back') {
								if (side === 'back') {
									return (ViewerNS.Component.mtx([ -(x / 2), 0, -z / 2 ], [ 1, 1, 1 ], 0));
								} else if (side === 'back-leftPlinthClosed') {
									return (ViewerNS.Component.mtx(
										[ boundingBoxPartitions, 0, 0 ],
										[ x / 3 - boundingBoxPartitions, 1, 1 ],
										0
									));
								} else if (side === 'back-middlePlinth') {
									return (ViewerNS.Component.mtx([ x / 3, 0, 0 ], [ x / 3, 1, 1 ], 0));
								} else if (side === 'back-rightPlinthClosed') {
									return (ViewerNS.Component.mtx([ 2 * x / 3, 0, 0 ], [ x / 3, 1, 1 ], 0));
								} else {
									return (ViewerNS.Component.mtx([ 1, 1, 1 ], [ 0, 0, 0 ], 0));
								}
							} else if (partitionHeadsPosition === 'back-back') {
								if (side === 'back') {
									return (ViewerNS.Component.mtx([ -(x / 2), 0, -z / 2 ], [ 1, 1, 1 ], 0));
								} else if (side === 'back-leftPlinthClosed') {
									return (ViewerNS.Component.mtx(
										[ boundingBoxPartitions, 0, 0 ],
										[ x / 3 - boundingBoxPartitions, 1, 1 ],
										0
									));
								} else if (side === 'back-middlePlinth') {
									return (ViewerNS.Component.mtx([ x / 3, 0, 0 ], [ x / 3, 1, 1 ], 0));
								} else if (side === 'back-rightPlinthClosed') {
									return (ViewerNS.Component.mtx([ 2 * x / 3, 0, 0 ], [ x / 3 - boundingBoxPartitions, 1, 1 ], 0));
								} else {
									return (ViewerNS.Component.mtx([ 1, 1, 1 ], [ 0, 0, 0 ], 0));
								}
							} else {
								if (side === 'back') {
									return (ViewerNS.Component.mtx([ -(x / 2), 0, -z / 2 ], [ 1, 1, 1 ], 0));
								} else if (side === 'back-leftPlinthClosed') {
									return (ViewerNS.Component.mtx([ 0, 0, 0 ], [ x / 3, 1, 1 ], 0));
								} else if (side === 'back-middlePlinth') {
									return (ViewerNS.Component.mtx([ x / 3, 0, 0 ], [ x / 3, 1, 1 ], 0));
								} else if (side === 'back-rightPlinthClosed') {
									return (ViewerNS.Component.mtx([ 2 * x / 3, 0, 0 ], [ x / 3, 1, 1 ], 0));
								} else {
									return (ViewerNS.Component.mtx([ 1, 1, 1 ], [ 0, 0, 0 ], 0));
								}
							}

						} else if (layoutId === 'shape-back-right') {
							if (partitionHeadsPosition === 'back') {
								if (side === 'right') {
									return (ViewerNS.Component.mtx([ (x / 2), 0, -z / 2 ], [ 1, 1, 1 ], 270));
								} else if (side === 'back') {
									return (ViewerNS.Component.mtx([ -(x / 2), 0, -z / 2 ], [ 1, 1, 1 ], 0));
								} else if (side === 'right-leftPlinth') {
									return (ViewerNS.Component.mtx(
										[ boundingBoxCorner.width, 0, 0 ],
										[ z / 3 - boundingBoxCorner.width, 1, 1 ],
										0
									));
								} else if (side === 'right-middlePlinth') {
									return (ViewerNS.Component.mtx([ z / 3, 0, 0 ], [ z / 3, 1, 1 ], 0));
								} else if (side === 'right-rightPlinth') {
									return (ViewerNS.Component.mtx([ 2 * z / 3, 0, 0 ], [ z / 3, 1, 1 ], 0));
								} else if (side === 'back-leftPlinthClosed') {
									return (ViewerNS.Component.mtx(
										[ boundingBoxPartitions, 0, 0 ],
										[ x / 3 - boundingBoxPartitions, 1, 1 ],
										0
									));
								} else if (side === 'back-middlePlinth') {
									return (ViewerNS.Component.mtx([ x / 3, 0, 0 ], [ x / 3, 1, 1 ], 0));
								} else if (side === 'back-rightPlinthOpened') {
									return (ViewerNS.Component.mtx([ 2 * x / 3, 0, 0 ], [ x / 3 - boundingBoxCorner.depth, 1, 1 ], 0));
								} else if (side === 'back-cornerRightPlinth') {
									return (ViewerNS.Component.mtx([ x, 0, 0 ], [ 1, 1, 1 ], 270));
								} else {
									return (ViewerNS.Component.mtx([ 1, 1, 1 ], [ 0, 0, 0 ], 0));
								}
							} else if (partitionHeadsPosition === 'back-right') {
								if (side === 'right') {
									return (ViewerNS.Component.mtx([ (x / 2), 0, -z / 2 ], [ 1, 1, 1 ], 270));
								} else if (side === 'back') {
									return (ViewerNS.Component.mtx([ -(x / 2), 0, -z / 2 ], [ 1, 1, 1 ], 0));
								} else if (side === 'right-leftPlinth') {
									return (ViewerNS.Component.mtx(
										[ boundingBoxCorner.width, 0, 0 ],
										[ z / 3 - boundingBoxCorner.width, 1, 1 ],
										0
									));
								} else if (side === 'right-middlePlinth') {
									return (ViewerNS.Component.mtx([ z / 3, 0, 0 ], [ z / 3, 1, 1 ], 0));
								} else if (side === 'right-rightPlinth') {
									return (ViewerNS.Component.mtx([ 2 * z / 3, 0, 0 ], [ z / 3 - boundingBoxPartitions, 1, 1 ], 0));
								} else if (side === 'back-leftPlinthClosed') {
									return (ViewerNS.Component.mtx(
										[ boundingBoxPartitions, 0, 0 ],
										[ x / 3 - boundingBoxPartitions, 1, 1 ],
										0
									));
								} else if (side === 'back-middlePlinth') {
									return (ViewerNS.Component.mtx([ x / 3, 0, 0 ], [ x / 3, 1, 1 ], 0));
								} else if (side === 'back-rightPlinthOpened') {
									return (ViewerNS.Component.mtx([ 2 * x / 3, 0, 0 ], [ x / 3 - boundingBoxCorner.depth, 1, 1 ], 0));
								} else if (side === 'back-cornerRightPlinth') {
									return (ViewerNS.Component.mtx([ x, 0, 0 ], [ 1, 1, 1 ], 270));
								} else {
									return (ViewerNS.Component.mtx([ 1, 1, 1 ], [ 0, 0, 0 ], 0));
								}
							} else {
								if (side === 'right') {
									return (ViewerNS.Component.mtx([ (x / 2), 0, -z / 2 ], [ 1, 1, 1 ], 270));
								} else if (side === 'back') {
									return (ViewerNS.Component.mtx([ -(x / 2), 0, -z / 2 ], [ 1, 1, 1 ], 0));
								} else if (side === 'right-leftPlinth') {
									return (ViewerNS.Component.mtx(
										[ boundingBoxCorner.width, 0, 0 ],
										[ z / 3 - boundingBoxCorner.width, 1, 1 ],
										0
									));
								} else if (side === 'right-middlePlinth') {
									return (ViewerNS.Component.mtx([ z / 3, 0, 0 ], [ z / 3, 1, 1 ], 0));
								} else if (side === 'right-rightPlinth') {
									return (ViewerNS.Component.mtx([ 2 * z / 3, 0, 0 ], [ z / 3, 1, 1 ], 0));
								} else if (side === 'back-leftPlinthClosed') {
									return (ViewerNS.Component.mtx([ 0, 0, 0 ], [ x / 3, 1, 1 ], 0));
								} else if (side === 'back-middlePlinth') {
									return (ViewerNS.Component.mtx([ x / 3, 0, 0 ], [ x / 3, 1, 1 ], 0));
								} else if (side === 'back-rightPlinthOpened') {
									return (ViewerNS.Component.mtx([ 2 * x / 3, 0, 0 ], [ x / 3 - boundingBoxCorner.depth, 1, 1 ], 0));
								} else if (side === 'back-cornerRightPlinth') {
									return (ViewerNS.Component.mtx([ x, 0, 0 ], [ 1, 1, 1 ], 270));
								} else {
									return (ViewerNS.Component.mtx([ 1, 1, 1 ], [ 0, 0, 0 ], 0));
								}
							}
						} else if (layoutId === 'shape-left-back-right') {
							if (partitionHeadsPosition === 'left') {
								if (side === 'left') {
									return (ViewerNS.Component.mtx([ -(x / 2), 0, z / 2 ], [ 1, 1, 1 ], 90));
								} else if (side === 'back') {
									return (ViewerNS.Component.mtx([ -(x / 2), 0, -z / 2 ], [ 1, 1, 1 ], 0));
								} else if (side === 'right') {
									return (ViewerNS.Component.mtx([ (x / 2), 0, -z / 2 ], [ 1, 1, 1 ], 270));
								} else if (side === 'left-leftPlinth') {
									return (ViewerNS.Component.mtx(
										[ boundingBoxPartitions, 0, 0 ],
										[ z / 3 - boundingBoxPartitions, 1, 1 ],
										0
									));
								} else if (side === 'left-middlePlinth') {
									return (ViewerNS.Component.mtx([ z / 3, 0, 0 ], [ z / 3, 1, 1 ], 0));
								} else if (side === 'left-rightPlinth') {
									return (ViewerNS.Component.mtx([ 2 * z / 3, 0, 0 ], [ z / 3 - boundingBoxCorner.depth, 1, 1 ], 0));
								} else if (side === 'back-cornerLeftPlinth') {
									return (ViewerNS.Component.mtx([ 0, 0, 0 ], [ 1, 1, 1 ], 0));
								} else if (side === 'back-leftPlinthOpened') {
									return (ViewerNS.Component.mtx(
										[ boundingBoxCorner.width, 0, 0 ],
										[ x / 3 - boundingBoxCorner.width, 1, 1 ],
										0
									));
								} else if (side === 'back-middlePlinth') {
									return (ViewerNS.Component.mtx([ x / 3, 0, 0 ], [ x / 3, 1, 1 ], 0));
								} else if (side === 'back-rightPlinthOpened') {
									return (ViewerNS.Component.mtx([ 2 * x / 3, 0, 0 ], [ x / 3 - boundingBoxCorner.depth, 1, 1 ], 0));
								} else if (side === 'back-cornerRightPlinth') {
									return (ViewerNS.Component.mtx([ x, 0, 0 ], [ 1, 1, 1 ], 270));
								} else if (side === 'right-leftPlinth') {
									return (ViewerNS.Component.mtx(
										[ boundingBoxCorner.width, 0, 0 ],
										[ z / 3 - boundingBoxCorner.width, 1, 1 ],
										0
									));
								} else if (side === 'right-middlePlinth') {
									return (ViewerNS.Component.mtx([ z / 3, 0, 0 ], [ z / 3, 1, 1 ], 0));
								} else if (side === 'right-rightPlinth') {
									return (ViewerNS.Component.mtx([ 2 * z / 3, 0, 0 ], [ z / 3, 1, 1 ], 0));
								} else {
									return (ViewerNS.Component.mtx([ 1, 1, 1 ], [ 0, 0, 0 ], 0));
								}
							} else if (partitionHeadsPosition === 'left-right') {
								if (side === 'left') {
									return (ViewerNS.Component.mtx([ -(x / 2), 0, z / 2 ], [ 1, 1, 1 ], 90));
								} else if (side === 'back') {
									return (ViewerNS.Component.mtx([ -(x / 2), 0, -z / 2 ], [ 1, 1, 1 ], 0));
								} else if (side === 'right') {
									return (ViewerNS.Component.mtx([ (x / 2), 0, -z / 2 ], [ 1, 1, 1 ], 270));
								} else if (side === 'left-leftPlinth') {
									return (ViewerNS.Component.mtx(
										[ boundingBoxPartitions, 0, 0 ],
										[ z / 3 - boundingBoxPartitions, 1, 1 ],
										0
									));
								} else if (side === 'left-middlePlinth') {
									return (ViewerNS.Component.mtx([ z / 3, 0, 0 ], [ z / 3, 1, 1 ], 0));
								} else if (side === 'left-rightPlinth') {
									return (ViewerNS.Component.mtx([ 2 * z / 3, 0, 0 ], [ z / 3 - boundingBoxCorner.depth, 1, 1 ], 0));
								} else if (side === 'back-cornerLeftPlinth') {
									return (ViewerNS.Component.mtx([ 0, 0, 0 ], [ 1, 1, 1 ], 0));
								} else if (side === 'back-leftPlinthOpened') {
									return (ViewerNS.Component.mtx(
										[ boundingBoxCorner.width, 0, 0 ],
										[ x / 3 - boundingBoxCorner.width, 1, 1 ],
										0
									));
								} else if (side === 'back-middlePlinth') {
									return (ViewerNS.Component.mtx([ x / 3, 0, 0 ], [ x / 3, 1, 1 ], 0));
								} else if (side === 'back-rightPlinthOpened') {
									return (ViewerNS.Component.mtx([ 2 * x / 3, 0, 0 ], [ x / 3 - boundingBoxCorner.depth, 1, 1 ], 0));
								} else if (side === 'back-cornerRightPlinth') {
									return (ViewerNS.Component.mtx([ x, 0, 0 ], [ 1, 1, 1 ], 270));
								} else if (side === 'right-leftPlinth') {
									return (ViewerNS.Component.mtx(
										[ boundingBoxCorner.width, 0, 0 ],
										[ z / 3 - boundingBoxCorner.width, 1, 1 ],
										0
									));
								} else if (side === 'right-middlePlinth') {
									return (ViewerNS.Component.mtx([ z / 3, 0, 0 ], [ z / 3, 1, 1 ], 0));
								} else if (side === 'right-rightPlinth') {
									return (ViewerNS.Component.mtx([ 2 * z / 3, 0, 0 ], [ z / 3 - boundingBoxPartitions, 1, 1 ], 0));
								} else {
									return (ViewerNS.Component.mtx([ 1, 1, 1 ], [ 0, 0, 0 ], 0));
								}
							} else {
								if (side === 'left') {
									return (ViewerNS.Component.mtx([ -(x / 2), 0, z / 2 ], [ 1, 1, 1 ], 90));
								} else if (side === 'back') {
									return (ViewerNS.Component.mtx([ -(x / 2), 0, -z / 2 ], [ 1, 1, 1 ], 0));
								} else if (side === 'right') {
									return (ViewerNS.Component.mtx([ (x / 2), 0, -z / 2 ], [ 1, 1, 1 ], 270));
								} else if (side === 'left-leftPlinth') {
									return (ViewerNS.Component.mtx([ 0, 0, 0 ], [ z / 3, 1, 1 ], 0));
								} else if (side === 'left-middlePlinth') {
									return (ViewerNS.Component.mtx([ z / 3, 0, 0 ], [ z / 3, 1, 1 ], 0));
								} else if (side === 'left-rightPlinth') {
									return (ViewerNS.Component.mtx([ 2 * z / 3, 0, 0 ], [ z / 3 - boundingBoxCorner.depth, 1, 1 ], 0));
								} else if (side === 'back-cornerLeftPlinth') {
									return (ViewerNS.Component.mtx([ 0, 0, 0 ], [ 1, 1, 1 ], 0));
								} else if (side === 'back-leftPlinthOpened') {
									return (ViewerNS.Component.mtx(
										[ boundingBoxCorner.width, 0, 0 ],
										[ x / 3 - boundingBoxCorner.width, 1, 1 ],
										0
									));
								} else if (side === 'back-middlePlinth') {
									return (ViewerNS.Component.mtx([ x / 3, 0, 0 ], [ x / 3, 1, 1 ], 0));
								} else if (side === 'back-rightPlinthOpened') {
									return (ViewerNS.Component.mtx([ 2 * x / 3, 0, 0 ], [ x / 3 - boundingBoxCorner.depth, 1, 1 ], 0));
								} else if (side === 'back-cornerRightPlinth') {
									return (ViewerNS.Component.mtx([ x, 0, 0 ], [ 1, 1, 1 ], 270));
								} else if (side === 'right-leftPlinth') {
									return (ViewerNS.Component.mtx(
										[ boundingBoxCorner.width, 0, 0 ],
										[ z / 3 - boundingBoxCorner.width, 1, 1 ],
										0
									));
								} else if (side === 'right-middlePlinth') {
									return (ViewerNS.Component.mtx([ z / 3, 0, 0 ], [ z / 3, 1, 1 ], 0));
								} else if (side === 'right-rightPlinth') {
									return (ViewerNS.Component.mtx([ 2 * z / 3, 0, 0 ], [ z / 3, 1, 1 ], 0));
								} else {
									return (ViewerNS.Component.mtx([ 1, 1, 1 ], [ 0, 0, 0 ], 0));
								}
							}
						} else {
							throw STD.errors.user('Unknown layoutId in plinth');
						}
					} else if (surface > 25) {
						if (layoutId === 'shape-no-wall') {
							return (ViewerNS.Component.mtx([ 1, 1, 1 ], [ 0, 0, 0 ], 0));
						} else if (layoutId === 'shape-back-left') {
							if (partitionHeadsPosition === 'left') {
								if (side === 'left') {
									return (ViewerNS.Component.mtx([ -(x / 2), 0, z / 2 ], [ 1, 1, 1 ], 90));
								} else if (side === 'back') {
									return (ViewerNS.Component.mtx([ -(x / 2), 0, -z / 2 ], [ 1, 1, 1 ], 0));
								} else if (side === 'left-leftPlinth') {
									return (ViewerNS.Component.mtx(
										[ boundingBoxPartitions, 0, 0 ],
										[ z / 3 - boundingBoxPartitions, 1, 1 ],
										0
									));
								} else if (side === 'left-middlePlinth') {
									return (ViewerNS.Component.mtx([ z / 3, 0, 0 ], [ z / 3, 1, 1 ], 0));
								} else if (side === 'left-rightPlinth') {
									return (ViewerNS.Component.mtx([ 2 * z / 3, 0, 0 ], [ z / 3 - boundingBoxCorner.depth, 1, 1 ], 0));
								} else if (side === 'back-leftPlinthOpened') {
									return (ViewerNS.Component.mtx(
										[ boundingBoxCorner.width, 0, 0 ],
										[ x / 3 - boundingBoxCorner.width, 1, 1 ],
										0
									));
								} else if (side === 'back-middlePlinth') {
									return (ViewerNS.Component.mtx([ x / 3, 0, 0 ], [ x / 3, 1, 1 ], 0));
								} else if (side === 'back-rightPlinthClosed') {
									return (ViewerNS.Component.mtx([ 2 * x / 3, 0, 0 ], [ x / 3, 1, 1 ], 0));
								} else if (side === 'back-cornerLeftPlinth') {
									return (ViewerNS.Component.mtx([ 0, 0, 0 ], [ 1, 1, 1 ], 0));
								} else {
									return (ViewerNS.Component.mtx([ 1, 1, 1 ], [ 0, 0, 0 ], 0));
								}
							} else if (partitionHeadsPosition === 'back') {
								if (side === 'left') {
									return (ViewerNS.Component.mtx([ -(x / 2), 0, z / 2 ], [ 1, 1, 1 ], 90));
								} else if (side === 'back') {
									return (ViewerNS.Component.mtx([ -(x / 2), 0, -z / 2 ], [ 1, 1, 1 ], 0));
								} else if (side === 'left-leftPlinth') {
									return (ViewerNS.Component.mtx([ 0, 0, 0 ], [ z / 3, 1, 1 ], 0));
								} else if (side === 'left-middlePlinth') {
									return (ViewerNS.Component.mtx([ z / 3, 0, 0 ], [ z / 3, 1, 1 ], 0));
								} else if (side === 'left-rightPlinth') {
									return (ViewerNS.Component.mtx([ 2 * z / 3, 0, 0 ], [ z / 3 - boundingBoxCorner.depth, 1, 1 ], 0));
								} else if (side === 'back-leftPlinthOpened') {
									return (ViewerNS.Component.mtx(
										[ boundingBoxCorner.width, 0, 0 ],
										[ x / 3 - boundingBoxCorner.width, 1, 1 ],
										0
									));
								} else if (side === 'back-middlePlinth') {
									return (ViewerNS.Component.mtx([ x / 3, 0, 0 ], [ x / 3, 1, 1 ], 0));
								} else if (side === 'back-rightPlinthClosed') {
									return (ViewerNS.Component.mtx([ 2 * x / 3, 0, 0 ], [ x / 3 - boundingBoxPartitions, 1, 1 ], 0));
								} else if (side === 'back-cornerLeftPlinth') {
									return (ViewerNS.Component.mtx([ 0, 0, 0 ], [ 1, 1, 1 ], 0));
								} else {
									return (ViewerNS.Component.mtx([ 1, 1, 1 ], [ 0, 0, 0 ], 0));
								}
							} else if (partitionHeadsPosition === 'back-left') {
								if (side === 'left') {
									return (ViewerNS.Component.mtx([ -(x / 2), 0, z / 2 ], [ 1, 1, 1 ], 90));
								} else if (side === 'back') {
									return (ViewerNS.Component.mtx([ -(x / 2), 0, -z / 2 ], [ 1, 1, 1 ], 0));
								} else if (side === 'left-leftPlinth') {
									return (ViewerNS.Component.mtx(
										[ boundingBoxPartitions, 0, 0 ],
										[ z / 3 - boundingBoxPartitions, 1, 1 ],
										0
									));
								} else if (side === 'left-middlePlinth') {
									return (ViewerNS.Component.mtx([ z / 3, 0, 0 ], [ z / 3, 1, 1 ], 0));
								} else if (side === 'left-rightPlinth') {
									return (ViewerNS.Component.mtx([ 2 * z / 3, 0, 0 ], [ z / 3 - boundingBoxCorner.depth, 1, 1 ], 0));
								} else if (side === 'back-leftPlinthOpened') {
									return (ViewerNS.Component.mtx(
										[ boundingBoxCorner.width, 0, 0 ],
										[ x / 3 - boundingBoxCorner.width, 1, 1 ],
										0
									));
								} else if (side === 'back-middlePlinth') {
									return (ViewerNS.Component.mtx([ x / 3, 0, 0 ], [ x / 3, 1, 1 ], 0));
								} else if (side === 'back-rightPlinthClosed') {
									return (ViewerNS.Component.mtx([ 2 * x / 3, 0, 0 ], [ x / 3 - boundingBoxPartitions, 1, 1 ], 0));
								} else if (side === 'back-cornerLeftPlinth') {
									return (ViewerNS.Component.mtx([ 0, 0, 0 ], [ 1, 1, 1 ], 0));
								} else {
									return (ViewerNS.Component.mtx([ 1, 1, 1 ], [ 0, 0, 0 ], 0));
								}
							} else {
								if (side === 'left') {
									return (ViewerNS.Component.mtx([ -(x / 2), 0, z / 2 ], [ 1, 1, 1 ], 90));
								} else if (side === 'back') {
									return (ViewerNS.Component.mtx([ -(x / 2), 0, -z / 2 ], [ 1, 1, 1 ], 0));
								} else if (side === 'left-leftPlinth') {
									return (ViewerNS.Component.mtx([ 0, 0, 0 ], [ z / 3, 1, 1 ], 0));
								} else if (side === 'left-middlePlinth') {
									return (ViewerNS.Component.mtx([ z / 3, 0, 0 ], [ z / 3, 1, 1 ], 0));
								} else if (side === 'left-rightPlinth') {
									return (ViewerNS.Component.mtx([ 2 * z / 3, 0, 0 ], [ z / 3 - boundingBoxCorner.depth, 1, 1 ], 0));
								} else if (side === 'back-leftPlinthOpened') {
									return (ViewerNS.Component.mtx(
										[ boundingBoxCorner.width, 0, 0 ],
										[ x / 3 - boundingBoxCorner.width, 1, 1 ],
										0
									));
								} else if (side === 'back-middlePlinth') {
									return (ViewerNS.Component.mtx([ x / 3, 0, 0 ], [ x / 3, 1, 1 ], 0));
								} else if (side === 'back-rightPlinthClosed') {
									return (ViewerNS.Component.mtx([ 2 * x / 3, 0, 0 ], [ x / 3, 1, 1 ], 0));
								} else if (side === 'back-cornerLeftPlinth') {
									return (ViewerNS.Component.mtx([ 0, 0, 0 ], [ 1, 1, 1 ], 0));
								} else {
									return (ViewerNS.Component.mtx([ 1, 1, 1 ], [ 0, 0, 0 ], 0));
								}
							}
						} else if (layoutId === 'shape-back') {
							if (partitionHeadsPosition === 'back') {
								if (side === 'back') {
									return (ViewerNS.Component.mtx([ -(x / 2), 0, -z / 2 ], [ 1, 1, 1 ], 0));
								} else if (side === 'back-leftPlinthClosed') {
									return (ViewerNS.Component.mtx(
										[ boundingBoxPartitions, 0, 0 ],
										[ x / 3 - boundingBoxPartitions, 1, 1 ],
										0
									));
								} else if (side === 'back-middlePlinth') {
									return (ViewerNS.Component.mtx([ x / 3, 0, 0 ], [ x / 3, 1, 1 ], 0));
								} else if (side === 'back-rightPlinthClosed') {
									return (ViewerNS.Component.mtx([ 2 * x / 3, 0, 0 ], [ x / 3, 1, 1 ], 0));
								} else {
									return (ViewerNS.Component.mtx([ 1, 1, 1 ], [ 0, 0, 0 ], 0));
								}
							} else if (partitionHeadsPosition === 'back-back') {
								if (side === 'back') {
									return (ViewerNS.Component.mtx([ -(x / 2), 0, -z / 2 ], [ 1, 1, 1 ], 0));
								} else if (side === 'back-leftPlinthClosed') {
									return (ViewerNS.Component.mtx(
										[ boundingBoxPartitions, 0, 0 ],
										[ x / 3 - boundingBoxPartitions, 1, 1 ],
										0
									));
								} else if (side === 'back-middlePlinth') {
									return (ViewerNS.Component.mtx([ x / 3, 0, 0 ], [ x / 3, 1, 1 ], 0));
								} else if (side === 'back-rightPlinthClosed') {
									return (ViewerNS.Component.mtx([ 2 * x / 3, 0, 0 ], [ x / 3 - boundingBoxPartitions, 1, 1 ], 0));
								} else {
									return (ViewerNS.Component.mtx([ 1, 1, 1 ], [ 0, 0, 0 ], 0));
								}
							} else {
								if (side === 'back') {
									return (ViewerNS.Component.mtx([ -(x / 2), 0, -z / 2 ], [ 1, 1, 1 ], 0));
								} else if (side === 'back-leftPlinthClosed') {
									return (ViewerNS.Component.mtx([ 0, 0, 0 ], [ x / 3, 1, 1 ], 0));
								} else if (side === 'back-middlePlinth') {
									return (ViewerNS.Component.mtx([ x / 3, 0, 0 ], [ x / 3, 1, 1 ], 0));
								} else if (side === 'back-rightPlinthClosed') {
									return (ViewerNS.Component.mtx([ 2 * x / 3, 0, 0 ], [ x / 3, 1, 1 ], 0));
								} else {
									return (ViewerNS.Component.mtx([ 1, 1, 1 ], [ 0, 0, 0 ], 0));
								}
							}

						} else if (layoutId === 'shape-back-right') {
							if (partitionHeadsPosition === 'back') {
								if (side === 'right') {
									return (ViewerNS.Component.mtx([ (x / 2), 0, -z / 2 ], [ 1, 1, 1 ], 270));
								} else if (side === 'back') {
									return (ViewerNS.Component.mtx([ -(x / 2), 0, -z / 2 ], [ 1, 1, 1 ], 0));
								} else if (side === 'right-leftPlinth') {
									return (ViewerNS.Component.mtx(
										[ boundingBoxCorner.width, 0, 0 ],
										[ z / 3 - boundingBoxCorner.width, 1, 1 ],
										0
									));
								} else if (side === 'right-middlePlinth') {
									return (ViewerNS.Component.mtx([ z / 3, 0, 0 ], [ z / 3, 1, 1 ], 0));
								} else if (side === 'right-rightPlinth') {
									return (ViewerNS.Component.mtx([ 2 * z / 3, 0, 0 ], [ z / 3, 1, 1 ], 0));
								} else if (side === 'back-leftPlinthClosed') {
									return (ViewerNS.Component.mtx(
										[ boundingBoxPartitions, 0, 0 ],
										[ x / 3 - boundingBoxPartitions, 1, 1 ],
										0
									));
								} else if (side === 'back-middlePlinth') {
									return (ViewerNS.Component.mtx([ x / 3, 0, 0 ], [ x / 3, 1, 1 ], 0));
								} else if (side === 'back-rightPlinthOpened') {
									return (ViewerNS.Component.mtx([ 2 * x / 3, 0, 0 ], [ x / 3 - boundingBoxCorner.depth, 1, 1 ], 0));
								} else if (side === 'back-cornerRightPlinth') {
									return (ViewerNS.Component.mtx([ x, 0, 0 ], [ 1, 1, 1 ], 270));
								} else {
									return (ViewerNS.Component.mtx([ 1, 1, 1 ], [ 0, 0, 0 ], 0));
								}
							} else if (partitionHeadsPosition === 'back-right') {
								if (side === 'right') {
									return (ViewerNS.Component.mtx([ (x / 2), 0, -z / 2 ], [ 1, 1, 1 ], 270));
								} else if (side === 'back') {
									return (ViewerNS.Component.mtx([ -(x / 2), 0, -z / 2 ], [ 1, 1, 1 ], 0));
								} else if (side === 'right-leftPlinth') {
									return (ViewerNS.Component.mtx(
										[ boundingBoxCorner.width, 0, 0 ],
										[ z / 3 - boundingBoxCorner.width, 1, 1 ],
										0
									));
								} else if (side === 'right-middlePlinth') {
									return (ViewerNS.Component.mtx([ z / 3, 0, 0 ], [ z / 3, 1, 1 ], 0));
								} else if (side === 'right-rightPlinth') {
									return (ViewerNS.Component.mtx([ 2 * z / 3, 0, 0 ], [ z / 3 - boundingBoxPartitions, 1, 1 ], 0));
								} else if (side === 'back-leftPlinthClosed') {
									return (ViewerNS.Component.mtx(
										[ boundingBoxPartitions, 0, 0 ],
										[ x / 3 - boundingBoxPartitions, 1, 1 ],
										0
									));
								} else if (side === 'back-middlePlinth') {
									return (ViewerNS.Component.mtx([ x / 3, 0, 0 ], [ x / 3, 1, 1 ], 0));
								} else if (side === 'back-rightPlinthOpened') {
									return (ViewerNS.Component.mtx([ 2 * x / 3, 0, 0 ], [ x / 3 - boundingBoxCorner.depth, 1, 1 ], 0));
								} else if (side === 'back-cornerRightPlinth') {
									return (ViewerNS.Component.mtx([ x, 0, 0 ], [ 1, 1, 1 ], 270));
								} else {
									return (ViewerNS.Component.mtx([ 1, 1, 1 ], [ 0, 0, 0 ], 0));
								}
							} else {
								if (side === 'right') {
									return (ViewerNS.Component.mtx([ (x / 2), 0, -z / 2 ], [ 1, 1, 1 ], 270));
								} else if (side === 'back') {
									return (ViewerNS.Component.mtx([ -(x / 2), 0, -z / 2 ], [ 1, 1, 1 ], 0));
								} else if (side === 'right-leftPlinth') {
									return (ViewerNS.Component.mtx(
										[ boundingBoxCorner.width, 0, 0 ],
										[ z / 3 - boundingBoxCorner.width, 1, 1 ],
										0
									));
								} else if (side === 'right-middlePlinth') {
									return (ViewerNS.Component.mtx([ z / 3, 0, 0 ], [ z / 3, 1, 1 ], 0));
								} else if (side === 'right-rightPlinth') {
									return (ViewerNS.Component.mtx([ 2 * z / 3, 0, 0 ], [ z / 3, 1, 1 ], 0));
								} else if (side === 'back-leftPlinthClosed') {
									return (ViewerNS.Component.mtx([ 0, 0, 0 ], [ x / 3, 1, 1 ], 0));
								} else if (side === 'back-middlePlinth') {
									return (ViewerNS.Component.mtx([ x / 3, 0, 0 ], [ x / 3, 1, 1 ], 0));
								} else if (side === 'back-rightPlinthOpened') {
									return (ViewerNS.Component.mtx([ 2 * x / 3, 0, 0 ], [ x / 3 - boundingBoxCorner.depth, 1, 1 ], 0));
								} else if (side === 'back-cornerRightPlinth') {
									return (ViewerNS.Component.mtx([ x, 0, 0 ], [ 1, 1, 1 ], 270));
								} else {
									return (ViewerNS.Component.mtx([ 1, 1, 1 ], [ 0, 0, 0 ], 0));
								}
							}
						} else if (layoutId === 'shape-left-back-right') {
							if (partitionHeadsPosition === 'left') {
								if (side === 'left') {
									return (ViewerNS.Component.mtx([ -(x / 2), 0, z / 2 ], [ 1, 1, 1 ], 90));
								} else if (side === 'back') {
									return (ViewerNS.Component.mtx([ -(x / 2), 0, -z / 2 ], [ 1, 1, 1 ], 0));
								} else if (side === 'right') {
									return (ViewerNS.Component.mtx([ (x / 2), 0, -z / 2 ], [ 1, 1, 1 ], 270));
								} else if (side === 'left-leftPlinth') {
									return (ViewerNS.Component.mtx(
										[ boundingBoxPartitions, 0, 0 ],
										[ z / 3 - boundingBoxPartitions, 1, 1 ],
										0
									));
								} else if (side === 'left-middlePlinth') {
									return (ViewerNS.Component.mtx([ z / 3, 0, 0 ], [ z / 3, 1, 1 ], 0));
								} else if (side === 'left-rightPlinth') {
									return (ViewerNS.Component.mtx([ 2 * z / 3, 0, 0 ], [ z / 3 - boundingBoxCorner.depth, 1, 1 ], 0));
								} else if (side === 'back-cornerLeftPlinth') {
									return (ViewerNS.Component.mtx([ 0, 0, 0 ], [ 1, 1, 1 ], 0));
								} else if (side === 'back-leftPlinthOpened') {
									return (ViewerNS.Component.mtx(
										[ boundingBoxCorner.width, 0, 0 ],
										[ x / 3 - boundingBoxCorner.width, 1, 1 ],
										0
									));
								} else if (side === 'back-middlePlinth') {
									return (ViewerNS.Component.mtx([ x / 3, 0, 0 ], [ x / 3, 1, 1 ], 0));
								} else if (side === 'back-rightPlinthOpened') {
									return (ViewerNS.Component.mtx([ 2 * x / 3, 0, 0 ], [ x / 3 - boundingBoxCorner.depth, 1, 1 ], 0));
								} else if (side === 'back-cornerRightPlinth') {
									return (ViewerNS.Component.mtx([ x, 0, 0 ], [ 1, 1, 1 ], 270));
								} else if (side === 'right-leftPlinth') {
									return (ViewerNS.Component.mtx(
										[ boundingBoxCorner.width, 0, 0 ],
										[ z / 3 - boundingBoxCorner.width, 1, 1 ],
										0
									));
								} else if (side === 'right-middlePlinth') {
									return (ViewerNS.Component.mtx([ z / 3, 0, 0 ], [ z / 3, 1, 1 ], 0));
								} else if (side === 'right-rightPlinth') {
									return (ViewerNS.Component.mtx([ 2 * z / 3, 0, 0 ], [ z / 3, 1, 1 ], 0));
								} else {
									return (ViewerNS.Component.mtx([ 1, 1, 1 ], [ 0, 0, 0 ], 0));
								}
							} else if (partitionHeadsPosition === 'left-right') {
								if (side === 'left') {
									return (ViewerNS.Component.mtx([ -(x / 2), 0, z / 2 ], [ 1, 1, 1 ], 90));
								} else if (side === 'back') {
									return (ViewerNS.Component.mtx([ -(x / 2), 0, -z / 2 ], [ 1, 1, 1 ], 0));
								} else if (side === 'right') {
									return (ViewerNS.Component.mtx([ (x / 2), 0, -z / 2 ], [ 1, 1, 1 ], 270));
								} else if (side === 'left-leftPlinth') {
									return (ViewerNS.Component.mtx(
										[ boundingBoxPartitions, 0, 0 ],
										[ z / 3 - boundingBoxPartitions, 1, 1 ],
										0
									));
								} else if (side === 'left-middlePlinth') {
									return (ViewerNS.Component.mtx([ z / 3, 0, 0 ], [ z / 3, 1, 1 ], 0));
								} else if (side === 'left-rightPlinth') {
									return (ViewerNS.Component.mtx([ 2 * z / 3, 0, 0 ], [ z / 3 - boundingBoxCorner.depth, 1, 1 ], 0));
								} else if (side === 'back-cornerLeftPlinth') {
									return (ViewerNS.Component.mtx([ 0, 0, 0 ], [ 1, 1, 1 ], 0));
								} else if (side === 'back-leftPlinthOpened') {
									return (ViewerNS.Component.mtx(
										[ boundingBoxCorner.width, 0, 0 ],
										[ x / 3 - boundingBoxCorner.width, 1, 1 ],
										0
									));
								} else if (side === 'back-middlePlinth') {
									return (ViewerNS.Component.mtx([ x / 3, 0, 0 ], [ x / 3, 1, 1 ], 0));
								} else if (side === 'back-rightPlinthOpened') {
									return (ViewerNS.Component.mtx([ 2 * x / 3, 0, 0 ], [ x / 3 - boundingBoxCorner.depth, 1, 1 ], 0));
								} else if (side === 'back-cornerRightPlinth') {
									return (ViewerNS.Component.mtx([ x, 0, 0 ], [ 1, 1, 1 ], 270));
								} else if (side === 'right-leftPlinth') {
									return (ViewerNS.Component.mtx(
										[ boundingBoxCorner.width, 0, 0 ],
										[ z / 3 - boundingBoxCorner.width, 1, 1 ],
										0
									));
								} else if (side === 'right-middlePlinth') {
									return (ViewerNS.Component.mtx([ z / 3, 0, 0 ], [ z / 3, 1, 1 ], 0));
								} else if (side === 'right-rightPlinth') {
									return (ViewerNS.Component.mtx([ 2 * z / 3, 0, 0 ], [ z / 3 - boundingBoxPartitions, 1, 1 ], 0));
								} else {
									return (ViewerNS.Component.mtx([ 1, 1, 1 ], [ 0, 0, 0 ], 0));
								}
							} else {
								if (side === 'left') {
									return (ViewerNS.Component.mtx([ -(x / 2), 0, z / 2 ], [ 1, 1, 1 ], 90));
								} else if (side === 'back') {
									return (ViewerNS.Component.mtx([ -(x / 2), 0, -z / 2 ], [ 1, 1, 1 ], 0));
								} else if (side === 'right') {
									return (ViewerNS.Component.mtx([ (x / 2), 0, -z / 2 ], [ 1, 1, 1 ], 270));
								} else if (side === 'left-leftPlinth') {
									return (ViewerNS.Component.mtx([ 0, 0, 0 ], [ z / 3, 1, 1 ], 0));
								} else if (side === 'left-middlePlinth') {
									return (ViewerNS.Component.mtx([ z / 3, 0, 0 ], [ z / 3, 1, 1 ], 0));
								} else if (side === 'left-rightPlinth') {
									return (ViewerNS.Component.mtx([ 2 * z / 3, 0, 0 ], [ z / 3 - boundingBoxCorner.depth, 1, 1 ], 0));
								} else if (side === 'back-cornerLeftPlinth') {
									return (ViewerNS.Component.mtx([ 0, 0, 0 ], [ 1, 1, 1 ], 0));
								} else if (side === 'back-leftPlinthOpened') {
									return (ViewerNS.Component.mtx(
										[ boundingBoxCorner.width, 0, 0 ],
										[ x / 3 - boundingBoxCorner.width, 1, 1 ],
										0
									));
								} else if (side === 'back-middlePlinth') {
									return (ViewerNS.Component.mtx([ x / 3, 0, 0 ], [ x / 3, 1, 1 ], 0));
								} else if (side === 'back-rightPlinthOpened') {
									return (ViewerNS.Component.mtx([ 2 * x / 3, 0, 0 ], [ x / 3 - boundingBoxCorner.depth, 1, 1 ], 0));
								} else if (side === 'back-cornerRightPlinth') {
									return (ViewerNS.Component.mtx([ x, 0, 0 ], [ 1, 1, 1 ], 270));
								} else if (side === 'right-leftPlinth') {
									return (ViewerNS.Component.mtx(
										[ boundingBoxCorner.width, 0, 0 ],
										[ z / 3 - boundingBoxCorner.width, 1, 1 ],
										0
									));
								} else if (side === 'right-middlePlinth') {
									return (ViewerNS.Component.mtx([ z / 3, 0, 0 ], [ z / 3, 1, 1 ], 0));
								} else if (side === 'right-rightPlinth') {
									return (ViewerNS.Component.mtx([ 2 * z / 3, 0, 0 ], [ z / 3, 1, 1 ], 0));
								} else {
									return (ViewerNS.Component.mtx([ 1, 1, 1 ], [ 0, 0, 0 ], 0));
								}
							}
						} else {
							throw STD.errors.user('Unknown layoutId in plinth');
						}
					} else if (surface > 11) {
						if (layoutId === 'shape-no-wall') {
							return (ViewerNS.Component.mtx([ 1, 1, 1 ], [ 0, 0, 0 ], 0));
						} else if (layoutId === 'shape-back-left') {
							if (partitionHeadsPosition === 'left') {
								if (side === 'left') {
									return (ViewerNS.Component.mtx([ -(x / 2), 0, z / 2 ], [ 1, 1, 1 ], 90));
								} else if (side === 'back') {
									return (ViewerNS.Component.mtx([ -(x / 2), 0, -z / 2 ], [ 1, 1, 1 ], 0));
								} else if (side === 'left-leftPlinth') {
									return (ViewerNS.Component.mtx(
										[ boundingBoxPartitions, 0, 0 ],
										[ z / 3 - boundingBoxPartitions, 1, 1 ],
										0
									));
								} else if (side === 'left-middlePlinth') {
									return (ViewerNS.Component.mtx([ z / 3, 0, 0 ], [ z / 3, 1, 1 ], 0));
								} else if (side === 'left-rightPlinth') {
									return (ViewerNS.Component.mtx([ 2 * z / 3, 0, 0 ], [ z / 3 - boundingBoxCorner.depth, 1, 1 ], 0));
								} else if (side === 'back-leftPlinthOpened') {
									return (ViewerNS.Component.mtx(
										[ boundingBoxCorner.width, 0, 0 ],
										[ x / 3 - boundingBoxCorner.width, 1, 1 ],
										0
									));
								} else if (side === 'back-middlePlinth') {
									return (ViewerNS.Component.mtx([ x / 3, 0, 0 ], [ x / 3, 1, 1 ], 0));
								} else if (side === 'back-rightPlinthClosed') {
									return (ViewerNS.Component.mtx([ 2 * x / 3, 0, 0 ], [ x / 3, 1, 1 ], 0));
								} else if (side === 'back-cornerLeftPlinth') {
									return (ViewerNS.Component.mtx([ 0, 0, 0 ], [ 1, 1, 1 ], 0));
								} else {
									return (ViewerNS.Component.mtx([ 1, 1, 1 ], [ 0, 0, 0 ], 0));
								}
							} else if (partitionHeadsPosition === 'back') {
								if (side === 'left') {
									return (ViewerNS.Component.mtx([ -(x / 2), 0, z / 2 ], [ 1, 1, 1 ], 90));
								} else if (side === 'back') {
									return (ViewerNS.Component.mtx([ -(x / 2), 0, -z / 2 ], [ 1, 1, 1 ], 0));
								} else if (side === 'left-leftPlinth') {
									return (ViewerNS.Component.mtx([ 0, 0, 0 ], [ z / 3, 1, 1 ], 0));
								} else if (side === 'left-middlePlinth') {
									return (ViewerNS.Component.mtx([ z / 3, 0, 0 ], [ z / 3, 1, 1 ], 0));
								} else if (side === 'left-rightPlinth') {
									return (ViewerNS.Component.mtx([ 2 * z / 3, 0, 0 ], [ z / 3 - boundingBoxCorner.depth, 1, 1 ], 0));
								} else if (side === 'back-leftPlinthOpened') {
									return (ViewerNS.Component.mtx(
										[ boundingBoxCorner.width, 0, 0 ],
										[ x / 3 - boundingBoxCorner.width, 1, 1 ],
										0
									));
								} else if (side === 'back-middlePlinth') {
									return (ViewerNS.Component.mtx([ x / 3, 0, 0 ], [ x / 3, 1, 1 ], 0));
								} else if (side === 'back-rightPlinthClosed') {
									return (ViewerNS.Component.mtx([ 2 * x / 3, 0, 0 ], [ x / 3 - boundingBoxPartitions, 1, 1 ], 0));
								} else if (side === 'back-cornerLeftPlinth') {
									return (ViewerNS.Component.mtx([ 0, 0, 0 ], [ 1, 1, 1 ], 0));
								} else {
									return (ViewerNS.Component.mtx([ 1, 1, 1 ], [ 0, 0, 0 ], 0));
								}
							} else if (partitionHeadsPosition === 'back-left') {
								if (side === 'left') {
									return (ViewerNS.Component.mtx([ -(x / 2), 0, z / 2 ], [ 1, 1, 1 ], 90));
								} else if (side === 'back') {
									return (ViewerNS.Component.mtx([ -(x / 2), 0, -z / 2 ], [ 1, 1, 1 ], 0));
								} else if (side === 'left-leftPlinth') {
									return (ViewerNS.Component.mtx(
										[ boundingBoxPartitions, 0, 0 ],
										[ z / 3 - boundingBoxPartitions, 1, 1 ],
										0
									));
								} else if (side === 'left-middlePlinth') {
									return (ViewerNS.Component.mtx([ z / 3, 0, 0 ], [ z / 3, 1, 1 ], 0));
								} else if (side === 'left-rightPlinth') {
									return (ViewerNS.Component.mtx([ 2 * z / 3, 0, 0 ], [ z / 3 - boundingBoxCorner.depth, 1, 1 ], 0));
								} else if (side === 'back-leftPlinthOpened') {
									return (ViewerNS.Component.mtx(
										[ boundingBoxCorner.width, 0, 0 ],
										[ x / 3 - boundingBoxCorner.width, 1, 1 ],
										0
									));
								} else if (side === 'back-middlePlinth') {
									return (ViewerNS.Component.mtx([ x / 3, 0, 0 ], [ x / 3, 1, 1 ], 0));
								} else if (side === 'back-rightPlinthClosed') {
									return (ViewerNS.Component.mtx([ 2 * x / 3, 0, 0 ], [ x / 3 - boundingBoxPartitions, 1, 1 ], 0));
								} else if (side === 'back-cornerLeftPlinth') {
									return (ViewerNS.Component.mtx([ 0, 0, 0 ], [ 1, 1, 1 ], 0));
								} else {
									return (ViewerNS.Component.mtx([ 1, 1, 1 ], [ 0, 0, 0 ], 0));
								}
							} else {
								if (side === 'left') {
									return (ViewerNS.Component.mtx([ -(x / 2), 0, z / 2 ], [ 1, 1, 1 ], 90));
								} else if (side === 'back') {
									return (ViewerNS.Component.mtx([ -(x / 2), 0, -z / 2 ], [ 1, 1, 1 ], 0));
								} else if (side === 'left-leftPlinth') {
									return (ViewerNS.Component.mtx([ 0, 0, 0 ], [ z / 3, 1, 1 ], 0));
								} else if (side === 'left-middlePlinth') {
									return (ViewerNS.Component.mtx([ z / 3, 0, 0 ], [ z / 3, 1, 1 ], 0));
								} else if (side === 'left-rightPlinth') {
									return (ViewerNS.Component.mtx([ 2 * z / 3, 0, 0 ], [ z / 3 - boundingBoxCorner.depth, 1, 1 ], 0));
								} else if (side === 'back-leftPlinthOpened') {
									return (ViewerNS.Component.mtx(
										[ boundingBoxCorner.width, 0, 0 ],
										[ x / 3 - boundingBoxCorner.width, 1, 1 ],
										0
									));
								} else if (side === 'back-middlePlinth') {
									return (ViewerNS.Component.mtx([ x / 3, 0, 0 ], [ x / 3, 1, 1 ], 0));
								} else if (side === 'back-rightPlinthClosed') {
									return (ViewerNS.Component.mtx([ 2 * x / 3, 0, 0 ], [ x / 3, 1, 1 ], 0));
								} else if (side === 'back-cornerLeftPlinth') {
									return (ViewerNS.Component.mtx([ 0, 0, 0 ], [ 1, 1, 1 ], 0));
								} else {
									return (ViewerNS.Component.mtx([ 1, 1, 1 ], [ 0, 0, 0 ], 0));
								}
							}
						} else if (layoutId === 'shape-back') {
							if (partitionHeadsPosition === 'back') {
								if (side === 'back') {
									return (ViewerNS.Component.mtx([ -(x / 2), 0, -z / 2 ], [ 1, 1, 1 ], 0));
								} else if (side === 'back-leftPlinthClosed') {
									return (ViewerNS.Component.mtx(
										[ boundingBoxPartitions, 0, 0 ],
										[ x / 3 - boundingBoxPartitions, 1, 1 ],
										0
									));
								} else if (side === 'back-middlePlinth') {
									return (ViewerNS.Component.mtx([ x / 3, 0, 0 ], [ x / 3, 1, 1 ], 0));
								} else if (side === 'back-rightPlinthClosed') {
									return (ViewerNS.Component.mtx([ 2 * x / 3, 0, 0 ], [ x / 3, 1, 1 ], 0));
								} else {
									return (ViewerNS.Component.mtx([ 1, 1, 1 ], [ 0, 0, 0 ], 0));
								}
							} else if (partitionHeadsPosition === 'back-back') {
								if (side === 'back') {
									return (ViewerNS.Component.mtx([ -(x / 2), 0, -z / 2 ], [ 1, 1, 1 ], 0));
								} else if (side === 'back-leftPlinthClosed') {
									return (ViewerNS.Component.mtx(
										[ boundingBoxPartitions, 0, 0 ],
										[ x / 3 - boundingBoxPartitions, 1, 1 ],
										0
									));
								} else if (side === 'back-middlePlinth') {
									return (ViewerNS.Component.mtx([ x / 3, 0, 0 ], [ x / 3, 1, 1 ], 0));
								} else if (side === 'back-rightPlinthClosed') {
									return (ViewerNS.Component.mtx([ 2 * x / 3, 0, 0 ], [ x / 3 - boundingBoxPartitions, 1, 1 ], 0));
								} else {
									return (ViewerNS.Component.mtx([ 1, 1, 1 ], [ 0, 0, 0 ], 0));
								}
							} else {
								if (side === 'back') {
									return (ViewerNS.Component.mtx([ -(x / 2), 0, -z / 2 ], [ 1, 1, 1 ], 0));
								} else if (side === 'back-leftPlinthClosed') {
									return (ViewerNS.Component.mtx([ 0, 0, 0 ], [ x / 3, 1, 1 ], 0));
								} else if (side === 'back-middlePlinth') {
									return (ViewerNS.Component.mtx([ x / 3, 0, 0 ], [ x / 3, 1, 1 ], 0));
								} else if (side === 'back-rightPlinthClosed') {
									return (ViewerNS.Component.mtx([ 2 * x / 3, 0, 0 ], [ x / 3, 1, 1 ], 0));
								} else {
									return (ViewerNS.Component.mtx([ 1, 1, 1 ], [ 0, 0, 0 ], 0));
								}
							}

						} else if (layoutId === 'shape-back-right') {
							if (partitionHeadsPosition === 'back') {
								if (side === 'right') {
									return (ViewerNS.Component.mtx([ (x / 2), 0, -z / 2 ], [ 1, 1, 1 ], 270));
								} else if (side === 'back') {
									return (ViewerNS.Component.mtx([ -(x / 2), 0, -z / 2 ], [ 1, 1, 1 ], 0));
								} else if (side === 'right-leftPlinth') {
									return (ViewerNS.Component.mtx(
										[ boundingBoxCorner.width, 0, 0 ],
										[ z / 3 - boundingBoxCorner.width, 1, 1 ],
										0
									));
								} else if (side === 'right-middlePlinth') {
									return (ViewerNS.Component.mtx([ z / 3, 0, 0 ], [ z / 3, 1, 1 ], 0));
								} else if (side === 'right-rightPlinth') {
									return (ViewerNS.Component.mtx([ 2 * z / 3, 0, 0 ], [ z / 3, 1, 1 ], 0));
								} else if (side === 'back-leftPlinthClosed') {
									return (ViewerNS.Component.mtx(
										[ boundingBoxPartitions, 0, 0 ],
										[ x / 3 - boundingBoxPartitions, 1, 1 ],
										0
									));
								} else if (side === 'back-middlePlinth') {
									return (ViewerNS.Component.mtx([ x / 3, 0, 0 ], [ x / 3, 1, 1 ], 0));
								} else if (side === 'back-rightPlinthOpened') {
									return (ViewerNS.Component.mtx([ 2 * x / 3, 0, 0 ], [ x / 3 - boundingBoxCorner.depth, 1, 1 ], 0));
								} else if (side === 'back-cornerRightPlinth') {
									return (ViewerNS.Component.mtx([ x, 0, 0 ], [ 1, 1, 1 ], 270));
								} else {
									return (ViewerNS.Component.mtx([ 1, 1, 1 ], [ 0, 0, 0 ], 0));
								}
							} else if (partitionHeadsPosition === 'back-right') {
								if (side === 'right') {
									return (ViewerNS.Component.mtx([ (x / 2), 0, -z / 2 ], [ 1, 1, 1 ], 270));
								} else if (side === 'back') {
									return (ViewerNS.Component.mtx([ -(x / 2), 0, -z / 2 ], [ 1, 1, 1 ], 0));
								} else if (side === 'right-leftPlinth') {
									return (ViewerNS.Component.mtx(
										[ boundingBoxCorner.width, 0, 0 ],
										[ z / 3 - boundingBoxCorner.width, 1, 1 ],
										0
									));
								} else if (side === 'right-middlePlinth') {
									return (ViewerNS.Component.mtx([ z / 3, 0, 0 ], [ z / 3, 1, 1 ], 0));
								} else if (side === 'right-rightPlinth') {
									return (ViewerNS.Component.mtx([ 2 * z / 3, 0, 0 ], [ z / 3 - boundingBoxPartitions, 1, 1 ], 0));
								} else if (side === 'back-leftPlinthClosed') {
									return (ViewerNS.Component.mtx(
										[ boundingBoxPartitions, 0, 0 ],
										[ x / 3 - boundingBoxPartitions, 1, 1 ],
										0
									));
								} else if (side === 'back-middlePlinth') {
									return (ViewerNS.Component.mtx([ x / 3, 0, 0 ], [ x / 3, 1, 1 ], 0));
								} else if (side === 'back-rightPlinthOpened') {
									return (ViewerNS.Component.mtx([ 2 * x / 3, 0, 0 ], [ x / 3 - boundingBoxCorner.depth, 1, 1 ], 0));
								} else if (side === 'back-cornerRightPlinth') {
									return (ViewerNS.Component.mtx([ x, 0, 0 ], [ 1, 1, 1 ], 270));
								} else {
									return (ViewerNS.Component.mtx([ 1, 1, 1 ], [ 0, 0, 0 ], 0));
								}
							} else {
								if (side === 'right') {
									return (ViewerNS.Component.mtx([ (x / 2), 0, -z / 2 ], [ 1, 1, 1 ], 270));
								} else if (side === 'back') {
									return (ViewerNS.Component.mtx([ -(x / 2), 0, -z / 2 ], [ 1, 1, 1 ], 0));
								} else if (side === 'right-leftPlinth') {
									return (ViewerNS.Component.mtx(
										[ boundingBoxCorner.width, 0, 0 ],
										[ z / 3 - boundingBoxCorner.width, 1, 1 ],
										0
									));
								} else if (side === 'right-middlePlinth') {
									return (ViewerNS.Component.mtx([ z / 3, 0, 0 ], [ z / 3, 1, 1 ], 0));
								} else if (side === 'right-rightPlinth') {
									return (ViewerNS.Component.mtx([ 2 * z / 3, 0, 0 ], [ z / 3, 1, 1 ], 0));
								} else if (side === 'back-leftPlinthClosed') {
									return (ViewerNS.Component.mtx([ 0, 0, 0 ], [ x / 3, 1, 1 ], 0));
								} else if (side === 'back-middlePlinth') {
									return (ViewerNS.Component.mtx([ x / 3, 0, 0 ], [ x / 3, 1, 1 ], 0));
								} else if (side === 'back-rightPlinthOpened') {
									return (ViewerNS.Component.mtx([ 2 * x / 3, 0, 0 ], [ x / 3 - boundingBoxCorner.depth, 1, 1 ], 0));
								} else if (side === 'back-cornerRightPlinth') {
									return (ViewerNS.Component.mtx([ x, 0, 0 ], [ 1, 1, 1 ], 270));
								} else {
									return (ViewerNS.Component.mtx([ 1, 1, 1 ], [ 0, 0, 0 ], 0));
								}
							}
						} else if (layoutId === 'shape-left-back-right') {
							if (partitionHeadsPosition === 'left') {
								if (side === 'left') {
									return (ViewerNS.Component.mtx([ -(x / 2), 0, z / 2 ], [ 1, 1, 1 ], 90));
								} else if (side === 'back') {
									return (ViewerNS.Component.mtx([ -(x / 2), 0, -z / 2 ], [ 1, 1, 1 ], 0));
								} else if (side === 'right') {
									return (ViewerNS.Component.mtx([ (x / 2), 0, -z / 2 ], [ 1, 1, 1 ], 270));
								} else if (side === 'left-leftPlinth') {
									return (ViewerNS.Component.mtx(
										[ boundingBoxPartitions, 0, 0 ],
										[ z / 3 - boundingBoxPartitions, 1, 1 ],
										0
									));
								} else if (side === 'left-middlePlinth') {
									return (ViewerNS.Component.mtx([ z / 3, 0, 0 ], [ z / 3, 1, 1 ], 0));
								} else if (side === 'left-rightPlinth') {
									return (ViewerNS.Component.mtx([ 2 * z / 3, 0, 0 ], [ z / 3 - boundingBoxCorner.depth, 1, 1 ], 0));
								} else if (side === 'back-cornerLeftPlinth') {
									return (ViewerNS.Component.mtx([ 0, 0, 0 ], [ 1, 1, 1 ], 0));
								} else if (side === 'back-leftPlinthOpened') {
									return (ViewerNS.Component.mtx(
										[ boundingBoxCorner.width, 0, 0 ],
										[ x / 3 - boundingBoxCorner.width, 1, 1 ],
										0
									));
								} else if (side === 'back-middlePlinth') {
									return (ViewerNS.Component.mtx([ x / 3, 0, 0 ], [ x / 3, 1, 1 ], 0));
								} else if (side === 'back-rightPlinthOpened') {
									return (ViewerNS.Component.mtx([ 2 * x / 3, 0, 0 ], [ x / 3 - boundingBoxCorner.depth, 1, 1 ], 0));
								} else if (side === 'back-cornerRightPlinth') {
									return (ViewerNS.Component.mtx([ x, 0, 0 ], [ 1, 1, 1 ], 270));
								} else if (side === 'right-leftPlinth') {
									return (ViewerNS.Component.mtx(
										[ boundingBoxCorner.width, 0, 0 ],
										[ z / 3 - boundingBoxCorner.width, 1, 1 ],
										0
									));
								} else if (side === 'right-middlePlinth') {
									return (ViewerNS.Component.mtx([ z / 3, 0, 0 ], [ z / 3, 1, 1 ], 0));
								} else if (side === 'right-rightPlinth') {
									return (ViewerNS.Component.mtx([ 2 * z / 3, 0, 0 ], [ z / 3, 1, 1 ], 0));
								} else {
									return (ViewerNS.Component.mtx([ 1, 1, 1 ], [ 0, 0, 0 ], 0));
								}
							} else if (partitionHeadsPosition === 'left-right') {
								if (side === 'left') {
									return (ViewerNS.Component.mtx([ -(x / 2), 0, z / 2 ], [ 1, 1, 1 ], 90));
								} else if (side === 'back') {
									return (ViewerNS.Component.mtx([ -(x / 2), 0, -z / 2 ], [ 1, 1, 1 ], 0));
								} else if (side === 'right') {
									return (ViewerNS.Component.mtx([ (x / 2), 0, -z / 2 ], [ 1, 1, 1 ], 270));
								} else if (side === 'left-leftPlinth') {
									return (ViewerNS.Component.mtx(
										[ boundingBoxPartitions, 0, 0 ],
										[ z / 3 - boundingBoxPartitions, 1, 1 ],
										0
									));
								} else if (side === 'left-middlePlinth') {
									return (ViewerNS.Component.mtx([ z / 3, 0, 0 ], [ z / 3, 1, 1 ], 0));
								} else if (side === 'left-rightPlinth') {
									return (ViewerNS.Component.mtx([ 2 * z / 3, 0, 0 ], [ z / 3 - boundingBoxCorner.depth, 1, 1 ], 0));
								} else if (side === 'back-cornerLeftPlinth') {
									return (ViewerNS.Component.mtx([ 0, 0, 0 ], [ 1, 1, 1 ], 0));
								} else if (side === 'back-leftPlinthOpened') {
									return (ViewerNS.Component.mtx(
										[ boundingBoxCorner.width, 0, 0 ],
										[ x / 3 - boundingBoxCorner.width, 1, 1 ],
										0
									));
								} else if (side === 'back-middlePlinth') {
									return (ViewerNS.Component.mtx([ x / 3, 0, 0 ], [ x / 3, 1, 1 ], 0));
								} else if (side === 'back-rightPlinthOpened') {
									return (ViewerNS.Component.mtx([ 2 * x / 3, 0, 0 ], [ x / 3 - boundingBoxCorner.depth, 1, 1 ], 0));
								} else if (side === 'back-cornerRightPlinth') {
									return (ViewerNS.Component.mtx([ x, 0, 0 ], [ 1, 1, 1 ], 270));
								} else if (side === 'right-leftPlinth') {
									return (ViewerNS.Component.mtx(
										[ boundingBoxCorner.width, 0, 0 ],
										[ z / 3 - boundingBoxCorner.width, 1, 1 ],
										0
									));
								} else if (side === 'right-middlePlinth') {
									return (ViewerNS.Component.mtx([ z / 3, 0, 0 ], [ z / 3, 1, 1 ], 0));
								} else if (side === 'right-rightPlinth') {
									return (ViewerNS.Component.mtx([ 2 * z / 3, 0, 0 ], [ z / 3 - boundingBoxPartitions, 1, 1 ], 0));
								} else {
									return (ViewerNS.Component.mtx([ 1, 1, 1 ], [ 0, 0, 0 ], 0));
								}
							} else {
								if (side === 'left') {
									return (ViewerNS.Component.mtx([ -(x / 2), 0, z / 2 ], [ 1, 1, 1 ], 90));
								} else if (side === 'back') {
									return (ViewerNS.Component.mtx([ -(x / 2), 0, -z / 2 ], [ 1, 1, 1 ], 0));
								} else if (side === 'right') {
									return (ViewerNS.Component.mtx([ (x / 2), 0, -z / 2 ], [ 1, 1, 1 ], 270));
								} else if (side === 'left-leftPlinth') {
									return (ViewerNS.Component.mtx([ 0, 0, 0 ], [ z / 3, 1, 1 ], 0));
								} else if (side === 'left-middlePlinth') {
									return (ViewerNS.Component.mtx([ z / 3, 0, 0 ], [ z / 3, 1, 1 ], 0));
								} else if (side === 'left-rightPlinth') {
									return (ViewerNS.Component.mtx([ 2 * z / 3, 0, 0 ], [ z / 3 - boundingBoxCorner.depth, 1, 1 ], 0));
								} else if (side === 'back-cornerLeftPlinth') {
									return (ViewerNS.Component.mtx([ 0, 0, 0 ], [ 1, 1, 1 ], 0));
								} else if (side === 'back-leftPlinthOpened') {
									return (ViewerNS.Component.mtx(
										[ boundingBoxCorner.width, 0, 0 ],
										[ x / 3 - boundingBoxCorner.width, 1, 1 ],
										0
									));
								} else if (side === 'back-middlePlinth') {
									return (ViewerNS.Component.mtx([ x / 3, 0, 0 ], [ x / 3, 1, 1 ], 0));
								} else if (side === 'back-rightPlinthOpened') {
									return (ViewerNS.Component.mtx([ 2 * x / 3, 0, 0 ], [ x / 3 - boundingBoxCorner.depth, 1, 1 ], 0));
								} else if (side === 'back-cornerRightPlinth') {
									return (ViewerNS.Component.mtx([ x, 0, 0 ], [ 1, 1, 1 ], 270));
								} else if (side === 'right-leftPlinth') {
									return (ViewerNS.Component.mtx(
										[ boundingBoxCorner.width, 0, 0 ],
										[ z / 3 - boundingBoxCorner.width, 1, 1 ],
										0
									));
								} else if (side === 'right-middlePlinth') {
									return (ViewerNS.Component.mtx([ z / 3, 0, 0 ], [ z / 3, 1, 1 ], 0));
								} else if (side === 'right-rightPlinth') {
									return (ViewerNS.Component.mtx([ 2 * z / 3, 0, 0 ], [ z / 3, 1, 1 ], 0));
								} else {
									return (ViewerNS.Component.mtx([ 1, 1, 1 ], [ 0, 0, 0 ], 0));
								}
							}
						} else {
							throw STD.errors.user('Unknown layoutId in plinth');
						}
					} else {
						return (ViewerNS.Component.mtx([ 1, 1, 1 ], [ 0, 0, 0 ], 0));
					}
				} else if (product.id === 'siae') {
					if (surface > 30) {
						if (layoutId === 'shape-no-wall') {
							return (ViewerNS.Component.mtx([ 1, 1, 1 ], [ 0, 0, 0 ], 0));
						} else if (layoutId === 'shape-back-left') {
							if (partitionHeadsPosition === 'left') {
								if (side === 'left') {
									return (ViewerNS.Component.mtx([ -(x / 2), 0, z / 2 ], [ 1, 1, 1 ], 90));
								} else if (side === 'back') {
									return (ViewerNS.Component.mtx([ -(x / 2), 0, -z / 2 ], [ 1, 1, 1 ], 0));
								} else if (side === 'left-leftPlinth') {
									return (ViewerNS.Component.mtx(
										[ boundingBoxPartitions, 0, 0 ],
										[ z / 3 - boundingBoxPartitions, 1, 1 ],
										0
									));
								} else if (side === 'left-middlePlinth') {
									return (ViewerNS.Component.mtx([ z / 3, 0, 0 ], [ z / 3, 1, 1 ], 0));
								} else if (side === 'left-rightPlinth') {
									return (ViewerNS.Component.mtx([ 2 * z / 3, 0, 0 ], [ z / 3 - boundingBoxCorner.depth, 1, 1 ], 0));
								} else if (side === 'back-leftPlinthOpened') {
									return (ViewerNS.Component.mtx(
										[ boundingBoxCorner.width, 0, 0 ],
										[ x / 3 - boundingBoxCorner.width, 1, 1 ],
										0
									));
								} else if (side === 'back-middlePlinth') {
									return (ViewerNS.Component.mtx([ x / 3, 0, 0 ], [ x / 3, 1, 1 ], 0));
								} else if (side === 'back-rightPlinthClosed') {
									return (ViewerNS.Component.mtx([ 2 * x / 3, 0, 0 ], [ x / 3, 1, 1 ], 0));
								} else if (side === 'back-cornerLeftPlinth') {
									return (ViewerNS.Component.mtx([ 0, 0, 0 ], [ 1, 1, 1 ], 0));
								} else {
									return (ViewerNS.Component.mtx([ 1, 1, 1 ], [ 0, 0, 0 ], 0));
								}
							} else if (partitionHeadsPosition === 'back') {
								if (side === 'left') {
									return (ViewerNS.Component.mtx([ -(x / 2), 0, z / 2 ], [ 1, 1, 1 ], 90));
								} else if (side === 'back') {
									return (ViewerNS.Component.mtx([ -(x / 2), 0, -z / 2 ], [ 1, 1, 1 ], 0));
								} else if (side === 'left-leftPlinth') {
									return (ViewerNS.Component.mtx([ 0, 0, 0 ], [ z / 3, 1, 1 ], 0));
								} else if (side === 'left-middlePlinth') {
									return (ViewerNS.Component.mtx([ z / 3, 0, 0 ], [ z / 3, 1, 1 ], 0));
								} else if (side === 'left-rightPlinth') {
									return (ViewerNS.Component.mtx([ 2 * z / 3, 0, 0 ], [ z / 3 - boundingBoxCorner.depth, 1, 1 ], 0));
								} else if (side === 'back-leftPlinthOpened') {
									return (ViewerNS.Component.mtx(
										[ boundingBoxCorner.width, 0, 0 ],
										[ x / 3 - boundingBoxCorner.width, 1, 1 ],
										0
									));
								} else if (side === 'back-middlePlinth') {
									return (ViewerNS.Component.mtx([ x / 3, 0, 0 ], [ x / 3, 1, 1 ], 0));
								} else if (side === 'back-rightPlinthClosed') {
									return (ViewerNS.Component.mtx([ 2 * x / 3, 0, 0 ], [ x / 3 - boundingBoxPartitions, 1, 1 ], 0));
								} else if (side === 'back-cornerLeftPlinth') {
									return (ViewerNS.Component.mtx([ 0, 0, 0 ], [ 1, 1, 1 ], 0));
								} else {
									return (ViewerNS.Component.mtx([ 1, 1, 1 ], [ 0, 0, 0 ], 0));
								}
							} else if (partitionHeadsPosition === 'back-left') {
								if (side === 'left') {
									return (ViewerNS.Component.mtx([ -(x / 2), 0, z / 2 ], [ 1, 1, 1 ], 90));
								} else if (side === 'back') {
									return (ViewerNS.Component.mtx([ -(x / 2), 0, -z / 2 ], [ 1, 1, 1 ], 0));
								} else if (side === 'left-leftPlinth') {
									return (ViewerNS.Component.mtx(
										[ boundingBoxPartitions, 0, 0 ],
										[ z / 3 - boundingBoxPartitions, 1, 1 ],
										0
									));
								} else if (side === 'left-middlePlinth') {
									return (ViewerNS.Component.mtx([ z / 3, 0, 0 ], [ z / 3, 1, 1 ], 0));
								} else if (side === 'left-rightPlinth') {
									return (ViewerNS.Component.mtx([ 2 * z / 3, 0, 0 ], [ z / 3 - boundingBoxCorner.depth, 1, 1 ], 0));
								} else if (side === 'back-leftPlinthOpened') {
									return (ViewerNS.Component.mtx(
										[ boundingBoxCorner.width, 0, 0 ],
										[ x / 3 - boundingBoxCorner.width, 1, 1 ],
										0
									));
								} else if (side === 'back-middlePlinth') {
									return (ViewerNS.Component.mtx([ x / 3, 0, 0 ], [ x / 3, 1, 1 ], 0));
								} else if (side === 'back-rightPlinthClosed') {
									return (ViewerNS.Component.mtx([ 2 * x / 3, 0, 0 ], [ x / 3 - boundingBoxPartitions, 1, 1 ], 0));
								} else if (side === 'back-cornerLeftPlinth') {
									return (ViewerNS.Component.mtx([ 0, 0, 0 ], [ 1, 1, 1 ], 0));
								} else {
									return (ViewerNS.Component.mtx([ 1, 1, 1 ], [ 0, 0, 0 ], 0));
								}
							} else {
								if (side === 'left') {
									return (ViewerNS.Component.mtx([ -(x / 2), 0, z / 2 ], [ 1, 1, 1 ], 90));
								} else if (side === 'back') {
									return (ViewerNS.Component.mtx([ -(x / 2), 0, -z / 2 ], [ 1, 1, 1 ], 0));
								} else if (side === 'left-leftPlinth') {
									return (ViewerNS.Component.mtx([ 0, 0, 0 ], [ z / 3, 1, 1 ], 0));
								} else if (side === 'left-middlePlinth') {
									return (ViewerNS.Component.mtx([ z / 3, 0, 0 ], [ z / 3, 1, 1 ], 0));
								} else if (side === 'left-rightPlinth') {
									return (ViewerNS.Component.mtx([ 2 * z / 3, 0, 0 ], [ z / 3 - boundingBoxCorner.depth, 1, 1 ], 0));
								} else if (side === 'back-leftPlinthOpened') {
									return (ViewerNS.Component.mtx(
										[ boundingBoxCorner.width, 0, 0 ],
										[ x / 3 - boundingBoxCorner.width, 1, 1 ],
										0
									));
								} else if (side === 'back-middlePlinth') {
									return (ViewerNS.Component.mtx([ x / 3, 0, 0 ], [ x / 3, 1, 1 ], 0));
								} else if (side === 'back-rightPlinthClosed') {
									return (ViewerNS.Component.mtx([ 2 * x / 3, 0, 0 ], [ x / 3, 1, 1 ], 0));
								} else if (side === 'back-cornerLeftPlinth') {
									return (ViewerNS.Component.mtx([ 0, 0, 0 ], [ 1, 1, 1 ], 0));
								} else {
									return (ViewerNS.Component.mtx([ 1, 1, 1 ], [ 0, 0, 0 ], 0));
								}
							}
						} else if (layoutId === 'shape-back') {
							if (partitionHeadsPosition === 'back') {
								if (side === 'back') {
									return (ViewerNS.Component.mtx([ -(x / 2), 0, -z / 2 ], [ 1, 1, 1 ], 0));
								} else if (side === 'back-leftPlinthClosed') {
									return (ViewerNS.Component.mtx(
										[ boundingBoxPartitions, 0, 0 ],
										[ x / 3 - boundingBoxPartitions, 1, 1 ],
										0
									));
								} else if (side === 'back-middlePlinth') {
									return (ViewerNS.Component.mtx([ x / 3, 0, 0 ], [ x / 3, 1, 1 ], 0));
								} else if (side === 'back-rightPlinthClosed') {
									return (ViewerNS.Component.mtx([ 2 * x / 3, 0, 0 ], [ x / 3, 1, 1 ], 0));
								} else {
									return (ViewerNS.Component.mtx([ 1, 1, 1 ], [ 0, 0, 0 ], 0));
								}
							} else if (partitionHeadsPosition === 'back-back') {
								if (side === 'back') {
									return (ViewerNS.Component.mtx([ -(x / 2), 0, -z / 2 ], [ 1, 1, 1 ], 0));
								} else if (side === 'back-leftPlinthClosed') {
									return (ViewerNS.Component.mtx(
										[ boundingBoxPartitions, 0, 0 ],
										[ x / 3 - boundingBoxPartitions, 1, 1 ],
										0
									));
								} else if (side === 'back-middlePlinth') {
									return (ViewerNS.Component.mtx([ x / 3, 0, 0 ], [ x / 3, 1, 1 ], 0));
								} else if (side === 'back-rightPlinthClosed') {
									return (ViewerNS.Component.mtx([ 2 * x / 3, 0, 0 ], [ x / 3 - boundingBoxPartitions, 1, 1 ], 0));
								} else {
									return (ViewerNS.Component.mtx([ 1, 1, 1 ], [ 0, 0, 0 ], 0));
								}
							} else {
								if (side === 'back') {
									return (ViewerNS.Component.mtx([ -(x / 2), 0, -z / 2 ], [ 1, 1, 1 ], 0));
								} else if (side === 'back-leftPlinthClosed') {
									return (ViewerNS.Component.mtx([ 0, 0, 0 ], [ x / 3, 1, 1 ], 0));
								} else if (side === 'back-middlePlinth') {
									return (ViewerNS.Component.mtx([ x / 3, 0, 0 ], [ x / 3, 1, 1 ], 0));
								} else if (side === 'back-rightPlinthClosed') {
									return (ViewerNS.Component.mtx([ 2 * x / 3, 0, 0 ], [ x / 3, 1, 1 ], 0));
								} else {
									return (ViewerNS.Component.mtx([ 1, 1, 1 ], [ 0, 0, 0 ], 0));
								}
							}

						} else if (layoutId === 'shape-back-right') {
							if (partitionHeadsPosition === 'back') {
								if (side === 'right') {
									return (ViewerNS.Component.mtx([ (x / 2), 0, -z / 2 ], [ 1, 1, 1 ], 270));
								} else if (side === 'back') {
									return (ViewerNS.Component.mtx([ -(x / 2), 0, -z / 2 ], [ 1, 1, 1 ], 0));
								} else if (side === 'right-leftPlinth') {
									return (ViewerNS.Component.mtx(
										[ boundingBoxCorner.width, 0, 0 ],
										[ z / 3 - boundingBoxCorner.width, 1, 1 ],
										0
									));
								} else if (side === 'right-middlePlinth') {
									return (ViewerNS.Component.mtx([ z / 3, 0, 0 ], [ z / 3, 1, 1 ], 0));
								} else if (side === 'right-rightPlinth') {
									return (ViewerNS.Component.mtx([ 2 * z / 3, 0, 0 ], [ z / 3, 1, 1 ], 0));
								} else if (side === 'back-leftPlinthClosed') {
									return (ViewerNS.Component.mtx(
										[ boundingBoxPartitions, 0, 0 ],
										[ x / 3 - boundingBoxPartitions, 1, 1 ],
										0
									));
								} else if (side === 'back-middlePlinth') {
									return (ViewerNS.Component.mtx([ x / 3, 0, 0 ], [ x / 3, 1, 1 ], 0));
								} else if (side === 'back-rightPlinthOpened') {
									return (ViewerNS.Component.mtx([ 2 * x / 3, 0, 0 ], [ x / 3 - boundingBoxCorner.depth, 1, 1 ], 0));
								} else if (side === 'back-cornerRightPlinth') {
									return (ViewerNS.Component.mtx([ x, 0, 0 ], [ 1, 1, 1 ], 270));
								} else {
									return (ViewerNS.Component.mtx([ 1, 1, 1 ], [ 0, 0, 0 ], 0));
								}
							} else if (partitionHeadsPosition === 'back-right') {
								if (side === 'right') {
									return (ViewerNS.Component.mtx([ (x / 2), 0, -z / 2 ], [ 1, 1, 1 ], 270));
								} else if (side === 'back') {
									return (ViewerNS.Component.mtx([ -(x / 2), 0, -z / 2 ], [ 1, 1, 1 ], 0));
								} else if (side === 'right-leftPlinth') {
									return (ViewerNS.Component.mtx(
										[ boundingBoxCorner.width, 0, 0 ],
										[ z / 3 - boundingBoxCorner.width, 1, 1 ],
										0
									));
								} else if (side === 'right-middlePlinth') {
									return (ViewerNS.Component.mtx([ z / 3, 0, 0 ], [ z / 3, 1, 1 ], 0));
								} else if (side === 'right-rightPlinth') {
									return (ViewerNS.Component.mtx([ 2 * z / 3, 0, 0 ], [ z / 3 - boundingBoxPartitions, 1, 1 ], 0));
								} else if (side === 'back-leftPlinthClosed') {
									return (ViewerNS.Component.mtx(
										[ boundingBoxPartitions, 0, 0 ],
										[ x / 3 - boundingBoxPartitions, 1, 1 ],
										0
									));
								} else if (side === 'back-middlePlinth') {
									return (ViewerNS.Component.mtx([ x / 3, 0, 0 ], [ x / 3, 1, 1 ], 0));
								} else if (side === 'back-rightPlinthOpened') {
									return (ViewerNS.Component.mtx([ 2 * x / 3, 0, 0 ], [ x / 3 - boundingBoxCorner.depth, 1, 1 ], 0));
								} else if (side === 'back-cornerRightPlinth') {
									return (ViewerNS.Component.mtx([ x, 0, 0 ], [ 1, 1, 1 ], 270));
								} else {
									return (ViewerNS.Component.mtx([ 1, 1, 1 ], [ 0, 0, 0 ], 0));
								}
							} else {
								if (side === 'right') {
									return (ViewerNS.Component.mtx([ (x / 2), 0, -z / 2 ], [ 1, 1, 1 ], 270));
								} else if (side === 'back') {
									return (ViewerNS.Component.mtx([ -(x / 2), 0, -z / 2 ], [ 1, 1, 1 ], 0));
								} else if (side === 'right-leftPlinth') {
									return (ViewerNS.Component.mtx(
										[ boundingBoxCorner.width, 0, 0 ],
										[ z / 3 - boundingBoxCorner.width, 1, 1 ],
										0
									));
								} else if (side === 'right-middlePlinth') {
									return (ViewerNS.Component.mtx([ z / 3, 0, 0 ], [ z / 3, 1, 1 ], 0));
								} else if (side === 'right-rightPlinth') {
									return (ViewerNS.Component.mtx([ 2 * z / 3, 0, 0 ], [ z / 3, 1, 1 ], 0));
								} else if (side === 'back-leftPlinthClosed') {
									return (ViewerNS.Component.mtx([ 0, 0, 0 ], [ x / 3, 1, 1 ], 0));
								} else if (side === 'back-middlePlinth') {
									return (ViewerNS.Component.mtx([ x / 3, 0, 0 ], [ x / 3, 1, 1 ], 0));
								} else if (side === 'back-rightPlinthOpened') {
									return (ViewerNS.Component.mtx([ 2 * x / 3, 0, 0 ], [ x / 3 - boundingBoxCorner.depth, 1, 1 ], 0));
								} else if (side === 'back-cornerRightPlinth') {
									return (ViewerNS.Component.mtx([ x, 0, 0 ], [ 1, 1, 1 ], 270));
								} else {
									return (ViewerNS.Component.mtx([ 1, 1, 1 ], [ 0, 0, 0 ], 0));
								}
							}
						} else if (layoutId === 'shape-left-back-right') {
							if (partitionHeadsPosition === 'left') {
								if (side === 'left') {
									return (ViewerNS.Component.mtx([ -(x / 2), 0, z / 2 ], [ 1, 1, 1 ], 90));
								} else if (side === 'back') {
									return (ViewerNS.Component.mtx([ -(x / 2), 0, -z / 2 ], [ 1, 1, 1 ], 0));
								} else if (side === 'right') {
									return (ViewerNS.Component.mtx([ (x / 2), 0, -z / 2 ], [ 1, 1, 1 ], 270));
								} else if (side === 'left-leftPlinth') {
									return (ViewerNS.Component.mtx(
										[ boundingBoxPartitions, 0, 0 ],
										[ z / 3 - boundingBoxPartitions, 1, 1 ],
										0
									));
								} else if (side === 'left-middlePlinth') {
									return (ViewerNS.Component.mtx([ z / 3, 0, 0 ], [ z / 3, 1, 1 ], 0));
								} else if (side === 'left-rightPlinth') {
									return (ViewerNS.Component.mtx([ 2 * z / 3, 0, 0 ], [ z / 3 - boundingBoxCorner.depth, 1, 1 ], 0));
								} else if (side === 'back-cornerLeftPlinth') {
									return (ViewerNS.Component.mtx([ 0, 0, 0 ], [ 1, 1, 1 ], 0));
								} else if (side === 'back-leftPlinthOpened') {
									return (ViewerNS.Component.mtx(
										[ boundingBoxCorner.width, 0, 0 ],
										[ x / 3 - boundingBoxCorner.width, 1, 1 ],
										0
									));
								} else if (side === 'back-middlePlinth') {
									return (ViewerNS.Component.mtx([ x / 3, 0, 0 ], [ x / 3, 1, 1 ], 0));
								} else if (side === 'back-rightPlinthOpened') {
									return (ViewerNS.Component.mtx([ 2 * x / 3, 0, 0 ], [ x / 3 - boundingBoxCorner.depth, 1, 1 ], 0));
								} else if (side === 'back-cornerRightPlinth') {
									return (ViewerNS.Component.mtx([ x, 0, 0 ], [ 1, 1, 1 ], 270));
								} else if (side === 'right-leftPlinth') {
									return (ViewerNS.Component.mtx(
										[ boundingBoxCorner.width, 0, 0 ],
										[ z / 3 - boundingBoxCorner.width, 1, 1 ],
										0
									));
								} else if (side === 'right-middlePlinth') {
									return (ViewerNS.Component.mtx([ z / 3, 0, 0 ], [ z / 3, 1, 1 ], 0));
								} else if (side === 'right-rightPlinth') {
									return (ViewerNS.Component.mtx([ 2 * z / 3, 0, 0 ], [ z / 3, 1, 1 ], 0));
								} else {
									return (ViewerNS.Component.mtx([ 1, 1, 1 ], [ 0, 0, 0 ], 0));
								}
							} else if (partitionHeadsPosition === 'left-right') {
								if (side === 'left') {
									return (ViewerNS.Component.mtx([ -(x / 2), 0, z / 2 ], [ 1, 1, 1 ], 90));
								} else if (side === 'back') {
									return (ViewerNS.Component.mtx([ -(x / 2), 0, -z / 2 ], [ 1, 1, 1 ], 0));
								} else if (side === 'right') {
									return (ViewerNS.Component.mtx([ (x / 2), 0, -z / 2 ], [ 1, 1, 1 ], 270));
								} else if (side === 'left-leftPlinth') {
									return (ViewerNS.Component.mtx(
										[ boundingBoxPartitions, 0, 0 ],
										[ z / 3 - boundingBoxPartitions, 1, 1 ],
										0
									));
								} else if (side === 'left-middlePlinth') {
									return (ViewerNS.Component.mtx([ z / 3, 0, 0 ], [ z / 3, 1, 1 ], 0));
								} else if (side === 'left-rightPlinth') {
									return (ViewerNS.Component.mtx([ 2 * z / 3, 0, 0 ], [ z / 3 - boundingBoxCorner.depth, 1, 1 ], 0));
								} else if (side === 'back-cornerLeftPlinth') {
									return (ViewerNS.Component.mtx([ 0, 0, 0 ], [ 1, 1, 1 ], 0));
								} else if (side === 'back-leftPlinthOpened') {
									return (ViewerNS.Component.mtx(
										[ boundingBoxCorner.width, 0, 0 ],
										[ x / 3 - boundingBoxCorner.width, 1, 1 ],
										0
									));
								} else if (side === 'back-middlePlinth') {
									return (ViewerNS.Component.mtx([ x / 3, 0, 0 ], [ x / 3, 1, 1 ], 0));
								} else if (side === 'back-rightPlinthOpened') {
									return (ViewerNS.Component.mtx([ 2 * x / 3, 0, 0 ], [ x / 3 - boundingBoxCorner.depth, 1, 1 ], 0));
								} else if (side === 'back-cornerRightPlinth') {
									return (ViewerNS.Component.mtx([ x, 0, 0 ], [ 1, 1, 1 ], 270));
								} else if (side === 'right-leftPlinth') {
									return (ViewerNS.Component.mtx(
										[ boundingBoxCorner.width, 0, 0 ],
										[ z / 3 - boundingBoxCorner.width, 1, 1 ],
										0
									));
								} else if (side === 'right-middlePlinth') {
									return (ViewerNS.Component.mtx([ z / 3, 0, 0 ], [ z / 3, 1, 1 ], 0));
								} else if (side === 'right-rightPlinth') {
									return (ViewerNS.Component.mtx([ 2 * z / 3, 0, 0 ], [ z / 3 - boundingBoxPartitions, 1, 1 ], 0));
								} else {
									return (ViewerNS.Component.mtx([ 1, 1, 1 ], [ 0, 0, 0 ], 0));
								}
							} else {
								if (side === 'left') {
									return (ViewerNS.Component.mtx([ -(x / 2), 0, z / 2 ], [ 1, 1, 1 ], 90));
								} else if (side === 'back') {
									return (ViewerNS.Component.mtx([ -(x / 2), 0, -z / 2 ], [ 1, 1, 1 ], 0));
								} else if (side === 'right') {
									return (ViewerNS.Component.mtx([ (x / 2), 0, -z / 2 ], [ 1, 1, 1 ], 270));
								} else if (side === 'left-leftPlinth') {
									return (ViewerNS.Component.mtx([ 0, 0, 0 ], [ z / 3, 1, 1 ], 0));
								} else if (side === 'left-middlePlinth') {
									return (ViewerNS.Component.mtx([ z / 3, 0, 0 ], [ z / 3, 1, 1 ], 0));
								} else if (side === 'left-rightPlinth') {
									return (ViewerNS.Component.mtx([ 2 * z / 3, 0, 0 ], [ z / 3 - boundingBoxCorner.depth, 1, 1 ], 0));
								} else if (side === 'back-cornerLeftPlinth') {
									return (ViewerNS.Component.mtx([ 0, 0, 0 ], [ 1, 1, 1 ], 0));
								} else if (side === 'back-leftPlinthOpened') {
									return (ViewerNS.Component.mtx(
										[ boundingBoxCorner.width, 0, 0 ],
										[ x / 3 - boundingBoxCorner.width, 1, 1 ],
										0
									));
								} else if (side === 'back-middlePlinth') {
									return (ViewerNS.Component.mtx([ x / 3, 0, 0 ], [ x / 3, 1, 1 ], 0));
								} else if (side === 'back-rightPlinthOpened') {
									return (ViewerNS.Component.mtx([ 2 * x / 3, 0, 0 ], [ x / 3 - boundingBoxCorner.depth, 1, 1 ], 0));
								} else if (side === 'back-cornerRightPlinth') {
									return (ViewerNS.Component.mtx([ x, 0, 0 ], [ 1, 1, 1 ], 270));
								} else if (side === 'right-leftPlinth') {
									return (ViewerNS.Component.mtx(
										[ boundingBoxCorner.width, 0, 0 ],
										[ z / 3 - boundingBoxCorner.width, 1, 1 ],
										0
									));
								} else if (side === 'right-middlePlinth') {
									return (ViewerNS.Component.mtx([ z / 3, 0, 0 ], [ z / 3, 1, 1 ], 0));
								} else if (side === 'right-rightPlinth') {
									return (ViewerNS.Component.mtx([ 2 * z / 3, 0, 0 ], [ z / 3, 1, 1 ], 0));
								} else {
									return (ViewerNS.Component.mtx([ 1, 1, 1 ], [ 0, 0, 0 ], 0));
								}
							}
						} else {
							throw STD.errors.user('Unknown layoutId in plinth');
						}
					} else if (surface > 24) {
						if (layoutId === 'shape-no-wall') {
							return (ViewerNS.Component.mtx([ 1, 1, 1 ], [ 0, 0, 0 ], 0));
						} else if (layoutId === 'shape-back-left') {
							if (partitionHeadsPosition === 'left') {
								if (side === 'left') {
									return (ViewerNS.Component.mtx([ -(x / 2), 0, z / 2 ], [ 1, 1, 1 ], 90));
								} else if (side === 'back') {
									return (ViewerNS.Component.mtx([ -(x / 2), 0, -z / 2 ], [ 1, 1, 1 ], 0));
								} else if (side === 'left-leftPlinth') {
									return (ViewerNS.Component.mtx(
										[ boundingBoxPartitions, 0, 0 ],
										[ z / 3 - boundingBoxPartitions, 1, 1 ],
										0
									));
								} else if (side === 'left-middlePlinth') {
									return (ViewerNS.Component.mtx([ z / 3, 0, 0 ], [ z / 3, 1, 1 ], 0));
								} else if (side === 'left-rightPlinth') {
									return (ViewerNS.Component.mtx([ 2 * z / 3, 0, 0 ], [ z / 3 - boundingBoxCorner.depth, 1, 1 ], 0));
								} else if (side === 'back-leftPlinthOpened') {
									return (ViewerNS.Component.mtx(
										[ boundingBoxCorner.width, 0, 0 ],
										[ x / 3 - boundingBoxCorner.width, 1, 1 ],
										0
									));
								} else if (side === 'back-middlePlinth') {
									return (ViewerNS.Component.mtx([ x / 3, 0, 0 ], [ x / 3, 1, 1 ], 0));
								} else if (side === 'back-rightPlinthClosed') {
									return (ViewerNS.Component.mtx([ 2 * x / 3, 0, 0 ], [ x / 3, 1, 1 ], 0));
								} else if (side === 'back-cornerLeftPlinth') {
									return (ViewerNS.Component.mtx([ 0, 0, 0 ], [ 1, 1, 1 ], 0));
								} else {
									return (ViewerNS.Component.mtx([ 1, 1, 1 ], [ 0, 0, 0 ], 0));
								}
							} else if (partitionHeadsPosition === 'back') {
								if (side === 'left') {
									return (ViewerNS.Component.mtx([ -(x / 2), 0, z / 2 ], [ 1, 1, 1 ], 90));
								} else if (side === 'back') {
									return (ViewerNS.Component.mtx([ -(x / 2), 0, -z / 2 ], [ 1, 1, 1 ], 0));
								} else if (side === 'left-leftPlinth') {
									return (ViewerNS.Component.mtx([ 0, 0, 0 ], [ z / 3, 1, 1 ], 0));
								} else if (side === 'left-middlePlinth') {
									return (ViewerNS.Component.mtx([ z / 3, 0, 0 ], [ z / 3, 1, 1 ], 0));
								} else if (side === 'left-rightPlinth') {
									return (ViewerNS.Component.mtx([ 2 * z / 3, 0, 0 ], [ z / 3 - boundingBoxCorner.depth, 1, 1 ], 0));
								} else if (side === 'back-leftPlinthOpened') {
									return (ViewerNS.Component.mtx(
										[ boundingBoxCorner.width, 0, 0 ],
										[ x / 3 - boundingBoxCorner.width, 1, 1 ],
										0
									));
								} else if (side === 'back-middlePlinth') {
									return (ViewerNS.Component.mtx([ x / 3, 0, 0 ], [ x / 3, 1, 1 ], 0));
								} else if (side === 'back-rightPlinthClosed') {
									return (ViewerNS.Component.mtx([ 2 * x / 3, 0, 0 ], [ x / 3 - boundingBoxPartitions, 1, 1 ], 0));
								} else if (side === 'back-cornerLeftPlinth') {
									return (ViewerNS.Component.mtx([ 0, 0, 0 ], [ 1, 1, 1 ], 0));
								} else {
									return (ViewerNS.Component.mtx([ 1, 1, 1 ], [ 0, 0, 0 ], 0));
								}
							} else if (partitionHeadsPosition === 'back-left') {
								if (side === 'left') {
									return (ViewerNS.Component.mtx([ -(x / 2), 0, z / 2 ], [ 1, 1, 1 ], 90));
								} else if (side === 'back') {
									return (ViewerNS.Component.mtx([ -(x / 2), 0, -z / 2 ], [ 1, 1, 1 ], 0));
								} else if (side === 'left-leftPlinth') {
									return (ViewerNS.Component.mtx(
										[ boundingBoxPartitions, 0, 0 ],
										[ z / 3 - boundingBoxPartitions, 1, 1 ],
										0
									));
								} else if (side === 'left-middlePlinth') {
									return (ViewerNS.Component.mtx([ z / 3, 0, 0 ], [ z / 3, 1, 1 ], 0));
								} else if (side === 'left-rightPlinth') {
									return (ViewerNS.Component.mtx([ 2 * z / 3, 0, 0 ], [ z / 3 - boundingBoxCorner.depth, 1, 1 ], 0));
								} else if (side === 'back-leftPlinthOpened') {
									return (ViewerNS.Component.mtx(
										[ boundingBoxCorner.width, 0, 0 ],
										[ x / 3 - boundingBoxCorner.width, 1, 1 ],
										0
									));
								} else if (side === 'back-middlePlinth') {
									return (ViewerNS.Component.mtx([ x / 3, 0, 0 ], [ x / 3, 1, 1 ], 0));
								} else if (side === 'back-rightPlinthClosed') {
									return (ViewerNS.Component.mtx([ 2 * x / 3, 0, 0 ], [ x / 3 - boundingBoxPartitions, 1, 1 ], 0));
								} else if (side === 'back-cornerLeftPlinth') {
									return (ViewerNS.Component.mtx([ 0, 0, 0 ], [ 1, 1, 1 ], 0));
								} else {
									return (ViewerNS.Component.mtx([ 1, 1, 1 ], [ 0, 0, 0 ], 0));
								}
							} else {
								if (side === 'left') {
									return (ViewerNS.Component.mtx([ -(x / 2), 0, z / 2 ], [ 1, 1, 1 ], 90));
								} else if (side === 'back') {
									return (ViewerNS.Component.mtx([ -(x / 2), 0, -z / 2 ], [ 1, 1, 1 ], 0));
								} else if (side === 'left-leftPlinth') {
									return (ViewerNS.Component.mtx([ 0, 0, 0 ], [ z / 3, 1, 1 ], 0));
								} else if (side === 'left-middlePlinth') {
									return (ViewerNS.Component.mtx([ z / 3, 0, 0 ], [ z / 3, 1, 1 ], 0));
								} else if (side === 'left-rightPlinth') {
									return (ViewerNS.Component.mtx([ 2 * z / 3, 0, 0 ], [ z / 3 - boundingBoxCorner.depth, 1, 1 ], 0));
								} else if (side === 'back-leftPlinthOpened') {
									return (ViewerNS.Component.mtx(
										[ boundingBoxCorner.width, 0, 0 ],
										[ x / 3 - boundingBoxCorner.width, 1, 1 ],
										0
									));
								} else if (side === 'back-middlePlinth') {
									return (ViewerNS.Component.mtx([ x / 3, 0, 0 ], [ x / 3, 1, 1 ], 0));
								} else if (side === 'back-rightPlinthClosed') {
									return (ViewerNS.Component.mtx([ 2 * x / 3, 0, 0 ], [ x / 3, 1, 1 ], 0));
								} else if (side === 'back-cornerLeftPlinth') {
									return (ViewerNS.Component.mtx([ 0, 0, 0 ], [ 1, 1, 1 ], 0));
								} else {
									return (ViewerNS.Component.mtx([ 1, 1, 1 ], [ 0, 0, 0 ], 0));
								}
							}
						} else if (layoutId === 'shape-back') {
							if (partitionHeadsPosition === 'back') {
								if (side === 'back') {
									return (ViewerNS.Component.mtx([ -(x / 2), 0, -z / 2 ], [ 1, 1, 1 ], 0));
								} else if (side === 'back-leftPlinthClosed') {
									return (ViewerNS.Component.mtx(
										[ boundingBoxPartitions, 0, 0 ],
										[ x / 3 - boundingBoxPartitions, 1, 1 ],
										0
									));
								} else if (side === 'back-middlePlinth') {
									return (ViewerNS.Component.mtx([ x / 3, 0, 0 ], [ x / 3, 1, 1 ], 0));
								} else if (side === 'back-rightPlinthClosed') {
									return (ViewerNS.Component.mtx([ 2 * x / 3, 0, 0 ], [ x / 3, 1, 1 ], 0));
								} else {
									return (ViewerNS.Component.mtx([ 1, 1, 1 ], [ 0, 0, 0 ], 0));
								}
							} else if (partitionHeadsPosition === 'back-back') {
								if (side === 'back') {
									return (ViewerNS.Component.mtx([ -(x / 2), 0, -z / 2 ], [ 1, 1, 1 ], 0));
								} else if (side === 'back-leftPlinthClosed') {
									return (ViewerNS.Component.mtx(
										[ boundingBoxPartitions, 0, 0 ],
										[ x / 3 - boundingBoxPartitions, 1, 1 ],
										0
									));
								} else if (side === 'back-middlePlinth') {
									return (ViewerNS.Component.mtx([ x / 3, 0, 0 ], [ x / 3, 1, 1 ], 0));
								} else if (side === 'back-rightPlinthClosed') {
									return (ViewerNS.Component.mtx([ 2 * x / 3, 0, 0 ], [ x / 3 - boundingBoxPartitions, 1, 1 ], 0));
								} else {
									return (ViewerNS.Component.mtx([ 1, 1, 1 ], [ 0, 0, 0 ], 0));
								}
							} else {
								if (side === 'back') {
									return (ViewerNS.Component.mtx([ -(x / 2), 0, -z / 2 ], [ 1, 1, 1 ], 0));
								} else if (side === 'back-leftPlinthClosed') {
									return (ViewerNS.Component.mtx([ 0, 0, 0 ], [ x / 3, 1, 1 ], 0));
								} else if (side === 'back-middlePlinth') {
									return (ViewerNS.Component.mtx([ x / 3, 0, 0 ], [ x / 3, 1, 1 ], 0));
								} else if (side === 'back-rightPlinthClosed') {
									return (ViewerNS.Component.mtx([ 2 * x / 3, 0, 0 ], [ x / 3, 1, 1 ], 0));
								} else {
									return (ViewerNS.Component.mtx([ 1, 1, 1 ], [ 0, 0, 0 ], 0));
								}
							}

						} else if (layoutId === 'shape-back-right') {
							if (partitionHeadsPosition === 'back') {
								if (side === 'right') {
									return (ViewerNS.Component.mtx([ (x / 2), 0, -z / 2 ], [ 1, 1, 1 ], 270));
								} else if (side === 'back') {
									return (ViewerNS.Component.mtx([ -(x / 2), 0, -z / 2 ], [ 1, 1, 1 ], 0));
								} else if (side === 'right-leftPlinth') {
									return (ViewerNS.Component.mtx(
										[ boundingBoxCorner.width, 0, 0 ],
										[ z / 3 - boundingBoxCorner.width, 1, 1 ],
										0
									));
								} else if (side === 'right-middlePlinth') {
									return (ViewerNS.Component.mtx([ z / 3, 0, 0 ], [ z / 3, 1, 1 ], 0));
								} else if (side === 'right-rightPlinth') {
									return (ViewerNS.Component.mtx([ 2 * z / 3, 0, 0 ], [ z / 3, 1, 1 ], 0));
								} else if (side === 'back-leftPlinthClosed') {
									return (ViewerNS.Component.mtx(
										[ boundingBoxPartitions, 0, 0 ],
										[ x / 3 - boundingBoxPartitions, 1, 1 ],
										0
									));
								} else if (side === 'back-middlePlinth') {
									return (ViewerNS.Component.mtx([ x / 3, 0, 0 ], [ x / 3, 1, 1 ], 0));
								} else if (side === 'back-rightPlinthOpened') {
									return (ViewerNS.Component.mtx([ 2 * x / 3, 0, 0 ], [ x / 3 - boundingBoxCorner.depth, 1, 1 ], 0));
								} else if (side === 'back-cornerRightPlinth') {
									return (ViewerNS.Component.mtx([ x, 0, 0 ], [ 1, 1, 1 ], 270));
								} else {
									return (ViewerNS.Component.mtx([ 1, 1, 1 ], [ 0, 0, 0 ], 0));
								}
							} else if (partitionHeadsPosition === 'back-right') {
								if (side === 'right') {
									return (ViewerNS.Component.mtx([ (x / 2), 0, -z / 2 ], [ 1, 1, 1 ], 270));
								} else if (side === 'back') {
									return (ViewerNS.Component.mtx([ -(x / 2), 0, -z / 2 ], [ 1, 1, 1 ], 0));
								} else if (side === 'right-leftPlinth') {
									return (ViewerNS.Component.mtx(
										[ boundingBoxCorner.width, 0, 0 ],
										[ z / 3 - boundingBoxCorner.width, 1, 1 ],
										0
									));
								} else if (side === 'right-middlePlinth') {
									return (ViewerNS.Component.mtx([ z / 3, 0, 0 ], [ z / 3, 1, 1 ], 0));
								} else if (side === 'right-rightPlinth') {
									return (ViewerNS.Component.mtx([ 2 * z / 3, 0, 0 ], [ z / 3 - boundingBoxPartitions, 1, 1 ], 0));
								} else if (side === 'back-leftPlinthClosed') {
									return (ViewerNS.Component.mtx(
										[ boundingBoxPartitions, 0, 0 ],
										[ x / 3 - boundingBoxPartitions, 1, 1 ],
										0
									));
								} else if (side === 'back-middlePlinth') {
									return (ViewerNS.Component.mtx([ x / 3, 0, 0 ], [ x / 3, 1, 1 ], 0));
								} else if (side === 'back-rightPlinthOpened') {
									return (ViewerNS.Component.mtx([ 2 * x / 3, 0, 0 ], [ x / 3 - boundingBoxCorner.depth, 1, 1 ], 0));
								} else if (side === 'back-cornerRightPlinth') {
									return (ViewerNS.Component.mtx([ x, 0, 0 ], [ 1, 1, 1 ], 270));
								} else {
									return (ViewerNS.Component.mtx([ 1, 1, 1 ], [ 0, 0, 0 ], 0));
								}
							} else {
								if (side === 'right') {
									return (ViewerNS.Component.mtx([ (x / 2), 0, -z / 2 ], [ 1, 1, 1 ], 270));
								} else if (side === 'back') {
									return (ViewerNS.Component.mtx([ -(x / 2), 0, -z / 2 ], [ 1, 1, 1 ], 0));
								} else if (side === 'right-leftPlinth') {
									return (ViewerNS.Component.mtx(
										[ boundingBoxCorner.width, 0, 0 ],
										[ z / 3 - boundingBoxCorner.width, 1, 1 ],
										0
									));
								} else if (side === 'right-middlePlinth') {
									return (ViewerNS.Component.mtx([ z / 3, 0, 0 ], [ z / 3, 1, 1 ], 0));
								} else if (side === 'right-rightPlinth') {
									return (ViewerNS.Component.mtx([ 2 * z / 3, 0, 0 ], [ z / 3, 1, 1 ], 0));
								} else if (side === 'back-leftPlinthClosed') {
									return (ViewerNS.Component.mtx([ 0, 0, 0 ], [ x / 3, 1, 1 ], 0));
								} else if (side === 'back-middlePlinth') {
									return (ViewerNS.Component.mtx([ x / 3, 0, 0 ], [ x / 3, 1, 1 ], 0));
								} else if (side === 'back-rightPlinthOpened') {
									return (ViewerNS.Component.mtx([ 2 * x / 3, 0, 0 ], [ x / 3 - boundingBoxCorner.depth, 1, 1 ], 0));
								} else if (side === 'back-cornerRightPlinth') {
									return (ViewerNS.Component.mtx([ x, 0, 0 ], [ 1, 1, 1 ], 270));
								} else {
									return (ViewerNS.Component.mtx([ 1, 1, 1 ], [ 0, 0, 0 ], 0));
								}
							}
						} else if (layoutId === 'shape-left-back-right') {
							if (partitionHeadsPosition === 'left') {
								if (side === 'left') {
									return (ViewerNS.Component.mtx([ -(x / 2), 0, z / 2 ], [ 1, 1, 1 ], 90));
								} else if (side === 'back') {
									return (ViewerNS.Component.mtx([ -(x / 2), 0, -z / 2 ], [ 1, 1, 1 ], 0));
								} else if (side === 'right') {
									return (ViewerNS.Component.mtx([ (x / 2), 0, -z / 2 ], [ 1, 1, 1 ], 270));
								} else if (side === 'left-leftPlinth') {
									return (ViewerNS.Component.mtx(
										[ boundingBoxPartitions, 0, 0 ],
										[ z / 3 - boundingBoxPartitions, 1, 1 ],
										0
									));
								} else if (side === 'left-middlePlinth') {
									return (ViewerNS.Component.mtx([ z / 3, 0, 0 ], [ z / 3, 1, 1 ], 0));
								} else if (side === 'left-rightPlinth') {
									return (ViewerNS.Component.mtx([ 2 * z / 3, 0, 0 ], [ z / 3 - boundingBoxCorner.depth, 1, 1 ], 0));
								} else if (side === 'back-cornerLeftPlinth') {
									return (ViewerNS.Component.mtx([ 0, 0, 0 ], [ 1, 1, 1 ], 0));
								} else if (side === 'back-leftPlinthOpened') {
									return (ViewerNS.Component.mtx(
										[ boundingBoxCorner.width, 0, 0 ],
										[ x / 3 - boundingBoxCorner.width, 1, 1 ],
										0
									));
								} else if (side === 'back-middlePlinth') {
									return (ViewerNS.Component.mtx([ x / 3, 0, 0 ], [ x / 3, 1, 1 ], 0));
								} else if (side === 'back-rightPlinthOpened') {
									return (ViewerNS.Component.mtx([ 2 * x / 3, 0, 0 ], [ x / 3 - boundingBoxCorner.depth, 1, 1 ], 0));
								} else if (side === 'back-cornerRightPlinth') {
									return (ViewerNS.Component.mtx([ x, 0, 0 ], [ 1, 1, 1 ], 270));
								} else if (side === 'right-leftPlinth') {
									return (ViewerNS.Component.mtx(
										[ boundingBoxCorner.width, 0, 0 ],
										[ z / 3 - boundingBoxCorner.width, 1, 1 ],
										0
									));
								} else if (side === 'right-middlePlinth') {
									return (ViewerNS.Component.mtx([ z / 3, 0, 0 ], [ z / 3, 1, 1 ], 0));
								} else if (side === 'right-rightPlinth') {
									return (ViewerNS.Component.mtx([ 2 * z / 3, 0, 0 ], [ z / 3, 1, 1 ], 0));
								} else {
									return (ViewerNS.Component.mtx([ 1, 1, 1 ], [ 0, 0, 0 ], 0));
								}
							} else if (partitionHeadsPosition === 'left-right') {
								if (side === 'left') {
									return (ViewerNS.Component.mtx([ -(x / 2), 0, z / 2 ], [ 1, 1, 1 ], 90));
								} else if (side === 'back') {
									return (ViewerNS.Component.mtx([ -(x / 2), 0, -z / 2 ], [ 1, 1, 1 ], 0));
								} else if (side === 'right') {
									return (ViewerNS.Component.mtx([ (x / 2), 0, -z / 2 ], [ 1, 1, 1 ], 270));
								} else if (side === 'left-leftPlinth') {
									return (ViewerNS.Component.mtx(
										[ boundingBoxPartitions, 0, 0 ],
										[ z / 3 - boundingBoxPartitions, 1, 1 ],
										0
									));
								} else if (side === 'left-middlePlinth') {
									return (ViewerNS.Component.mtx([ z / 3, 0, 0 ], [ z / 3, 1, 1 ], 0));
								} else if (side === 'left-rightPlinth') {
									return (ViewerNS.Component.mtx([ 2 * z / 3, 0, 0 ], [ z / 3 - boundingBoxCorner.depth, 1, 1 ], 0));
								} else if (side === 'back-cornerLeftPlinth') {
									return (ViewerNS.Component.mtx([ 0, 0, 0 ], [ 1, 1, 1 ], 0));
								} else if (side === 'back-leftPlinthOpened') {
									return (ViewerNS.Component.mtx(
										[ boundingBoxCorner.width, 0, 0 ],
										[ x / 3 - boundingBoxCorner.width, 1, 1 ],
										0
									));
								} else if (side === 'back-middlePlinth') {
									return (ViewerNS.Component.mtx([ x / 3, 0, 0 ], [ x / 3, 1, 1 ], 0));
								} else if (side === 'back-rightPlinthOpened') {
									return (ViewerNS.Component.mtx([ 2 * x / 3, 0, 0 ], [ x / 3 - boundingBoxCorner.depth, 1, 1 ], 0));
								} else if (side === 'back-cornerRightPlinth') {
									return (ViewerNS.Component.mtx([ x, 0, 0 ], [ 1, 1, 1 ], 270));
								} else if (side === 'right-leftPlinth') {
									return (ViewerNS.Component.mtx(
										[ boundingBoxCorner.width, 0, 0 ],
										[ z / 3 - boundingBoxCorner.width, 1, 1 ],
										0
									));
								} else if (side === 'right-middlePlinth') {
									return (ViewerNS.Component.mtx([ z / 3, 0, 0 ], [ z / 3, 1, 1 ], 0));
								} else if (side === 'right-rightPlinth') {
									return (ViewerNS.Component.mtx([ 2 * z / 3, 0, 0 ], [ z / 3 - boundingBoxPartitions, 1, 1 ], 0));
								} else {
									return (ViewerNS.Component.mtx([ 1, 1, 1 ], [ 0, 0, 0 ], 0));
								}
							} else {
								if (side === 'left') {
									return (ViewerNS.Component.mtx([ -(x / 2), 0, z / 2 ], [ 1, 1, 1 ], 90));
								} else if (side === 'back') {
									return (ViewerNS.Component.mtx([ -(x / 2), 0, -z / 2 ], [ 1, 1, 1 ], 0));
								} else if (side === 'right') {
									return (ViewerNS.Component.mtx([ (x / 2), 0, -z / 2 ], [ 1, 1, 1 ], 270));
								} else if (side === 'left-leftPlinth') {
									return (ViewerNS.Component.mtx([ 0, 0, 0 ], [ z / 3, 1, 1 ], 0));
								} else if (side === 'left-middlePlinth') {
									return (ViewerNS.Component.mtx([ z / 3, 0, 0 ], [ z / 3, 1, 1 ], 0));
								} else if (side === 'left-rightPlinth') {
									return (ViewerNS.Component.mtx([ 2 * z / 3, 0, 0 ], [ z / 3 - boundingBoxCorner.depth, 1, 1 ], 0));
								} else if (side === 'back-cornerLeftPlinth') {
									return (ViewerNS.Component.mtx([ 0, 0, 0 ], [ 1, 1, 1 ], 0));
								} else if (side === 'back-leftPlinthOpened') {
									return (ViewerNS.Component.mtx(
										[ boundingBoxCorner.width, 0, 0 ],
										[ x / 3 - boundingBoxCorner.width, 1, 1 ],
										0
									));
								} else if (side === 'back-middlePlinth') {
									return (ViewerNS.Component.mtx([ x / 3, 0, 0 ], [ x / 3, 1, 1 ], 0));
								} else if (side === 'back-rightPlinthOpened') {
									return (ViewerNS.Component.mtx([ 2 * x / 3, 0, 0 ], [ x / 3 - boundingBoxCorner.depth, 1, 1 ], 0));
								} else if (side === 'back-cornerRightPlinth') {
									return (ViewerNS.Component.mtx([ x, 0, 0 ], [ 1, 1, 1 ], 270));
								} else if (side === 'right-leftPlinth') {
									return (ViewerNS.Component.mtx(
										[ boundingBoxCorner.width, 0, 0 ],
										[ z / 3 - boundingBoxCorner.width, 1, 1 ],
										0
									));
								} else if (side === 'right-middlePlinth') {
									return (ViewerNS.Component.mtx([ z / 3, 0, 0 ], [ z / 3, 1, 1 ], 0));
								} else if (side === 'right-rightPlinth') {
									return (ViewerNS.Component.mtx([ 2 * z / 3, 0, 0 ], [ z / 3, 1, 1 ], 0));
								} else {
									return (ViewerNS.Component.mtx([ 1, 1, 1 ], [ 0, 0, 0 ], 0));
								}
							}
						} else {
							throw STD.errors.user('Unknown layoutId in plinth');
						}
					} else if (surface > 11) {
						if (layoutId === 'shape-no-wall') {
							return (ViewerNS.Component.mtx([ 1, 1, 1 ], [ 0, 0, 0 ], 0));
						} else if (layoutId === 'shape-back-left') {
							if (partitionHeadsPosition === 'left') {
								if (side === 'left') {
									return (ViewerNS.Component.mtx([ -(x / 2), 0, z / 2 ], [ 1, 1, 1 ], 90));
								} else if (side === 'back') {
									return (ViewerNS.Component.mtx([ -(x / 2), 0, -z / 2 ], [ 1, 1, 1 ], 0));
								} else if (side === 'left-leftPlinth') {
									return (ViewerNS.Component.mtx(
										[ boundingBoxPartitions, 0, 0 ],
										[ z / 3 - boundingBoxPartitions, 1, 1 ],
										0
									));
								} else if (side === 'left-middlePlinth') {
									return (ViewerNS.Component.mtx([ z / 3, 0, 0 ], [ z / 3, 1, 1 ], 0));
								} else if (side === 'left-rightPlinth') {
									return (ViewerNS.Component.mtx([ 2 * z / 3, 0, 0 ], [ z / 3 - boundingBoxCorner.depth, 1, 1 ], 0));
								} else if (side === 'back-leftPlinthOpened') {
									return (ViewerNS.Component.mtx(
										[ boundingBoxCorner.width, 0, 0 ],
										[ x / 3 - boundingBoxCorner.width, 1, 1 ],
										0
									));
								} else if (side === 'back-middlePlinth') {
									return (ViewerNS.Component.mtx([ x / 3, 0, 0 ], [ x / 3, 1, 1 ], 0));
								} else if (side === 'back-rightPlinthClosed') {
									return (ViewerNS.Component.mtx([ 2 * x / 3, 0, 0 ], [ x / 3, 1, 1 ], 0));
								} else if (side === 'back-cornerLeftPlinth') {
									return (ViewerNS.Component.mtx([ 0, 0, 0 ], [ 1, 1, 1 ], 0));
								} else {
									return (ViewerNS.Component.mtx([ 1, 1, 1 ], [ 0, 0, 0 ], 0));
								}
							} else if (partitionHeadsPosition === 'back') {
								if (side === 'left') {
									return (ViewerNS.Component.mtx([ -(x / 2), 0, z / 2 ], [ 1, 1, 1 ], 90));
								} else if (side === 'back') {
									return (ViewerNS.Component.mtx([ -(x / 2), 0, -z / 2 ], [ 1, 1, 1 ], 0));
								} else if (side === 'left-leftPlinth') {
									return (ViewerNS.Component.mtx([ 0, 0, 0 ], [ z / 3, 1, 1 ], 0));
								} else if (side === 'left-middlePlinth') {
									return (ViewerNS.Component.mtx([ z / 3, 0, 0 ], [ z / 3, 1, 1 ], 0));
								} else if (side === 'left-rightPlinth') {
									return (ViewerNS.Component.mtx([ 2 * z / 3, 0, 0 ], [ z / 3 - boundingBoxCorner.depth, 1, 1 ], 0));
								} else if (side === 'back-leftPlinthOpened') {
									return (ViewerNS.Component.mtx(
										[ boundingBoxCorner.width, 0, 0 ],
										[ x / 3 - boundingBoxCorner.width, 1, 1 ],
										0
									));
								} else if (side === 'back-middlePlinth') {
									return (ViewerNS.Component.mtx([ x / 3, 0, 0 ], [ x / 3, 1, 1 ], 0));
								} else if (side === 'back-rightPlinthClosed') {
									return (ViewerNS.Component.mtx([ 2 * x / 3, 0, 0 ], [ x / 3 - boundingBoxPartitions, 1, 1 ], 0));
								} else if (side === 'back-cornerLeftPlinth') {
									return (ViewerNS.Component.mtx([ 0, 0, 0 ], [ 1, 1, 1 ], 0));
								} else {
									return (ViewerNS.Component.mtx([ 1, 1, 1 ], [ 0, 0, 0 ], 0));
								}
							} else if (partitionHeadsPosition === 'back-left') {
								if (side === 'left') {
									return (ViewerNS.Component.mtx([ -(x / 2), 0, z / 2 ], [ 1, 1, 1 ], 90));
								} else if (side === 'back') {
									return (ViewerNS.Component.mtx([ -(x / 2), 0, -z / 2 ], [ 1, 1, 1 ], 0));
								} else if (side === 'left-leftPlinth') {
									return (ViewerNS.Component.mtx(
										[ boundingBoxPartitions, 0, 0 ],
										[ z / 3 - boundingBoxPartitions, 1, 1 ],
										0
									));
								} else if (side === 'left-middlePlinth') {
									return (ViewerNS.Component.mtx([ z / 3, 0, 0 ], [ z / 3, 1, 1 ], 0));
								} else if (side === 'left-rightPlinth') {
									return (ViewerNS.Component.mtx([ 2 * z / 3, 0, 0 ], [ z / 3 - boundingBoxCorner.depth, 1, 1 ], 0));
								} else if (side === 'back-leftPlinthOpened') {
									return (ViewerNS.Component.mtx(
										[ boundingBoxCorner.width, 0, 0 ],
										[ x / 3 - boundingBoxCorner.width, 1, 1 ],
										0
									));
								} else if (side === 'back-middlePlinth') {
									return (ViewerNS.Component.mtx([ x / 3, 0, 0 ], [ x / 3, 1, 1 ], 0));
								} else if (side === 'back-rightPlinthClosed') {
									return (ViewerNS.Component.mtx([ 2 * x / 3, 0, 0 ], [ x / 3 - boundingBoxPartitions, 1, 1 ], 0));
								} else if (side === 'back-cornerLeftPlinth') {
									return (ViewerNS.Component.mtx([ 0, 0, 0 ], [ 1, 1, 1 ], 0));
								} else {
									return (ViewerNS.Component.mtx([ 1, 1, 1 ], [ 0, 0, 0 ], 0));
								}
							} else {
								if (side === 'left') {
									return (ViewerNS.Component.mtx([ -(x / 2), 0, z / 2 ], [ 1, 1, 1 ], 90));
								} else if (side === 'back') {
									return (ViewerNS.Component.mtx([ -(x / 2), 0, -z / 2 ], [ 1, 1, 1 ], 0));
								} else if (side === 'left-leftPlinth') {
									return (ViewerNS.Component.mtx([ 0, 0, 0 ], [ z / 3, 1, 1 ], 0));
								} else if (side === 'left-middlePlinth') {
									return (ViewerNS.Component.mtx([ z / 3, 0, 0 ], [ z / 3, 1, 1 ], 0));
								} else if (side === 'left-rightPlinth') {
									return (ViewerNS.Component.mtx([ 2 * z / 3, 0, 0 ], [ z / 3 - boundingBoxCorner.depth, 1, 1 ], 0));
								} else if (side === 'back-leftPlinthOpened') {
									return (ViewerNS.Component.mtx(
										[ boundingBoxCorner.width, 0, 0 ],
										[ x / 3 - boundingBoxCorner.width, 1, 1 ],
										0
									));
								} else if (side === 'back-middlePlinth') {
									return (ViewerNS.Component.mtx([ x / 3, 0, 0 ], [ x / 3, 1, 1 ], 0));
								} else if (side === 'back-rightPlinthClosed') {
									return (ViewerNS.Component.mtx([ 2 * x / 3, 0, 0 ], [ x / 3, 1, 1 ], 0));
								} else if (side === 'back-cornerLeftPlinth') {
									return (ViewerNS.Component.mtx([ 0, 0, 0 ], [ 1, 1, 1 ], 0));
								} else {
									return (ViewerNS.Component.mtx([ 1, 1, 1 ], [ 0, 0, 0 ], 0));
								}
							}
						} else if (layoutId === 'shape-back') {
							if (partitionHeadsPosition === 'back') {
								if (side === 'back') {
									return (ViewerNS.Component.mtx([ -(x / 2), 0, -z / 2 ], [ 1, 1, 1 ], 0));
								} else if (side === 'back-leftPlinthClosed') {
									return (ViewerNS.Component.mtx(
										[ boundingBoxPartitions, 0, 0 ],
										[ x / 3 - boundingBoxPartitions, 1, 1 ],
										0
									));
								} else if (side === 'back-middlePlinth') {
									return (ViewerNS.Component.mtx([ x / 3, 0, 0 ], [ x / 3, 1, 1 ], 0));
								} else if (side === 'back-rightPlinthClosed') {
									return (ViewerNS.Component.mtx([ 2 * x / 3, 0, 0 ], [ x / 3, 1, 1 ], 0));
								} else {
									return (ViewerNS.Component.mtx([ 1, 1, 1 ], [ 0, 0, 0 ], 0));
								}
							} else if (partitionHeadsPosition === 'back-back') {
								if (side === 'back') {
									return (ViewerNS.Component.mtx([ -(x / 2), 0, -z / 2 ], [ 1, 1, 1 ], 0));
								} else if (side === 'back-leftPlinthClosed') {
									return (ViewerNS.Component.mtx(
										[ boundingBoxPartitions, 0, 0 ],
										[ x / 3 - boundingBoxPartitions, 1, 1 ],
										0
									));
								} else if (side === 'back-middlePlinth') {
									return (ViewerNS.Component.mtx([ x / 3, 0, 0 ], [ x / 3, 1, 1 ], 0));
								} else if (side === 'back-rightPlinthClosed') {
									return (ViewerNS.Component.mtx([ 2 * x / 3, 0, 0 ], [ x / 3 - boundingBoxPartitions, 1, 1 ], 0));
								} else {
									return (ViewerNS.Component.mtx([ 1, 1, 1 ], [ 0, 0, 0 ], 0));
								}
							} else {
								if (side === 'back') {
									return (ViewerNS.Component.mtx([ -(x / 2), 0, -z / 2 ], [ 1, 1, 1 ], 0));
								} else if (side === 'back-leftPlinthClosed') {
									return (ViewerNS.Component.mtx([ 0, 0, 0 ], [ x / 3, 1, 1 ], 0));
								} else if (side === 'back-middlePlinth') {
									return (ViewerNS.Component.mtx([ x / 3, 0, 0 ], [ x / 3, 1, 1 ], 0));
								} else if (side === 'back-rightPlinthClosed') {
									return (ViewerNS.Component.mtx([ 2 * x / 3, 0, 0 ], [ x / 3, 1, 1 ], 0));
								} else {
									return (ViewerNS.Component.mtx([ 1, 1, 1 ], [ 0, 0, 0 ], 0));
								}
							}

						} else if (layoutId === 'shape-back-right') {
							if (partitionHeadsPosition === 'back') {
								if (side === 'right') {
									return (ViewerNS.Component.mtx([ (x / 2), 0, -z / 2 ], [ 1, 1, 1 ], 270));
								} else if (side === 'back') {
									return (ViewerNS.Component.mtx([ -(x / 2), 0, -z / 2 ], [ 1, 1, 1 ], 0));
								} else if (side === 'right-leftPlinth') {
									return (ViewerNS.Component.mtx(
										[ boundingBoxCorner.width, 0, 0 ],
										[ z / 3 - boundingBoxCorner.width, 1, 1 ],
										0
									));
								} else if (side === 'right-middlePlinth') {
									return (ViewerNS.Component.mtx([ z / 3, 0, 0 ], [ z / 3, 1, 1 ], 0));
								} else if (side === 'right-rightPlinth') {
									return (ViewerNS.Component.mtx([ 2 * z / 3, 0, 0 ], [ z / 3, 1, 1 ], 0));
								} else if (side === 'back-leftPlinthClosed') {
									return (ViewerNS.Component.mtx(
										[ boundingBoxPartitions, 0, 0 ],
										[ x / 3 - boundingBoxPartitions, 1, 1 ],
										0
									));
								} else if (side === 'back-middlePlinth') {
									return (ViewerNS.Component.mtx([ x / 3, 0, 0 ], [ x / 3, 1, 1 ], 0));
								} else if (side === 'back-rightPlinthOpened') {
									return (ViewerNS.Component.mtx([ 2 * x / 3, 0, 0 ], [ x / 3 - boundingBoxCorner.depth, 1, 1 ], 0));
								} else if (side === 'back-cornerRightPlinth') {
									return (ViewerNS.Component.mtx([ x, 0, 0 ], [ 1, 1, 1 ], 270));
								} else {
									return (ViewerNS.Component.mtx([ 1, 1, 1 ], [ 0, 0, 0 ], 0));
								}
							} else if (partitionHeadsPosition === 'back-right') {
								if (side === 'right') {
									return (ViewerNS.Component.mtx([ (x / 2), 0, -z / 2 ], [ 1, 1, 1 ], 270));
								} else if (side === 'back') {
									return (ViewerNS.Component.mtx([ -(x / 2), 0, -z / 2 ], [ 1, 1, 1 ], 0));
								} else if (side === 'right-leftPlinth') {
									return (ViewerNS.Component.mtx(
										[ boundingBoxCorner.width, 0, 0 ],
										[ z / 3 - boundingBoxCorner.width, 1, 1 ],
										0
									));
								} else if (side === 'right-middlePlinth') {
									return (ViewerNS.Component.mtx([ z / 3, 0, 0 ], [ z / 3, 1, 1 ], 0));
								} else if (side === 'right-rightPlinth') {
									return (ViewerNS.Component.mtx([ 2 * z / 3, 0, 0 ], [ z / 3 - boundingBoxPartitions, 1, 1 ], 0));
								} else if (side === 'back-leftPlinthClosed') {
									return (ViewerNS.Component.mtx(
										[ boundingBoxPartitions, 0, 0 ],
										[ x / 3 - boundingBoxPartitions, 1, 1 ],
										0
									));
								} else if (side === 'back-middlePlinth') {
									return (ViewerNS.Component.mtx([ x / 3, 0, 0 ], [ x / 3, 1, 1 ], 0));
								} else if (side === 'back-rightPlinthOpened') {
									return (ViewerNS.Component.mtx([ 2 * x / 3, 0, 0 ], [ x / 3 - boundingBoxCorner.depth, 1, 1 ], 0));
								} else if (side === 'back-cornerRightPlinth') {
									return (ViewerNS.Component.mtx([ x, 0, 0 ], [ 1, 1, 1 ], 270));
								} else {
									return (ViewerNS.Component.mtx([ 1, 1, 1 ], [ 0, 0, 0 ], 0));
								}
							} else {
								if (side === 'right') {
									return (ViewerNS.Component.mtx([ (x / 2), 0, -z / 2 ], [ 1, 1, 1 ], 270));
								} else if (side === 'back') {
									return (ViewerNS.Component.mtx([ -(x / 2), 0, -z / 2 ], [ 1, 1, 1 ], 0));
								} else if (side === 'right-leftPlinth') {
									return (ViewerNS.Component.mtx(
										[ boundingBoxCorner.width, 0, 0 ],
										[ z / 3 - boundingBoxCorner.width, 1, 1 ],
										0
									));
								} else if (side === 'right-middlePlinth') {
									return (ViewerNS.Component.mtx([ z / 3, 0, 0 ], [ z / 3, 1, 1 ], 0));
								} else if (side === 'right-rightPlinth') {
									return (ViewerNS.Component.mtx([ 2 * z / 3, 0, 0 ], [ z / 3, 1, 1 ], 0));
								} else if (side === 'back-leftPlinthClosed') {
									return (ViewerNS.Component.mtx([ 0, 0, 0 ], [ x / 3, 1, 1 ], 0));
								} else if (side === 'back-middlePlinth') {
									return (ViewerNS.Component.mtx([ x / 3, 0, 0 ], [ x / 3, 1, 1 ], 0));
								} else if (side === 'back-rightPlinthOpened') {
									return (ViewerNS.Component.mtx([ 2 * x / 3, 0, 0 ], [ x / 3 - boundingBoxCorner.depth, 1, 1 ], 0));
								} else if (side === 'back-cornerRightPlinth') {
									return (ViewerNS.Component.mtx([ x, 0, 0 ], [ 1, 1, 1 ], 270));
								} else {
									return (ViewerNS.Component.mtx([ 1, 1, 1 ], [ 0, 0, 0 ], 0));
								}
							}
						} else if (layoutId === 'shape-left-back-right') {
							if (partitionHeadsPosition === 'left') {
								if (side === 'left') {
									return (ViewerNS.Component.mtx([ -(x / 2), 0, z / 2 ], [ 1, 1, 1 ], 90));
								} else if (side === 'back') {
									return (ViewerNS.Component.mtx([ -(x / 2), 0, -z / 2 ], [ 1, 1, 1 ], 0));
								} else if (side === 'right') {
									return (ViewerNS.Component.mtx([ (x / 2), 0, -z / 2 ], [ 1, 1, 1 ], 270));
								} else if (side === 'left-leftPlinth') {
									return (ViewerNS.Component.mtx(
										[ boundingBoxPartitions, 0, 0 ],
										[ z / 3 - boundingBoxPartitions, 1, 1 ],
										0
									));
								} else if (side === 'left-middlePlinth') {
									return (ViewerNS.Component.mtx([ z / 3, 0, 0 ], [ z / 3, 1, 1 ], 0));
								} else if (side === 'left-rightPlinth') {
									return (ViewerNS.Component.mtx([ 2 * z / 3, 0, 0 ], [ z / 3 - boundingBoxCorner.depth, 1, 1 ], 0));
								} else if (side === 'back-cornerLeftPlinth') {
									return (ViewerNS.Component.mtx([ 0, 0, 0 ], [ 1, 1, 1 ], 0));
								} else if (side === 'back-leftPlinthOpened') {
									return (ViewerNS.Component.mtx(
										[ boundingBoxCorner.width, 0, 0 ],
										[ x / 3 - boundingBoxCorner.width, 1, 1 ],
										0
									));
								} else if (side === 'back-middlePlinth') {
									return (ViewerNS.Component.mtx([ x / 3, 0, 0 ], [ x / 3, 1, 1 ], 0));
								} else if (side === 'back-rightPlinthOpened') {
									return (ViewerNS.Component.mtx([ 2 * x / 3, 0, 0 ], [ x / 3 - boundingBoxCorner.depth, 1, 1 ], 0));
								} else if (side === 'back-cornerRightPlinth') {
									return (ViewerNS.Component.mtx([ x, 0, 0 ], [ 1, 1, 1 ], 270));
								} else if (side === 'right-leftPlinth') {
									return (ViewerNS.Component.mtx(
										[ boundingBoxCorner.width, 0, 0 ],
										[ z / 3 - boundingBoxCorner.width, 1, 1 ],
										0
									));
								} else if (side === 'right-middlePlinth') {
									return (ViewerNS.Component.mtx([ z / 3, 0, 0 ], [ z / 3, 1, 1 ], 0));
								} else if (side === 'right-rightPlinth') {
									return (ViewerNS.Component.mtx([ 2 * z / 3, 0, 0 ], [ z / 3, 1, 1 ], 0));
								} else {
									return (ViewerNS.Component.mtx([ 1, 1, 1 ], [ 0, 0, 0 ], 0));
								}
							} else if (partitionHeadsPosition === 'left-right') {
								if (side === 'left') {
									return (ViewerNS.Component.mtx([ -(x / 2), 0, z / 2 ], [ 1, 1, 1 ], 90));
								} else if (side === 'back') {
									return (ViewerNS.Component.mtx([ -(x / 2), 0, -z / 2 ], [ 1, 1, 1 ], 0));
								} else if (side === 'right') {
									return (ViewerNS.Component.mtx([ (x / 2), 0, -z / 2 ], [ 1, 1, 1 ], 270));
								} else if (side === 'left-leftPlinth') {
									return (ViewerNS.Component.mtx(
										[ boundingBoxPartitions, 0, 0 ],
										[ z / 3 - boundingBoxPartitions, 1, 1 ],
										0
									));
								} else if (side === 'left-middlePlinth') {
									return (ViewerNS.Component.mtx([ z / 3, 0, 0 ], [ z / 3, 1, 1 ], 0));
								} else if (side === 'left-rightPlinth') {
									return (ViewerNS.Component.mtx([ 2 * z / 3, 0, 0 ], [ z / 3 - boundingBoxCorner.depth, 1, 1 ], 0));
								} else if (side === 'back-cornerLeftPlinth') {
									return (ViewerNS.Component.mtx([ 0, 0, 0 ], [ 1, 1, 1 ], 0));
								} else if (side === 'back-leftPlinthOpened') {
									return (ViewerNS.Component.mtx(
										[ boundingBoxCorner.width, 0, 0 ],
										[ x / 3 - boundingBoxCorner.width, 1, 1 ],
										0
									));
								} else if (side === 'back-middlePlinth') {
									return (ViewerNS.Component.mtx([ x / 3, 0, 0 ], [ x / 3, 1, 1 ], 0));
								} else if (side === 'back-rightPlinthOpened') {
									return (ViewerNS.Component.mtx([ 2 * x / 3, 0, 0 ], [ x / 3 - boundingBoxCorner.depth, 1, 1 ], 0));
								} else if (side === 'back-cornerRightPlinth') {
									return (ViewerNS.Component.mtx([ x, 0, 0 ], [ 1, 1, 1 ], 270));
								} else if (side === 'right-leftPlinth') {
									return (ViewerNS.Component.mtx(
										[ boundingBoxCorner.width, 0, 0 ],
										[ z / 3 - boundingBoxCorner.width, 1, 1 ],
										0
									));
								} else if (side === 'right-middlePlinth') {
									return (ViewerNS.Component.mtx([ z / 3, 0, 0 ], [ z / 3, 1, 1 ], 0));
								} else if (side === 'right-rightPlinth') {
									return (ViewerNS.Component.mtx([ 2 * z / 3, 0, 0 ], [ z / 3 - boundingBoxPartitions, 1, 1 ], 0));
								} else {
									return (ViewerNS.Component.mtx([ 1, 1, 1 ], [ 0, 0, 0 ], 0));
								}
							} else {
								if (side === 'left') {
									return (ViewerNS.Component.mtx([ -(x / 2), 0, z / 2 ], [ 1, 1, 1 ], 90));
								} else if (side === 'back') {
									return (ViewerNS.Component.mtx([ -(x / 2), 0, -z / 2 ], [ 1, 1, 1 ], 0));
								} else if (side === 'right') {
									return (ViewerNS.Component.mtx([ (x / 2), 0, -z / 2 ], [ 1, 1, 1 ], 270));
								} else if (side === 'left-leftPlinth') {
									return (ViewerNS.Component.mtx([ 0, 0, 0 ], [ z / 3, 1, 1 ], 0));
								} else if (side === 'left-middlePlinth') {
									return (ViewerNS.Component.mtx([ z / 3, 0, 0 ], [ z / 3, 1, 1 ], 0));
								} else if (side === 'left-rightPlinth') {
									return (ViewerNS.Component.mtx([ 2 * z / 3, 0, 0 ], [ z / 3 - boundingBoxCorner.depth, 1, 1 ], 0));
								} else if (side === 'back-cornerLeftPlinth') {
									return (ViewerNS.Component.mtx([ 0, 0, 0 ], [ 1, 1, 1 ], 0));
								} else if (side === 'back-leftPlinthOpened') {
									return (ViewerNS.Component.mtx(
										[ boundingBoxCorner.width, 0, 0 ],
										[ x / 3 - boundingBoxCorner.width, 1, 1 ],
										0
									));
								} else if (side === 'back-middlePlinth') {
									return (ViewerNS.Component.mtx([ x / 3, 0, 0 ], [ x / 3, 1, 1 ], 0));
								} else if (side === 'back-rightPlinthOpened') {
									return (ViewerNS.Component.mtx([ 2 * x / 3, 0, 0 ], [ x / 3 - boundingBoxCorner.depth, 1, 1 ], 0));
								} else if (side === 'back-cornerRightPlinth') {
									return (ViewerNS.Component.mtx([ x, 0, 0 ], [ 1, 1, 1 ], 270));
								} else if (side === 'right-leftPlinth') {
									return (ViewerNS.Component.mtx(
										[ boundingBoxCorner.width, 0, 0 ],
										[ z / 3 - boundingBoxCorner.width, 1, 1 ],
										0
									));
								} else if (side === 'right-middlePlinth') {
									return (ViewerNS.Component.mtx([ z / 3, 0, 0 ], [ z / 3, 1, 1 ], 0));
								} else if (side === 'right-rightPlinth') {
									return (ViewerNS.Component.mtx([ 2 * z / 3, 0, 0 ], [ z / 3, 1, 1 ], 0));
								} else {
									return (ViewerNS.Component.mtx([ 1, 1, 1 ], [ 0, 0, 0 ], 0));
								}
							}
						} else {
							throw STD.errors.user('Unknown layoutId in plinth');
						}
					} else {
						return (ViewerNS.Component.mtx([ 1, 1, 1 ], [ 0, 0, 0 ], 0));
					}
				} else {
					throw STD.errors.user('Unknown product name in plinth');
				}
			}
		}
		if (product.id === 'prestige' || product.id === 'confort') {
			if (layoutId === 'shape-no-wall') {
				return (ViewerNS.Component.mtx([ 1, 1, 1 ], [ 0, 0, 0 ], 0));
			} else if (layoutId === 'shape-back-left') {
				if (side === 'left') {
					return (ViewerNS.Component.mtx([ -(x / 2), 0, z / 2 ], [ 1, 1, 1 ], 90));
				} else if (side === 'back') {
					return (ViewerNS.Component.mtx([ -(x / 2), 0, -z / 2 ], [ 1, 1, 1 ], 0));
				} else if (side === 'left-leftPlinth') {
					return (ViewerNS.Component.mtx([ 0, 0, 0 ], [ z / 3, 1, 1 ], 0));
				} else if (side === 'left-middlePlinth') {
					return (ViewerNS.Component.mtx([ z / 3, 0, 0 ], [ z / 3, 1, 1 ], 0));
				} else if (side === 'left-rightPlinth') {
					return (ViewerNS.Component.mtx([ 2 * z / 3, 0, 0 ], [ z / 3 - boundingBoxCorner.depth, 1, 1 ], 0));
				} else if (side === 'back-leftPlinthOpened') {
					return (ViewerNS.Component.mtx([ boundingBoxCorner.width, 0, 0 ], [ x / 3 - boundingBoxCorner.width, 1, 1 ], 0));
				} else if (side === 'back-middlePlinth') {
					return (ViewerNS.Component.mtx([ x / 3, 0, 0 ], [ x / 3, 1, 1 ], 0));
				} else if (side === 'back-rightPlinthClosed') {
					return (ViewerNS.Component.mtx([ 2 * x / 3, 0, 0 ], [ x / 3, 1, 1 ], 0));
				} else if (side === 'back-cornerLeftPlinth') {
					return (ViewerNS.Component.mtx([ 0, 0, 0 ], [ 1, 1, 1 ], 0));
				} else {
					return (ViewerNS.Component.mtx([ 1, 1, 1 ], [ 0, 0, 0 ], 0));
				}
			} else if (layoutId === 'shape-back') {
				if (side === 'back') {
					return (ViewerNS.Component.mtx([ -(x / 2), 0, -z / 2 ], [ 1, 1, 1 ], 0));
				} else if (side === 'back-leftPlinthClosed') {
					return (ViewerNS.Component.mtx([ 0, 0, 0 ], [ x / 3, 1, 1 ], 0));
				} else if (side === 'back-middlePlinth') {
					return (ViewerNS.Component.mtx([ x / 3, 0, 0 ], [ x / 3, 1, 1 ], 0));
				} else if (side === 'back-rightPlinthClosed') {
					return (ViewerNS.Component.mtx([ 2 * x / 3, 0, 0 ], [ x / 3, 1, 1 ], 0));
				} else {
					return (ViewerNS.Component.mtx([ 1, 1, 1 ], [ 0, 0, 0 ], 0));
				}
			} else if (layoutId === 'shape-back-right') {
				if (side === 'right') {
					return (ViewerNS.Component.mtx([ (x / 2), 0, -z / 2 ], [ 1, 1, 1 ], 270));
				} else if (side === 'back') {
					return (ViewerNS.Component.mtx([ -(x / 2), 0, -z / 2 ], [ 1, 1, 1 ], 0));
				} else if (side === 'right-leftPlinth') {
					return (ViewerNS.Component.mtx([ boundingBoxCorner.width, 0, 0 ], [ z / 3 - boundingBoxCorner.width, 1, 1 ], 0));
				} else if (side === 'right-middlePlinth') {
					return (ViewerNS.Component.mtx([ z / 3, 0, 0 ], [ z / 3, 1, 1 ], 0));
				} else if (side === 'right-rightPlinth') {
					return (ViewerNS.Component.mtx([ 2 * z / 3, 0, 0 ], [ z / 3, 1, 1 ], 0));
				} else if (side === 'back-leftPlinthClosed') {
					return (ViewerNS.Component.mtx([ 0, 0, 0 ], [ x / 3, 1, 1 ], 0));
				} else if (side === 'back-middlePlinth') {
					return (ViewerNS.Component.mtx([ x / 3, 0, 0 ], [ x / 3, 1, 1 ], 0));
				} else if (side === 'back-rightPlinthOpened') {
					return (ViewerNS.Component.mtx([ 2 * x / 3, 0, 0 ], [ x / 3 - boundingBoxCorner.depth, 1, 1 ], 0));
				} else if (side === 'back-cornerRightPlinth') {
					return (ViewerNS.Component.mtx([ x, 0, 0 ], [ 1, 1, 1 ], 270));
				} else {
					return (ViewerNS.Component.mtx([ 1, 1, 1 ], [ 0, 0, 0 ], 0));
				}
			} else if (layoutId === 'shape-left-back-right') {
				if (side === 'left') {
					return (ViewerNS.Component.mtx([ -(x / 2), 0, z / 2 ], [ 1, 1, 1 ], 90));
				} else if (side === 'back') {
					return (ViewerNS.Component.mtx([ -(x / 2), 0, -z / 2 ], [ 1, 1, 1 ], 0));
				} else if (side === 'right') {
					return (ViewerNS.Component.mtx([ (x / 2), 0, -z / 2 ], [ 1, 1, 1 ], 270));
				} else if (side === 'left-leftPlinth') {
					return (ViewerNS.Component.mtx([ 0, 0, 0 ], [ z / 3, 1, 1 ], 0));
				} else if (side === 'left-middlePlinth') {
					return (ViewerNS.Component.mtx([ z / 3, 0, 0 ], [ z / 3, 1, 1 ], 0));
				} else if (side === 'left-rightPlinth') {
					return (ViewerNS.Component.mtx([ 2 * z / 3, 0, 0 ], [ z / 3 - boundingBoxCorner.depth, 1, 1 ], 0));
				} else if (side === 'back-cornerLeftPlinth') {
					return (ViewerNS.Component.mtx([ 0, 0, 0 ], [ 1, 1, 1 ], 0));
				} else if (side === 'back-leftPlinthOpened') {
					return (ViewerNS.Component.mtx([ boundingBoxCorner.width, 0, 0 ], [ x / 3 - boundingBoxCorner.width, 1, 1 ], 0));
				} else if (side === 'back-middlePlinth') {
					return (ViewerNS.Component.mtx([ x / 3, 0, 0 ], [ x / 3, 1, 1 ], 0));
				} else if (side === 'back-rightPlinthOpened') {
					return (ViewerNS.Component.mtx([ 2 * x / 3, 0, 0 ], [ x / 3 - boundingBoxCorner.depth, 1, 1 ], 0));
				} else if (side === 'back-cornerRightPlinth') {
					return (ViewerNS.Component.mtx([ x, 0, 0 ], [ 1, 1, 1 ], 270));
				} else if (side === 'right-leftPlinth') {
					return (ViewerNS.Component.mtx([ boundingBoxCorner.width, 0, 0 ], [ z / 3 - boundingBoxCorner.width, 1, 1 ], 0));
				} else if (side === 'right-middlePlinth') {
					return (ViewerNS.Component.mtx([ z / 3, 0, 0 ], [ z / 3, 1, 1 ], 0));
				} else if (side === 'right-rightPlinth') {
					return (ViewerNS.Component.mtx([ 2 * z / 3, 0, 0 ], [ z / 3, 1, 1 ], 0));
				} else {
					return (ViewerNS.Component.mtx([ 1, 1, 1 ], [ 0, 0, 0 ], 0));
				}
			} else {
				throw STD.errors.user('Unknown layoutId in plinth');
			}
		} else {
			if (layoutId === 'shape-no-wall') {
				return (ViewerNS.Component.mtx([ 1, 1, 1 ], [ 0, 0, 0 ], 0));
			} else if (layoutId === 'shape-back-left') {
				if (partitionHeadsPosition === 'left') {
					if (side === 'left') {
						return (ViewerNS.Component.mtx([ -(x / 2), 0, z / 2 ], [ 1, 1, 1 ], 90));
					} else if (side === 'back') {
						return (ViewerNS.Component.mtx([ -(x / 2), 0, -z / 2 ], [ 1, 1, 1 ], 0));
					} else if (side === 'left-leftPlinth') {
						return (ViewerNS.Component.mtx([ boundingBoxPartitions, 0, 0 ], [ z / 3 - boundingBoxPartitions, 1, 1 ], 0));
					} else if (side === 'left-middlePlinth') {
						return (ViewerNS.Component.mtx([ z / 3, 0, 0 ], [ z / 3, 1, 1 ], 0));
					} else if (side === 'left-rightPlinth') {
						return (ViewerNS.Component.mtx([ 2 * z / 3, 0, 0 ], [ z / 3 - boundingBoxCorner.depth, 1, 1 ], 0));
					} else if (side === 'back-leftPlinthOpened') {
						return (ViewerNS.Component.mtx([ boundingBoxCorner.width, 0, 0 ], [ x / 3 - boundingBoxCorner.width, 1, 1 ], 0));
					} else if (side === 'back-middlePlinth') {
						return (ViewerNS.Component.mtx([ x / 3, 0, 0 ], [ x / 3, 1, 1 ], 0));
					} else if (side === 'back-rightPlinthClosed') {
						return (ViewerNS.Component.mtx([ 2 * x / 3, 0, 0 ], [ x / 3, 1, 1 ], 0));
					} else if (side === 'back-cornerLeftPlinth') {
						return (ViewerNS.Component.mtx([ 0, 0, 0 ], [ 1, 1, 1 ], 0));
					} else {
						return (ViewerNS.Component.mtx([ 1, 1, 1 ], [ 0, 0, 0 ], 0));
					}
				} else if (partitionHeadsPosition === 'back') {
					if (side === 'left') {
						return (ViewerNS.Component.mtx([ -(x / 2), 0, z / 2 ], [ 1, 1, 1 ], 90));
					} else if (side === 'back') {
						return (ViewerNS.Component.mtx([ -(x / 2), 0, -z / 2 ], [ 1, 1, 1 ], 0));
					} else if (side === 'left-leftPlinth') {
						return (ViewerNS.Component.mtx([ 0, 0, 0 ], [ z / 3, 1, 1 ], 0));
					} else if (side === 'left-middlePlinth') {
						return (ViewerNS.Component.mtx([ z / 3, 0, 0 ], [ z / 3, 1, 1 ], 0));
					} else if (side === 'left-rightPlinth') {
						return (ViewerNS.Component.mtx([ 2 * z / 3, 0, 0 ], [ z / 3 - boundingBoxCorner.depth, 1, 1 ], 0));
					} else if (side === 'back-leftPlinthOpened') {
						return (ViewerNS.Component.mtx([ boundingBoxCorner.width, 0, 0 ], [ x / 3 - boundingBoxCorner.width, 1, 1 ], 0));
					} else if (side === 'back-middlePlinth') {
						return (ViewerNS.Component.mtx([ x / 3, 0, 0 ], [ x / 3, 1, 1 ], 0));
					} else if (side === 'back-rightPlinthClosed') {
						return (ViewerNS.Component.mtx([ 2 * x / 3, 0, 0 ], [ x / 3 - boundingBoxPartitions, 1, 1 ], 0));
					} else if (side === 'back-cornerLeftPlinth') {
						return (ViewerNS.Component.mtx([ 0, 0, 0 ], [ 1, 1, 1 ], 0));
					} else {
						return (ViewerNS.Component.mtx([ 1, 1, 1 ], [ 0, 0, 0 ], 0));
					}
				} else if (partitionHeadsPosition === 'back-left') {
					if (side === 'left') {
						return (ViewerNS.Component.mtx([ -(x / 2), 0, z / 2 ], [ 1, 1, 1 ], 90));
					} else if (side === 'back') {
						return (ViewerNS.Component.mtx([ -(x / 2), 0, -z / 2 ], [ 1, 1, 1 ], 0));
					} else if (side === 'left-leftPlinth') {
						return (ViewerNS.Component.mtx([ boundingBoxPartitions, 0, 0 ], [ z / 3 - boundingBoxPartitions, 1, 1 ], 0));
					} else if (side === 'left-middlePlinth') {
						return (ViewerNS.Component.mtx([ z / 3, 0, 0 ], [ z / 3, 1, 1 ], 0));
					} else if (side === 'left-rightPlinth') {
						return (ViewerNS.Component.mtx([ 2 * z / 3, 0, 0 ], [ z / 3 - boundingBoxCorner.depth, 1, 1 ], 0));
					} else if (side === 'back-leftPlinthOpened') {
						return (ViewerNS.Component.mtx([ boundingBoxCorner.width, 0, 0 ], [ x / 3 - boundingBoxCorner.width, 1, 1 ], 0));
					} else if (side === 'back-middlePlinth') {
						return (ViewerNS.Component.mtx([ x / 3, 0, 0 ], [ x / 3, 1, 1 ], 0));
					} else if (side === 'back-rightPlinthClosed') {
						return (ViewerNS.Component.mtx([ 2 * x / 3, 0, 0 ], [ x / 3 - boundingBoxPartitions, 1, 1 ], 0));
					} else if (side === 'back-cornerLeftPlinth') {
						return (ViewerNS.Component.mtx([ 0, 0, 0 ], [ 1, 1, 1 ], 0));
					} else {
						return (ViewerNS.Component.mtx([ 1, 1, 1 ], [ 0, 0, 0 ], 0));
					}
				} else {
					if (side === 'left') {
						return (ViewerNS.Component.mtx([ -(x / 2), 0, z / 2 ], [ 1, 1, 1 ], 90));
					} else if (side === 'back') {
						return (ViewerNS.Component.mtx([ -(x / 2), 0, -z / 2 ], [ 1, 1, 1 ], 0));
					} else if (side === 'left-leftPlinth') {
						return (ViewerNS.Component.mtx([ 0, 0, 0 ], [ z / 3, 1, 1 ], 0));
					} else if (side === 'left-middlePlinth') {
						return (ViewerNS.Component.mtx([ z / 3, 0, 0 ], [ z / 3, 1, 1 ], 0));
					} else if (side === 'left-rightPlinth') {
						return (ViewerNS.Component.mtx([ 2 * z / 3, 0, 0 ], [ z / 3 - boundingBoxCorner.depth, 1, 1 ], 0));
					} else if (side === 'back-leftPlinthOpened') {
						return (ViewerNS.Component.mtx([ boundingBoxCorner.width, 0, 0 ], [ x / 3 - boundingBoxCorner.width, 1, 1 ], 0));
					} else if (side === 'back-middlePlinth') {
						return (ViewerNS.Component.mtx([ x / 3, 0, 0 ], [ x / 3, 1, 1 ], 0));
					} else if (side === 'back-rightPlinthClosed') {
						return (ViewerNS.Component.mtx([ 2 * x / 3, 0, 0 ], [ x / 3, 1, 1 ], 0));
					} else if (side === 'back-cornerLeftPlinth') {
						return (ViewerNS.Component.mtx([ 0, 0, 0 ], [ 1, 1, 1 ], 0));
					} else {
						return (ViewerNS.Component.mtx([ 1, 1, 1 ], [ 0, 0, 0 ], 0));
					}
				}
			} else if (layoutId === 'shape-back') {
				if (partitionHeadsPosition === 'back') {
					if (side === 'back') {
						return (ViewerNS.Component.mtx([ -(x / 2), 0, -z / 2 ], [ 1, 1, 1 ], 0));
					} else if (side === 'back-leftPlinthClosed') {
						return (ViewerNS.Component.mtx([ boundingBoxPartitions, 0, 0 ], [ x / 3 - boundingBoxPartitions, 1, 1 ], 0));
					} else if (side === 'back-middlePlinth') {
						return (ViewerNS.Component.mtx([ x / 3, 0, 0 ], [ x / 3, 1, 1 ], 0));
					} else if (side === 'back-rightPlinthClosed') {
						return (ViewerNS.Component.mtx([ 2 * x / 3, 0, 0 ], [ x / 3, 1, 1 ], 0));
					} else {
						return (ViewerNS.Component.mtx([ 1, 1, 1 ], [ 0, 0, 0 ], 0));
					}
				} else if (partitionHeadsPosition === 'back-back') {
					if (side === 'back') {
						return (ViewerNS.Component.mtx([ -(x / 2), 0, -z / 2 ], [ 1, 1, 1 ], 0));
					} else if (side === 'back-leftPlinthClosed') {
						return (ViewerNS.Component.mtx([ boundingBoxPartitions, 0, 0 ], [ x / 3 - boundingBoxPartitions, 1, 1 ], 0));
					} else if (side === 'back-middlePlinth') {
						return (ViewerNS.Component.mtx([ x / 3, 0, 0 ], [ x / 3, 1, 1 ], 0));
					} else if (side === 'back-rightPlinthClosed') {
						return (ViewerNS.Component.mtx([ 2 * x / 3, 0, 0 ], [ x / 3 - boundingBoxPartitions, 1, 1 ], 0));
					} else {
						return (ViewerNS.Component.mtx([ 1, 1, 1 ], [ 0, 0, 0 ], 0));
					}
				} else {
					if (side === 'back') {
						return (ViewerNS.Component.mtx([ -(x / 2), 0, -z / 2 ], [ 1, 1, 1 ], 0));
					} else if (side === 'back-leftPlinthClosed') {
						return (ViewerNS.Component.mtx([ 0, 0, 0 ], [ x / 3, 1, 1 ], 0));
					} else if (side === 'back-middlePlinth') {
						return (ViewerNS.Component.mtx([ x / 3, 0, 0 ], [ x / 3, 1, 1 ], 0));
					} else if (side === 'back-rightPlinthClosed') {
						return (ViewerNS.Component.mtx([ 2 * x / 3, 0, 0 ], [ x / 3, 1, 1 ], 0));
					} else {
						return (ViewerNS.Component.mtx([ 1, 1, 1 ], [ 0, 0, 0 ], 0));
					}
				}

			} else if (layoutId === 'shape-back-right') {
				if (partitionHeadsPosition === 'back') {
					if (side === 'right') {
						return (ViewerNS.Component.mtx([ (x / 2), 0, -z / 2 ], [ 1, 1, 1 ], 270));
					} else if (side === 'back') {
						return (ViewerNS.Component.mtx([ -(x / 2), 0, -z / 2 ], [ 1, 1, 1 ], 0));
					} else if (side === 'right-leftPlinth') {
						return (ViewerNS.Component.mtx([ boundingBoxCorner.width, 0, 0 ], [ z / 3 - boundingBoxCorner.width, 1, 1 ], 0));
					} else if (side === 'right-middlePlinth') {
						return (ViewerNS.Component.mtx([ z / 3, 0, 0 ], [ z / 3, 1, 1 ], 0));
					} else if (side === 'right-rightPlinth') {
						return (ViewerNS.Component.mtx([ 2 * z / 3, 0, 0 ], [ z / 3, 1, 1 ], 0));
					} else if (side === 'back-leftPlinthClosed') {
						return (ViewerNS.Component.mtx([ boundingBoxPartitions, 0, 0 ], [ x / 3 - boundingBoxPartitions, 1, 1 ], 0));
					} else if (side === 'back-middlePlinth') {
						return (ViewerNS.Component.mtx([ x / 3, 0, 0 ], [ x / 3, 1, 1 ], 0));
					} else if (side === 'back-rightPlinthOpened') {
						return (ViewerNS.Component.mtx([ 2 * x / 3, 0, 0 ], [ x / 3 - boundingBoxCorner.depth, 1, 1 ], 0));
					} else if (side === 'back-cornerRightPlinth') {
						return (ViewerNS.Component.mtx([ x, 0, 0 ], [ 1, 1, 1 ], 270));
					} else {
						return (ViewerNS.Component.mtx([ 1, 1, 1 ], [ 0, 0, 0 ], 0));
					}
				} else if (partitionHeadsPosition === 'back-right') {
					if (side === 'right') {
						return (ViewerNS.Component.mtx([ (x / 2), 0, -z / 2 ], [ 1, 1, 1 ], 270));
					} else if (side === 'back') {
						return (ViewerNS.Component.mtx([ -(x / 2), 0, -z / 2 ], [ 1, 1, 1 ], 0));
					} else if (side === 'right-leftPlinth') {
						return (ViewerNS.Component.mtx([ boundingBoxCorner.width, 0, 0 ], [ z / 3 - boundingBoxCorner.width, 1, 1 ], 0));
					} else if (side === 'right-middlePlinth') {
						return (ViewerNS.Component.mtx([ z / 3, 0, 0 ], [ z / 3, 1, 1 ], 0));
					} else if (side === 'right-rightPlinth') {
						return (ViewerNS.Component.mtx([ 2 * z / 3, 0, 0 ], [ z / 3 - boundingBoxPartitions, 1, 1 ], 0));
					} else if (side === 'back-leftPlinthClosed') {
						return (ViewerNS.Component.mtx([ boundingBoxPartitions, 0, 0 ], [ x / 3 - boundingBoxPartitions, 1, 1 ], 0));
					} else if (side === 'back-middlePlinth') {
						return (ViewerNS.Component.mtx([ x / 3, 0, 0 ], [ x / 3, 1, 1 ], 0));
					} else if (side === 'back-rightPlinthOpened') {
						return (ViewerNS.Component.mtx([ 2 * x / 3, 0, 0 ], [ x / 3 - boundingBoxCorner.depth, 1, 1 ], 0));
					} else if (side === 'back-cornerRightPlinth') {
						return (ViewerNS.Component.mtx([ x, 0, 0 ], [ 1, 1, 1 ], 270));
					} else {
						return (ViewerNS.Component.mtx([ 1, 1, 1 ], [ 0, 0, 0 ], 0));
					}
				} else {
					if (side === 'right') {
						return (ViewerNS.Component.mtx([ (x / 2), 0, -z / 2 ], [ 1, 1, 1 ], 270));
					} else if (side === 'back') {
						return (ViewerNS.Component.mtx([ -(x / 2), 0, -z / 2 ], [ 1, 1, 1 ], 0));
					} else if (side === 'right-leftPlinth') {
						return (ViewerNS.Component.mtx([ boundingBoxCorner.width, 0, 0 ], [ z / 3 - boundingBoxCorner.width, 1, 1 ], 0));
					} else if (side === 'right-middlePlinth') {
						return (ViewerNS.Component.mtx([ z / 3, 0, 0 ], [ z / 3, 1, 1 ], 0));
					} else if (side === 'right-rightPlinth') {
						return (ViewerNS.Component.mtx([ 2 * z / 3, 0, 0 ], [ z / 3, 1, 1 ], 0));
					} else if (side === 'back-leftPlinthClosed') {
						return (ViewerNS.Component.mtx([ 0, 0, 0 ], [ x / 3, 1, 1 ], 0));
					} else if (side === 'back-middlePlinth') {
						return (ViewerNS.Component.mtx([ x / 3, 0, 0 ], [ x / 3, 1, 1 ], 0));
					} else if (side === 'back-rightPlinthOpened') {
						return (ViewerNS.Component.mtx([ 2 * x / 3, 0, 0 ], [ x / 3 - boundingBoxCorner.depth, 1, 1 ], 0));
					} else if (side === 'back-cornerRightPlinth') {
						return (ViewerNS.Component.mtx([ x, 0, 0 ], [ 1, 1, 1 ], 270));
					} else {
						return (ViewerNS.Component.mtx([ 1, 1, 1 ], [ 0, 0, 0 ], 0));
					}
				}
			} else if (layoutId === 'shape-left-back-right') {
				if (partitionHeadsPosition === 'left') {
					if (side === 'left') {
						return (ViewerNS.Component.mtx([ -(x / 2), 0, z / 2 ], [ 1, 1, 1 ], 90));
					} else if (side === 'back') {
						return (ViewerNS.Component.mtx([ -(x / 2), 0, -z / 2 ], [ 1, 1, 1 ], 0));
					} else if (side === 'right') {
						return (ViewerNS.Component.mtx([ (x / 2), 0, -z / 2 ], [ 1, 1, 1 ], 270));
					} else if (side === 'left-leftPlinth') {
						return (ViewerNS.Component.mtx([ boundingBoxPartitions, 0, 0 ], [ z / 3 - boundingBoxPartitions, 1, 1 ], 0));
					} else if (side === 'left-middlePlinth') {
						return (ViewerNS.Component.mtx([ z / 3, 0, 0 ], [ z / 3, 1, 1 ], 0));
					} else if (side === 'left-rightPlinth') {
						return (ViewerNS.Component.mtx([ 2 * z / 3, 0, 0 ], [ z / 3 - boundingBoxCorner.depth, 1, 1 ], 0));
					} else if (side === 'back-cornerLeftPlinth') {
						return (ViewerNS.Component.mtx([ 0, 0, 0 ], [ 1, 1, 1 ], 0));
					} else if (side === 'back-leftPlinthOpened') {
						return (ViewerNS.Component.mtx([ boundingBoxCorner.width, 0, 0 ], [ x / 3 - boundingBoxCorner.width, 1, 1 ], 0));
					} else if (side === 'back-middlePlinth') {
						return (ViewerNS.Component.mtx([ x / 3, 0, 0 ], [ x / 3, 1, 1 ], 0));
					} else if (side === 'back-rightPlinthOpened') {
						return (ViewerNS.Component.mtx([ 2 * x / 3, 0, 0 ], [ x / 3 - boundingBoxCorner.depth, 1, 1 ], 0));
					} else if (side === 'back-cornerRightPlinth') {
						return (ViewerNS.Component.mtx([ x, 0, 0 ], [ 1, 1, 1 ], 270));
					} else if (side === 'right-leftPlinth') {
						return (ViewerNS.Component.mtx([ boundingBoxCorner.width, 0, 0 ], [ z / 3 - boundingBoxCorner.width, 1, 1 ], 0));
					} else if (side === 'right-middlePlinth') {
						return (ViewerNS.Component.mtx([ z / 3, 0, 0 ], [ z / 3, 1, 1 ], 0));
					} else if (side === 'right-rightPlinth') {
						return (ViewerNS.Component.mtx([ 2 * z / 3, 0, 0 ], [ z / 3, 1, 1 ], 0));
					} else {
						return (ViewerNS.Component.mtx([ 1, 1, 1 ], [ 0, 0, 0 ], 0));
					}
				} else if (partitionHeadsPosition === 'left-right') {
					if (side === 'left') {
						return (ViewerNS.Component.mtx([ -(x / 2), 0, z / 2 ], [ 1, 1, 1 ], 90));
					} else if (side === 'back') {
						return (ViewerNS.Component.mtx([ -(x / 2), 0, -z / 2 ], [ 1, 1, 1 ], 0));
					} else if (side === 'right') {
						return (ViewerNS.Component.mtx([ (x / 2), 0, -z / 2 ], [ 1, 1, 1 ], 270));
					} else if (side === 'left-leftPlinth') {
						return (ViewerNS.Component.mtx([ boundingBoxPartitions, 0, 0 ], [ z / 3 - boundingBoxPartitions, 1, 1 ], 0));
					} else if (side === 'left-middlePlinth') {
						return (ViewerNS.Component.mtx([ z / 3, 0, 0 ], [ z / 3, 1, 1 ], 0));
					} else if (side === 'left-rightPlinth') {
						return (ViewerNS.Component.mtx([ 2 * z / 3, 0, 0 ], [ z / 3 - boundingBoxCorner.depth, 1, 1 ], 0));
					} else if (side === 'back-cornerLeftPlinth') {
						return (ViewerNS.Component.mtx([ 0, 0, 0 ], [ 1, 1, 1 ], 0));
					} else if (side === 'back-leftPlinthOpened') {
						return (ViewerNS.Component.mtx([ boundingBoxCorner.width, 0, 0 ], [ x / 3 - boundingBoxCorner.width, 1, 1 ], 0));
					} else if (side === 'back-middlePlinth') {
						return (ViewerNS.Component.mtx([ x / 3, 0, 0 ], [ x / 3, 1, 1 ], 0));
					} else if (side === 'back-rightPlinthOpened') {
						return (ViewerNS.Component.mtx([ 2 * x / 3, 0, 0 ], [ x / 3 - boundingBoxCorner.depth, 1, 1 ], 0));
					} else if (side === 'back-cornerRightPlinth') {
						return (ViewerNS.Component.mtx([ x, 0, 0 ], [ 1, 1, 1 ], 270));
					} else if (side === 'right-leftPlinth') {
						return (ViewerNS.Component.mtx([ boundingBoxCorner.width, 0, 0 ], [ z / 3 - boundingBoxCorner.width, 1, 1 ], 0));
					} else if (side === 'right-middlePlinth') {
						return (ViewerNS.Component.mtx([ z / 3, 0, 0 ], [ z / 3, 1, 1 ], 0));
					} else if (side === 'right-rightPlinth') {
						return (ViewerNS.Component.mtx([ 2 * z / 3, 0, 0 ], [ z / 3 - boundingBoxPartitions, 1, 1 ], 0));
					} else {
						return (ViewerNS.Component.mtx([ 1, 1, 1 ], [ 0, 0, 0 ], 0));
					}
				} else {
					if (side === 'left') {
						return (ViewerNS.Component.mtx([ -(x / 2), 0, z / 2 ], [ 1, 1, 1 ], 90));
					} else if (side === 'back') {
						return (ViewerNS.Component.mtx([ -(x / 2), 0, -z / 2 ], [ 1, 1, 1 ], 0));
					} else if (side === 'right') {
						return (ViewerNS.Component.mtx([ (x / 2), 0, -z / 2 ], [ 1, 1, 1 ], 270));
					} else if (side === 'left-leftPlinth') {
						return (ViewerNS.Component.mtx([ 0, 0, 0 ], [ z / 3, 1, 1 ], 0));
					} else if (side === 'left-middlePlinth') {
						return (ViewerNS.Component.mtx([ z / 3, 0, 0 ], [ z / 3, 1, 1 ], 0));
					} else if (side === 'left-rightPlinth') {
						return (ViewerNS.Component.mtx([ 2 * z / 3, 0, 0 ], [ z / 3 - boundingBoxCorner.depth, 1, 1 ], 0));
					} else if (side === 'back-cornerLeftPlinth') {
						return (ViewerNS.Component.mtx([ 0, 0, 0 ], [ 1, 1, 1 ], 0));
					} else if (side === 'back-leftPlinthOpened') {
						return (ViewerNS.Component.mtx([ boundingBoxCorner.width, 0, 0 ], [ x / 3 - boundingBoxCorner.width, 1, 1 ], 0));
					} else if (side === 'back-middlePlinth') {
						return (ViewerNS.Component.mtx([ x / 3, 0, 0 ], [ x / 3, 1, 1 ], 0));
					} else if (side === 'back-rightPlinthOpened') {
						return (ViewerNS.Component.mtx([ 2 * x / 3, 0, 0 ], [ x / 3 - boundingBoxCorner.depth, 1, 1 ], 0));
					} else if (side === 'back-cornerRightPlinth') {
						return (ViewerNS.Component.mtx([ x, 0, 0 ], [ 1, 1, 1 ], 270));
					} else if (side === 'right-leftPlinth') {
						return (ViewerNS.Component.mtx([ boundingBoxCorner.width, 0, 0 ], [ z / 3 - boundingBoxCorner.width, 1, 1 ], 0));
					} else if (side === 'right-middlePlinth') {
						return (ViewerNS.Component.mtx([ z / 3, 0, 0 ], [ z / 3, 1, 1 ], 0));
					} else if (side === 'right-rightPlinth') {
						return (ViewerNS.Component.mtx([ 2 * z / 3, 0, 0 ], [ z / 3, 1, 1 ], 0));
					} else {
						return (ViewerNS.Component.mtx([ 1, 1, 1 ], [ 0, 0, 0 ], 0));
					}
				}
			} else {
				throw STD.errors.user('Unknown layoutId in plinth');
			}
		}

	}

	async insert() {
		// insert nodes
		const product = app.currentProduct;
		if (this.viewerNode || !product || !app.viewer.planner) {
			this.component_throwUserError('');
		}
		const plinthProductSchema = this.plannerCategory.products.find(x => x.SKU === `@plinth-${ product.id }`);
		if (!plinthProductSchema) {
			this.component_throwLibraryError('');
		}
		this.viewerNode = await plinthProductSchema.instantiate({
			rootLocalId : app.viewer.globalLocalId,
			appendType : 'insert',
			basketPart : null,
			basketUseDynamicTitleBinding : false,
			metadata : {
				id : this.id + product.id
			}
		});
		this.viewerNode.setName('Plinth ' + this.id);
	};

	async update() {
		// update nodes matrices
		if (!this.viewerNode) {
			return;
		}

		const product = app.currentProduct;
		if (!product) {
			throw STD.errors.user('No current product available!');
		}
		const layoutPart = product.getPart([ 'layout' ]);
		if (!layoutPart) {
			throw STD.errors.user('No current product available!');
		}
		const layoutCurrentOption = layoutPart.currentOption;
		if (!layoutCurrentOption) {
			return;
		}
		;
		const idMapping = this.viewerNode.idMapping;
		if (product.id === 'business' || product.id === 'siae') {
			if (!idMapping ||
				!idMapping.left ||
				!idMapping.back ||
				!idMapping.right ||
				!idMapping[ 'left-leftPlinth' ] ||
				!idMapping[ 'left-middlePlinth' ] ||
				!idMapping[ 'left-cornerPlinth' ] ||
				!idMapping[ 'left-rightPlinth' ] ||
				!idMapping[ 'back-leftPlinthClosed' ] ||
				!idMapping[ 'back-leftPlinthOpened' ] ||
				!idMapping[ 'back-middlePlinth' ] ||
				!idMapping[ 'back-cornerLeftPlinth' ] ||
				!idMapping[ 'back-cornerRightPlinth' ] ||
				!idMapping[ 'back-cornerLeftStoragePlinth' ] ||
				!idMapping[ 'back-cornerRightStoragePlinth' ] ||
				!idMapping[ 'back-rightPlinthClosed' ] ||
				!idMapping[ 'back-rightPlinthOpened' ] ||
				!idMapping[ 'right-leftPlinth' ] ||
				!idMapping[ 'right-middlePlinth' ] ||
				!idMapping[ 'right-cornerPlinth' ] ||
				!idMapping[ 'right-rightPlinth' ])
			{
				throw STD.errors.user('Nodes not correctly insert');
			}
			;
			await app.viewer.batch([
				[
					'setProductNodesInstancesMatrices', [
					{
						localId : idMapping.left,
						matrix :  this.computeMatrix('left')
					},
					{
						localId : idMapping.back,
						matrix :  this.computeMatrix('back')
					},
					{
						localId : idMapping.right,
						matrix :  this.computeMatrix('right')
					},
					{
						localId : idMapping[ 'left-leftPlinth' ],
						matrix :  this.computeMatrix('left-leftPlinth')
					},
					{
						localId : idMapping[ 'left-middlePlinth' ],
						matrix :  this.computeMatrix('left-middlePlinth')
					},
					{
						localId : idMapping[ 'left-cornerPlinth' ],
						matrix :  this.computeMatrix('left-cornerPlinth')
					},
					{
						localId : idMapping[ 'left-rightPlinth' ],
						matrix :  this.computeMatrix('left-rightPlinth')
					},
					{
						localId : idMapping[ 'back-leftPlinthClosed' ],
						matrix :  this.computeMatrix('back-leftPlinthClosed')
					},
					{
						localId : idMapping[ 'back-leftPlinthOpened' ],
						matrix :  this.computeMatrix('back-leftPlinthOpened')
					},
					{
						localId : idMapping[ 'back-middlePlinth' ],
						matrix :  this.computeMatrix('back-middlePlinth')
					},
					{
						localId : idMapping[ 'back-cornerLeftPlinth' ],
						matrix :  this.computeMatrix('back-cornerLeftPlinth')
					},
					{
						localId : idMapping[ 'back-cornerRightPlinth' ],
						matrix :  this.computeMatrix('back-cornerRightPlinth')
					},
					{
						localId : idMapping[ 'back-cornerLeftStoragePlinth' ],
						matrix :  this.computeMatrix('back-cornerLeftStoragePlinth')
					},
					{
						localId : idMapping[ 'back-cornerRightStoragePlinth' ],
						matrix :  this.computeMatrix('back-cornerRightStoragePlinth')
					},
					{
						localId : idMapping[ 'back-rightPlinthOpened' ],
						matrix :  this.computeMatrix('back-rightPlinthOpened')
					},
					{
						localId : idMapping[ 'back-rightPlinthClosed' ],
						matrix :  this.computeMatrix('back-rightPlinthClosed')
					},
					{
						localId : idMapping[ 'right-leftPlinth' ],
						matrix :  this.computeMatrix('right-leftPlinth')
					},
					{
						localId : idMapping[ 'right-middlePlinth' ],
						matrix :  this.computeMatrix('right-middlePlinth')
					},
					{
						localId : idMapping[ 'right-cornerPlinth' ],
						matrix :  this.computeMatrix('right-cornerPlinth')
					},
					{
						localId : idMapping[ 'right-rightPlinth' ],
						matrix :  this.computeMatrix('right-rightPlinth')
					}
				]
				]
			]);
		} else {
			if (!idMapping ||
				!idMapping.left ||
				!idMapping.back ||
				!idMapping.right ||
				!idMapping[ 'left-leftPlinth' ] ||
				!idMapping[ 'left-middlePlinth' ] ||
				!idMapping[ 'left-rightPlinth' ] ||
				!idMapping[ 'back-leftPlinthClosed' ] ||
				!idMapping[ 'back-leftPlinthOpened' ] ||
				!idMapping[ 'back-middlePlinth' ] ||
				!idMapping[ 'back-cornerLeftPlinth' ] ||
				!idMapping[ 'back-cornerRightPlinth' ] ||
				!idMapping[ 'back-rightPlinthClosed' ] ||
				!idMapping[ 'back-rightPlinthOpened' ] ||
				!idMapping[ 'right-leftPlinth' ] ||
				!idMapping[ 'right-middlePlinth' ] ||
				!idMapping[ 'right-rightPlinth' ])
			{
				throw STD.errors.user('Nodes not correctly insert');
			}
			;
			await app.viewer.batch([
				[
					'setProductNodesInstancesMatrices', [
					{
						localId : idMapping.left,
						matrix :  this.computeMatrix('left')
					},
					{
						localId : idMapping.back,
						matrix :  this.computeMatrix('back')
					},
					{
						localId : idMapping.right,
						matrix :  this.computeMatrix('right')
					},
					{
						localId : idMapping[ 'left-leftPlinth' ],
						matrix :  this.computeMatrix('left-leftPlinth')
					},
					{
						localId : idMapping[ 'left-middlePlinth' ],
						matrix :  this.computeMatrix('left-middlePlinth')
					},
					{
						localId : idMapping[ 'left-rightPlinth' ],
						matrix :  this.computeMatrix('left-rightPlinth')
					},
					{
						localId : idMapping[ 'back-leftPlinthClosed' ],
						matrix :  this.computeMatrix('back-leftPlinthClosed')
					},
					{
						localId : idMapping[ 'back-leftPlinthOpened' ],
						matrix :  this.computeMatrix('back-leftPlinthOpened')
					},
					{
						localId : idMapping[ 'back-middlePlinth' ],
						matrix :  this.computeMatrix('back-middlePlinth')
					},
					{
						localId : idMapping[ 'back-cornerLeftPlinth' ],
						matrix :  this.computeMatrix('back-cornerLeftPlinth')
					},
					{
						localId : idMapping[ 'back-cornerRightPlinth' ],
						matrix :  this.computeMatrix('back-cornerRightPlinth')
					},
					{
						localId : idMapping[ 'back-rightPlinthOpened' ],
						matrix :  this.computeMatrix('back-rightPlinthOpened')
					},
					{
						localId : idMapping[ 'back-rightPlinthClosed' ],
						matrix :  this.computeMatrix('back-rightPlinthClosed')
					},
					{
						localId : idMapping[ 'right-leftPlinth' ],
						matrix :  this.computeMatrix('right-leftPlinth')
					},
					{
						localId : idMapping[ 'right-middlePlinth' ],
						matrix :  this.computeMatrix('right-middlePlinth')
					},
					{
						localId : idMapping[ 'right-rightPlinth' ],
						matrix :  this.computeMatrix('right-rightPlinth')
					}
				]
				]
			]);
		}

	};

	async remove() {
		if (!this.viewerNode) {
			return;
		}
		await this.viewerNode.delete();
		this.viewerNode = null;
	};

	override async component_initialize() {
		await super.component_initialize();
	};

	override async component_start(startEvent : STD.events.Event<any, CM.Component<any, any>>) {
		await super.component_start(startEvent);
		if (!app.viewer.planner) {
			this.component_throwUserError('');
		}
		const categoryDescriptor : ViewerComponent.ProductCategory.IDescriptor & {
			products : NonNullable<ViewerComponent.ProductCategory.IDescriptor['products']>;
		} = {
			name :        'plinth',
			menuActions : {
				edit :      false,
				delete :    false,
				rotate :    false,
				duplicate : false
			},
			products :    []
		};
		const plinthsComponents = app.component_configuration.productsComponents.filter(x => x.type === 'plinth').
		reduce(
			(a, c) => {
				(<any> a)[ c.SKU.replace('plinth_', '') ] = c;
				return a;
			},
			<Record<'Left' | 'Middle' | 'Right' | 'LEDLeft' | 'LEDMiddle' | 'LEDRight' | 'Corner' | 'LEDCorner', typeof app.component_configuration.productsComponents[0]>> {}
		);
		for (const product of app.component_configuration.products) {
			if (product.SKU === 'business' || product.SKU === 'siae') {
				for (const piece of <('Left' | 'Middle' | 'Right' | 'Corner')[]> [ 'Left', 'Middle', 'Right', 'Corner' ]) {
					if (!plinthsComponents[ piece ]) {
						throw STD.errors.user(`Missing plinth "${ piece }"!`);
					}
				}
				categoryDescriptor.products.push({
					SKU :   `@plinth-${ product.SKU }`,
					nodes : [
						//1 in size...
						app.viewer.createEmptyNodeDescriptor('global', 'root', 1),
						app.viewer.createEmptyNodeDescriptor('left', 'global', 1),
						app.viewer.createEmptyNodeDescriptor('back', 'global', 1),
						app.viewer.createEmptyNodeDescriptor('right', 'global', 1),
						{
							SKU :                         <string> plinthsComponents.Left.viewerComponentSKU,
							projectCode :                 <string> plinthsComponents.Left.viewerProjectCode,
							localId :                     'left-leftPlinth',
							parentLocalId :               'left',
							snappable :                   false,
							fixedPositionSetIds :         null,
							draggable :                   false,
							doNotListAsProductComponent : true,
							matrix :                      app.viewer.mtx(
								[ 0, 0, 0 ],
								[ 0, 0, 0 ],
								0
							)
						},
						{
							SKU :                         <string> plinthsComponents.Middle.viewerComponentSKU,
							projectCode :                 <string> plinthsComponents.Middle.viewerProjectCode,
							localId :                     'left-middlePlinth',
							parentLocalId :               'left',
							snappable :                   false,
							fixedPositionSetIds :         null,
							draggable :                   false,
							doNotListAsProductComponent : true,
							matrix :                      app.viewer.mtx(
								[ 0, 0, 0 ],
								[ 0, 0, 0 ],
								0
							)
						},
						{
							SKU :                         <string> plinthsComponents.Corner.viewerComponentSKU,
							projectCode :                 <string> plinthsComponents.Corner.viewerProjectCode,
							localId :                     'left-cornerPlinth',
							parentLocalId :               'left',
							snappable :                   false,
							fixedPositionSetIds :         null,
							draggable :                   false,
							doNotListAsProductComponent : true,
							matrix :                      app.viewer.mtx(
								[ 0, 0, 0 ],
								[ 0, 0, 0 ],
								0
							)
						},
						{
							SKU :                         <string> plinthsComponents.Middle.viewerComponentSKU,
							projectCode :                 <string> plinthsComponents.Middle.viewerProjectCode,
							localId :                     'left-rightPlinth',
							parentLocalId :               'left',
							snappable :                   false,
							fixedPositionSetIds :         null,
							draggable :                   false,
							doNotListAsProductComponent : true,
							matrix :                      app.viewer.mtx(
								[ 0, 0, 0 ],
								[ 0, 0, 0 ],
								0
							)
						},
						{
							SKU :                         <string> plinthsComponents.Left.viewerComponentSKU,
							projectCode :                 <string> plinthsComponents.Left.viewerProjectCode,
							localId :                     'back-leftPlinthClosed',
							parentLocalId :               'back',
							snappable :                   false,
							fixedPositionSetIds :         null,
							draggable :                   false,
							doNotListAsProductComponent : true,
							matrix :                      app.viewer.mtx(
								[ 0, 0, 0 ],
								[ 0, 0, 0 ],
								0
							)
						},
						{
							SKU :                         <string> plinthsComponents.Middle.viewerComponentSKU,
							projectCode :                 <string> plinthsComponents.Middle.viewerProjectCode,
							localId :                     'back-leftPlinthOpened',
							parentLocalId :               'back',
							snappable :                   false,
							fixedPositionSetIds :         null,
							draggable :                   false,
							doNotListAsProductComponent : true,
							matrix :                      app.viewer.mtx(
								[ 0, 0, 0 ],
								[ 0, 0, 0 ],
								0
							)
						},
						{
							SKU :                         <string> plinthsComponents.Middle.viewerComponentSKU,
							projectCode :                 <string> plinthsComponents.Middle.viewerProjectCode,
							localId :                     'back-middlePlinth',
							parentLocalId :               'back',
							snappable :                   false,
							fixedPositionSetIds :         null,
							draggable :                   false,
							doNotListAsProductComponent : true,
							matrix :                      app.viewer.mtx(
								[ 0, 0, 0 ],
								[ 0, 0, 0 ],
								0
							)
						},
						{
							SKU :                         <string> plinthsComponents.Corner.viewerComponentSKU,
							projectCode :                 <string> plinthsComponents.Corner.viewerProjectCode,
							localId :                     'back-cornerLeftPlinth',
							parentLocalId :               'back',
							snappable :                   false,
							fixedPositionSetIds :         null,
							draggable :                   false,
							doNotListAsProductComponent : true,
							matrix :                      app.viewer.mtx(
								[ 0, 0, 0 ],
								[ 0, 0, 0 ],
								0
							)
						},
						{
							SKU :                         <string> plinthsComponents.Corner.viewerComponentSKU,
							projectCode :                 <string> plinthsComponents.Corner.viewerProjectCode,
							localId :                     'back-cornerRightPlinth',
							parentLocalId :               'back',
							snappable :                   false,
							fixedPositionSetIds :         null,
							draggable :                   false,
							doNotListAsProductComponent : true,
							matrix :                      app.viewer.mtx(
								[ 0, 0, 0 ],
								[ 0, 0, 0 ],
								0
							)
						},
						{
							SKU :                         <string> plinthsComponents.Corner.viewerComponentSKU,
							projectCode :                 <string> plinthsComponents.Corner.viewerProjectCode,
							localId :                     'back-cornerLeftStoragePlinth',
							parentLocalId :               'back',
							snappable :                   false,
							fixedPositionSetIds :         null,
							draggable :                   false,
							doNotListAsProductComponent : true,
							matrix :                      app.viewer.mtx(
								[ 0, 0, 0 ],
								[ 0, 0, 0 ],
								0
							)
						},
						{
							SKU :                         <string> plinthsComponents.Corner.viewerComponentSKU,
							projectCode :                 <string> plinthsComponents.Corner.viewerProjectCode,
							localId :                     'back-cornerRightStoragePlinth',
							parentLocalId :               'back',
							snappable :                   false,
							fixedPositionSetIds :         null,
							draggable :                   false,
							doNotListAsProductComponent : true,
							matrix :                      app.viewer.mtx(
								[ 0, 0, 0 ],
								[ 0, 0, 0 ],
								0
							)
						},
						{
							SKU :                         <string> plinthsComponents.Right.viewerComponentSKU,
							projectCode :                 <string> plinthsComponents.Right.viewerProjectCode,
							localId :                     'back-rightPlinthClosed',
							parentLocalId :               'back',
							snappable :                   false,
							fixedPositionSetIds :         null,
							draggable :                   false,
							doNotListAsProductComponent : true,
							matrix :                      app.viewer.mtx(
								[ 0, 0, 0 ],
								[ 0, 0, 0 ],
								0
							)
						},
						{
							SKU :                         <string> plinthsComponents.Middle.viewerComponentSKU,
							projectCode :                 <string> plinthsComponents.Middle.viewerProjectCode,
							localId :                     'back-rightPlinthOpened',
							parentLocalId :               'back',
							snappable :                   false,
							fixedPositionSetIds :         null,
							draggable :                   false,
							doNotListAsProductComponent : true,
							matrix :                      app.viewer.mtx(
								[ 0, 0, 0 ],
								[ 0, 0, 0 ],
								0
							)
						},
						{
							SKU :                         <string> plinthsComponents.Middle.viewerComponentSKU,
							projectCode :                 <string> plinthsComponents.Middle.viewerProjectCode,
							localId :                     'right-leftPlinth',
							parentLocalId :               'right',
							snappable :                   false,
							fixedPositionSetIds :         null,
							draggable :                   false,
							doNotListAsProductComponent : true,
							matrix :                      app.viewer.mtx(
								[ 0, 0, 0 ],
								[ 0, 0, 0 ],
								0
							)
						},
						{
							SKU :                         <string> plinthsComponents.Middle.viewerComponentSKU,
							projectCode :                 <string> plinthsComponents.Middle.viewerProjectCode,
							localId :                     'right-middlePlinth',
							parentLocalId :               'right',
							snappable :                   false,
							fixedPositionSetIds :         null,
							draggable :                   false,
							doNotListAsProductComponent : true,
							matrix :                      app.viewer.mtx(
								[ 0, 0, 0 ],
								[ 0, 0, 0 ],
								0
							)
						},
						{
							SKU :                         <string> plinthsComponents.Corner.viewerComponentSKU,
							projectCode :                 <string> plinthsComponents.Corner.viewerProjectCode,
							localId :                     'right-cornerPlinth',
							parentLocalId :               'right',
							snappable :                   false,
							fixedPositionSetIds :         null,
							draggable :                   false,
							doNotListAsProductComponent : true,
							matrix :                      app.viewer.mtx(
								[ 0, 0, 0 ],
								[ 0, 0, 0 ],
								0
							)
						},
						{
							SKU :                         <string> plinthsComponents.Right.viewerComponentSKU,
							projectCode :                 <string> plinthsComponents.Right.viewerProjectCode,
							localId :                     'right-rightPlinth',
							parentLocalId :               'right',
							snappable :                   false,
							fixedPositionSetIds :         null,
							draggable :                   false,
							doNotListAsProductComponent : true,
							matrix :                      app.viewer.mtx(
								[ 0, 0, 0 ],
								[ 0, 0, 0 ],
								0
							)
						}
					]
				});
			} else if (product.SKU === 'confort' || product.SKU === 'prestige') {
				for (const piece of
					<('LEDLeft' | 'LEDMiddle' | 'LEDRight' | 'LEDCorner')[]> [ 'LEDLeft', 'LEDMiddle', 'LEDRight', 'LEDCorner' ])
				{
					if (!plinthsComponents[ piece ]) {
						throw STD.errors.user(`Missing plinth "${ piece }"!`);
					}
				}
				categoryDescriptor.products.push({
					SKU :   `@plinth-${ product.SKU }`,
					nodes : [
						//1 in size...
						app.viewer.createEmptyNodeDescriptor('global', 'root', 1),
						app.viewer.createEmptyNodeDescriptor('left', 'global', 1),
						app.viewer.createEmptyNodeDescriptor('back', 'global', 1),
						app.viewer.createEmptyNodeDescriptor('right', 'global', 1),
						{
							SKU :                         <string> plinthsComponents.LEDLeft.viewerComponentSKU,
							projectCode :                 <string> plinthsComponents.LEDLeft.viewerProjectCode,
							localId :                     'left-leftPlinth',
							parentLocalId :               'left',
							snappable :                   false,
							fixedPositionSetIds :         null,
							draggable :                   false,
							doNotListAsProductComponent : true,
							matrix :                      app.viewer.mtx(
								[ 0, 0, 0 ],
								[ 0, 0, 0 ],
								0
							)
						},
						{
							SKU :                         <string> plinthsComponents.LEDMiddle.viewerComponentSKU,
							projectCode :                 <string> plinthsComponents.LEDMiddle.viewerProjectCode,
							localId :                     'left-middlePlinth',
							parentLocalId :               'left',
							snappable :                   false,
							fixedPositionSetIds :         null,
							draggable :                   false,
							doNotListAsProductComponent : true,
							matrix :                      app.viewer.mtx(
								[ 0, 0, 0 ],
								[ 0, 0, 0 ],
								0
							)
						},
						{
							SKU :                         <string> plinthsComponents.LEDMiddle.viewerComponentSKU,
							projectCode :                 <string> plinthsComponents.LEDMiddle.viewerProjectCode,
							localId :                     'left-rightPlinth',
							parentLocalId :               'left',
							snappable :                   false,
							fixedPositionSetIds :         null,
							draggable :                   false,
							doNotListAsProductComponent : true,
							matrix :                      app.viewer.mtx(
								[ 0, 0, 0 ],
								[ 0, 0, 0 ],
								0
							)
						},
						{
							SKU :                         <string> plinthsComponents.LEDLeft.viewerComponentSKU,
							projectCode :                 <string> plinthsComponents.LEDLeft.viewerProjectCode,
							localId :                     'back-leftPlinthClosed',
							parentLocalId :               'back',
							snappable :                   false,
							fixedPositionSetIds :         null,
							draggable :                   false,
							doNotListAsProductComponent : true,
							matrix :                      app.viewer.mtx(
								[ 0, 0, 0 ],
								[ 0, 0, 0 ],
								0
							)
						},
						{
							SKU :                         <string> plinthsComponents.LEDMiddle.viewerComponentSKU,
							projectCode :                 <string> plinthsComponents.LEDMiddle.viewerProjectCode,
							localId :                     'back-leftPlinthOpened',
							parentLocalId :               'back',
							snappable :                   false,
							fixedPositionSetIds :         null,
							draggable :                   false,
							doNotListAsProductComponent : true,
							matrix :                      app.viewer.mtx(
								[ 0, 0, 0 ],
								[ 0, 0, 0 ],
								0
							)
						},
						{
							SKU :                         <string> plinthsComponents.LEDMiddle.viewerComponentSKU,
							projectCode :                 <string> plinthsComponents.LEDMiddle.viewerProjectCode,
							localId :                     'back-middlePlinth',
							parentLocalId :               'back',
							snappable :                   false,
							fixedPositionSetIds :         null,
							draggable :                   false,
							doNotListAsProductComponent : true,
							matrix :                      app.viewer.mtx(
								[ 0, 0, 0 ],
								[ 0, 0, 0 ],
								0
							)
						},
						{
							SKU :                         <string> plinthsComponents.LEDCorner.viewerComponentSKU,
							projectCode :                 <string> plinthsComponents.LEDCorner.viewerProjectCode,
							localId :                     'back-cornerLeftPlinth',
							parentLocalId :               'back',
							snappable :                   false,
							fixedPositionSetIds :         null,
							draggable :                   false,
							doNotListAsProductComponent : true,
							matrix :                      app.viewer.mtx(
								[ 0, 0, 0 ],
								[ 0, 0, 0 ],
								0
							)
						},
						{
							SKU :                         <string> plinthsComponents.LEDCorner.viewerComponentSKU,
							projectCode :                 <string> plinthsComponents.LEDCorner.viewerProjectCode,
							localId :                     'back-cornerRightPlinth',
							parentLocalId :               'back',
							snappable :                   false,
							fixedPositionSetIds :         null,
							draggable :                   false,
							doNotListAsProductComponent : true,
							matrix :                      app.viewer.mtx(
								[ 0, 0, 0 ],
								[ 0, 0, 0 ],
								0
							)
						},
						{
							SKU :                         <string> plinthsComponents.LEDRight.viewerComponentSKU,
							projectCode :                 <string> plinthsComponents.LEDRight.viewerProjectCode,
							localId :                     'back-rightPlinthClosed',
							parentLocalId :               'back',
							snappable :                   false,
							fixedPositionSetIds :         null,
							draggable :                   false,
							doNotListAsProductComponent : true,
							matrix :                      app.viewer.mtx(
								[ 0, 0, 0 ],
								[ 0, 0, 0 ],
								0
							)
						},
						{
							SKU :                         <string> plinthsComponents.LEDMiddle.viewerComponentSKU,
							projectCode :                 <string> plinthsComponents.LEDMiddle.viewerProjectCode,
							localId :                     'back-rightPlinthOpened',
							parentLocalId :               'back',
							snappable :                   false,
							fixedPositionSetIds :         null,
							draggable :                   false,
							doNotListAsProductComponent : true,
							matrix :                      app.viewer.mtx(
								[ 0, 0, 0 ],
								[ 0, 0, 0 ],
								0
							)
						},
						{
							SKU :                         <string> plinthsComponents.LEDMiddle.viewerComponentSKU,
							projectCode :                 <string> plinthsComponents.LEDMiddle.viewerProjectCode,
							localId :                     'right-leftPlinth',
							parentLocalId :               'right',
							snappable :                   false,
							fixedPositionSetIds :         null,
							draggable :                   false,
							doNotListAsProductComponent : true,
							matrix :                      app.viewer.mtx(
								[ 0, 0, 0 ],
								[ 0, 0, 0 ],
								0
							)
						},
						{
							SKU :                         <string> plinthsComponents.LEDMiddle.viewerComponentSKU,
							projectCode :                 <string> plinthsComponents.LEDMiddle.viewerProjectCode,
							localId :                     'right-middlePlinth',
							parentLocalId :               'right',
							snappable :                   false,
							fixedPositionSetIds :         null,
							draggable :                   false,
							doNotListAsProductComponent : true,
							matrix :                      app.viewer.mtx(
								[ 0, 0, 0 ],
								[ 0, 0, 0 ],
								0
							)
						},
						{
							SKU :                         <string> plinthsComponents.LEDRight.viewerComponentSKU,
							projectCode :                 <string> plinthsComponents.LEDRight.viewerProjectCode,
							localId :                     'right-rightPlinth',
							parentLocalId :               'right',
							snappable :                   false,
							fixedPositionSetIds :         null,
							draggable :                   false,
							doNotListAsProductComponent : true,
							matrix :                      app.viewer.mtx(
								[ 0, 0, 0 ],
								[ 0, 0, 0 ],
								0
							)
						}
					]
				});
			} else {
				this.component_throwUserError('Unknown SKU name');
			}
		}
		(<any> this).plannerCategory = app.viewer.createCategory(categoryDescriptor);
	}

	constructor(
		descriptor : ConstructorParameters<typeof CM.Component>[0],
		configuration : IStandingPlinthComponentConfiguration
	)
	{
		super(descriptor, configuration);
	};
};
export namespace NS {
	export const Component = StandingPlinthComponent;
	export type Component = StandingPlinthComponent;
	export type Configuration = IStandingPlinthComponentConfiguration;
}
CM.declare({
	id :   'standing-plinth',
	type : StandingPlinthComponent
});
